/**
 * Wizard 2 Step Handler
 * Extends StepHandler for wizard-4 flow: quiz → plan_overview → profile
 */
(function() {
  if (typeof StepHandler === 'undefined') {
    console.error('wizard-steps requires wizard-1-steps.js');
    return;
  }

  const BOWL_URLS = {
    trial: {
      full: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/full_filling_bowl.gif?v=1775629275',
      half: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/half_filling_bowl.gif?v=1775629283'
    },
    plan: {
      full: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/filled_bowl.webp?v=1773925349',
      half: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/half_filled_bowl.webp?v=1773925349'
    }
  };

  const FLAVOR_TO_INSTANT = { rund: 'beef', kip: 'chicken', vis: 'fish' };

  /** Shopify product option names for bowl size (Dutch "Kom", English "Bowl") */
  const BOWL_OPTION_NAMES = ['kom', 'bowl'];

  class StepHandlerWizard extends StepHandler {
    getProfileSaveRedirectStep() {
      return 'plan_overview';
    }

    getPortalHandoffCookieDomain() {
      const host = window.location.hostname || '';
      if (host === 'bluezonepets.com' || host.endsWith('.bluezonepets.com')) {
        return '.bluezonepets.com';
      }
      return '';
    }

    buildPortalPetHandoffPatch(state) {
      const s = state || this.flow.state;
      const petData = s.getPetData();
      const calc = typeof s.getCalculations === 'function' ? s.getCalculations() : (s.calculations || {});
      const dailyFoodG = calc.dailyFoodG != null ? calc.dailyFoodG : petData.dailyFoodG;
      const dailyKcal = calc.dailyKcal != null ? calc.dailyKcal : petData.dailyKcal;
      const currentDailyFoodG = dailyFoodG;

      return {
        name: petData.name || '',
        gender: petData.gender || 'male',
        breed: petData.breed || '',
        weight: petData.weight != null ? petData.weight : null,
        composition: petData.composition || '',
        ageGroup: petData.ageGroup || '',
        spayed: petData.spayed === true,
        activity: petData.activity || '',
        snacks: petData.snacks || '',
        allergies: Array.isArray(petData.allergies) ? petData.allergies : [],
        photoUrl: petData.profilePhotoUrl || '',
        dailyKcal: dailyKcal != null && !Number.isNaN(Number(dailyKcal)) ? Number(dailyKcal) : null,
        dailyFoodG: dailyFoodG != null && !Number.isNaN(Number(dailyFoodG)) ? Number(dailyFoodG) : null,
        currentDailyFoodG: currentDailyFoodG != null && !Number.isNaN(Number(currentDailyFoodG)) ? Number(currentDailyFoodG) : null,
      };
    }

    publishPortalPetHandoff(extra) {
      const state = this.flow.state;
      const metaobjectId = (extra && extra.id) || state.petMetaobjectId;
      if (!metaobjectId) return;

      const payload = {
        v: 1,
        ts: Date.now(),
        id: metaobjectId,
        deleted: !!(extra && extra.deleted),
      };
      if (!payload.deleted) {
        payload.patch = this.buildPortalPetHandoffPatch(state);
      }

      try {
        const json = JSON.stringify(payload);
        if (json.length > 3500) return;
        const domain = this.getPortalHandoffCookieDomain();
        let cookie = 'bzPetProfileUpdate=' + encodeURIComponent(json) + '; path=/; max-age=120; SameSite=Lax';
        if (window.location.protocol === 'https:') cookie += '; Secure';
        if (domain) cookie += '; domain=' + domain;
        document.cookie = cookie;
      } catch (e) {}
    }

    readPortalPetHandoffCookie() {
      try {
        const name = 'bzPetProfileUpdate=';
        const parts = document.cookie.split(';');
        for (let i = 0; i < parts.length; i++) {
          const part = parts[i].trim();
          if (part.indexOf(name) === 0) {
            return JSON.parse(decodeURIComponent(part.slice(name.length)));
          }
        }
      } catch (e) {}
      return null;
    }

    petHandoffMatchesId(handoffId, petId) {
      const norm = (id) => {
        const s = String(id || '').trim();
        const m = s.match(/(\d+)$/);
        return m ? m[1] : s;
      };
      return norm(handoffId) === norm(petId);
    }

    applyPortalPetHandoffPatch(patch) {
      if (!patch) return;
      const updates = {
        name: patch.name,
        gender: patch.gender,
        breed: patch.breed,
        weight: patch.weight,
        composition: patch.composition,
        ageGroup: patch.ageGroup,
        spayed: patch.spayed,
        activity: patch.activity,
        snacks: patch.snacks,
        allergies: patch.allergies,
        profilePhotoUrl: patch.photoUrl,
      };
      Object.keys(updates).forEach((key) => {
        if (updates[key] === undefined) delete updates[key];
      });
      if (Object.keys(updates).length) {
        this.flow.state.updatePetDataBatch(updates);
      }

      const calcUpdates = {};
      if (patch.dailyKcal != null) calcUpdates.dailyKcal = patch.dailyKcal;
      if (patch.dailyFoodG != null) calcUpdates.dailyFoodG = patch.dailyFoodG;
      if (Object.keys(calcUpdates).length) {
        this.flow.state.updateCalculations(calcUpdates);
      }
    }

    /**
     * Storefront reads can lag behind saves; last handoff cookie wins over API data.
     */
    async loadProfileData(metaobjectId) {
      await super.loadProfileData(metaobjectId);
      const handoff = this.readPortalPetHandoffCookie();
      if (!handoff || handoff.deleted || !handoff.patch || !handoff.id) return;
      if (!this.petHandoffMatchesId(handoff.id, metaobjectId)) return;
      this.applyPortalPetHandoffPatch(handoff.patch);
    }

    /**
     * After save: portal edit → customer portal dogs page; otherwise history.back / plan overview.
     */
    redirectAfterProfileSave() {
      this.publishPortalPetHandoff();
      if (this.isPortalProfileEdit()) {
        this.navigateToPortalDogs(this.flow.state.petMetaobjectId);
        return;
      }
      if (window.BzWizard && window.BzWizard.id() === 'w3' && window.WizardPlan) {
        this._runWizardCartAndCheckout({ mode: 'checkout' });
        return;
      }
      if (window.history.length > 1) {
        window.history.back();
        return;
      }
      const petId = this.flow.state.petMetaobjectId;
      if (petId) {
        this.flow.router.navigate('plan_overview', {}, false, { pet: petId });
      } else {
        this.flow.router.navigate('plan_overview');
      }
    }

    static PROFILE_ORIGIN_KEY = 'bz_wizard_profile_origin';
    static PORTAL_ACCOUNT_ORIGIN = 'https://account.bluezonepets.com';

    isFromPortalQueryParam(params) {
      if (params && params.from === 'portal') return true;
      try {
        return new URLSearchParams(window.location.search).get('from') === 'portal';
      } catch (e) {
        return false;
      }
    }

    /**
     * True when this profile visit was opened via portal edit (?from=portal).
     * Uses sessionStorage so chrome/redirect keep working if the query param is dropped.
     */
    isPortalProfileEdit(params) {
      if (this.isFromPortalQueryParam(params)) return true;
      try {
        return sessionStorage.getItem(StepHandlerWizard.PROFILE_ORIGIN_KEY) === 'portal';
      } catch (e) {
        return false;
      }
    }

    isProfileOpenedFromPortal() {
      if (this.isPortalProfileEdit()) return true;
      const ref = document.referrer || '';
      return /account\.bluezonepets\.com/i.test(ref);
    }

    markProfileOrigin(origin) {
      try {
        sessionStorage.setItem(StepHandlerWizard.PROFILE_ORIGIN_KEY, origin);
      } catch (e) {}
    }

    clearProfileOrigin() {
      try {
        sessionStorage.removeItem(StepHandlerWizard.PROFILE_ORIGIN_KEY);
      } catch (e) {}
    }

    numericIdFromPetGid(petMetaobjectId) {
      const m = String(petMetaobjectId || '').trim().match(/(\d+)$/);
      return m ? m[1] : '';
    }

    getPortalLocale() {
      const loc = String(window.__wizardCurrentLocale || window.__wizard1CurrentLocale || 'nl');
      return (loc.split('-')[0] || 'nl').toLowerCase();
    }

    /**
     * @param {string} [petMetaobjectId]
     * @param {{ omitPet?: boolean }} [opts]
     */
    getPortalDogsReturnUrl(petMetaobjectId, opts) {
      const locale = this.getPortalLocale();
      let hash = '#dogs';
      if (!(opts && opts.omitPet)) {
        const numericId = this.numericIdFromPetGid(petMetaobjectId);
        if (numericId) hash += '?pet=' + encodeURIComponent(numericId);
      }
      return StepHandlerWizard.PORTAL_ACCOUNT_ORIGIN + '/' + locale + '/self-service' + hash;
    }

    navigateToPortalDogs(petMetaobjectId, opts) {
      window.location.assign(this.getPortalDogsReturnUrl(petMetaobjectId, opts));
    }

    /**
     * Hide offer bar, progress bar, and cart when editing a dog from the customer portal.
     * Does not hide logo/back header.
     */
    setPortalProfileChrome(active) {
      const quizContainer = document.querySelector('[data-quiz-container]');
      if (!quizContainer) return;
      quizContainer.classList.toggle('portal-profile-edit', !!active);
    }

    /**
     * Instant "get-started" section → [data-get-started-slot]. Shown only on get_started.
     * Instant root should use class `data-get-started-section` (same pattern as plan overview).
     */
    ensureGetStartedShopifySectionInSlotVisible() {
      const slot = document.querySelector('[data-get-started-slot]');
      document.querySelectorAll('[data-get-started-section], .data-get-started-section').forEach((el) => {
        const sectionWrapper = el.closest('.shopify-section');
        if (sectionWrapper && slot && !slot.contains(sectionWrapper)) {
          slot.appendChild(sectionWrapper);
        }
      });
      if (slot) slot.style.display = '';
      document.querySelector('[data-quiz-container]')?.classList.add('get-started-step-active');
    }

    hideGetStartedShopifySectionSlot() {
      const slot = document.querySelector('[data-get-started-slot]');
      if (slot) slot.style.display = 'none';
      document.querySelector('[data-quiz-container]')?.classList.remove('get-started-step-active');
    }

    /**
     * Instant "plan-overview-section-w3" → [data-plan-overview-w3-slot].
     * Instant root uses class `data-plan-overview-section-w3`. Wizard 3 plan overview only.
     */
    ensureW3PlanOverviewShopifySectionInSlotVisible() {
      const slot = document.querySelector('[data-plan-overview-w3-slot]');
      document.querySelectorAll('[data-plan-overview-section-w3], .data-plan-overview-section-w3').forEach((el) => {
        const sectionWrapper = el.closest('.shopify-section');
        if (sectionWrapper && slot && !slot.contains(sectionWrapper)) {
          slot.appendChild(sectionWrapper);
        }
      });
      if (slot) slot.style.display = '';
    }

    hideW3PlanOverviewShopifySectionSlot() {
      const slot = document.querySelector('[data-plan-overview-w3-slot]');
      if (slot) slot.style.display = 'none';
    }

    returnFromProfileStep() {
      if (this.isPortalProfileEdit()) {
        this.navigateToPortalDogs(this.flow.state.petMetaobjectId);
        return;
      }
      if (window.history.length > 1) {
        window.history.back();
        return;
      }
      const petId = this.flow.state.petMetaobjectId;
      if (petId) {
        this.flow.router.navigate('plan_overview', {}, false, { pet: petId });
      } else {
        this.flow.router.navigate('plan_overview');
      }
    }

    bindPortalAwareProfileHeaderNav() {
      const headerBackButton = document.querySelector('.quiz-header [data-back-button]');
      if (headerBackButton) {
        const newButton = headerBackButton.cloneNode(true);
        headerBackButton.parentNode.replaceChild(newButton, headerBackButton);
        newButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.returnFromProfileStep();
        });
      }

      const logoLink = document.querySelector('.quiz-header .header__heading-link');
      if (logoLink && this.isPortalProfileEdit()) {
        const newLogo = logoLink.cloneNode(true);
        logoLink.parentNode.replaceChild(newLogo, logoLink);
        newLogo.setAttribute('href', this.getPortalDogsReturnUrl(this.flow.state.petMetaobjectId));
        newLogo.addEventListener('click', (e) => {
          e.preventDefault();
          this.returnFromProfileStep();
        });
      }
    }

    async setupProfileStep(params) {
      await super.setupProfileStep(params);
      this.bindPortalAwareProfileHeaderNav();
    }

    /**
     * After delete: portal edit → portal dogs; wizard flow → fresh name step.
     * @param {string} [petMetaobjectId]
     * @param {boolean} [fromPortal]
     */
    redirectAfterProfileDelete(petMetaobjectId, fromPortal) {
      const id = petMetaobjectId || this.flow.state.petMetaobjectId;
      if (fromPortal) {
        if (id) {
          this.publishPortalPetHandoff({ deleted: true, id: id });
        }
        this.navigateToPortalDogs(null, { omitPet: true });
        return;
      }
      if (this.flow.router && typeof this.flow.router.navigateToNameFresh === 'function') {
        this.flow.router.navigateToNameFresh();
      } else {
        this.flow.router.navigate('name');
      }
    }

    /**
     * Wizard 2: unlink pet from customer when linked; mid-quiz drafts only clear local state.
     */
    async deleteProfile() {
      const petMetaobjectId = this.flow.state.petMetaobjectId;
      const customerId = this.flow.state.sessionCustomerId || this.flow.state.customerId || null;
      const fromPortal = this.isPortalProfileEdit();

      try {
        if (petMetaobjectId && customerId) {
          try {
            if (typeof this.flow.shopifyAPI.unlinkPetFromCustomer === 'function') {
              await this.flow.shopifyAPI.unlinkPetFromCustomer(petMetaobjectId, customerId);
            }
          } catch (error) {
            console.error('Error unlinking pet from customer:', error);
          }
        }

        const modal = this.currentStepElement?.querySelector('[data-delete-modal]');
        if (modal) {
          modal.style.display = 'none';
        }

        this.flow.state.reset();
        this.flow.storage.clearLocalStorage();
        this.clearProfileOrigin();

        this.redirectAfterProfileDelete(petMetaobjectId, fromPortal);
      } catch (error) {
        console.error('Error deleting profile:', error);
        const isDutch =
          (typeof window.__wizardCurrentLocale === 'string' &&
            window.__wizardCurrentLocale.toLowerCase().startsWith('nl')) ||
          (document.documentElement.lang || '').toLowerCase().startsWith('nl');
        if (window.bzToast) {
          window.bzToast.show({
            type: 'error',
            message: isDutch
              ? 'Er is een fout opgetreden bij het verwijderen van het profiel.'
              : 'Something went wrong while removing the profile.',
          });
        } else {
          alert(
            isDutch
              ? 'Er is een fout opgetreden bij het verwijderen van het profiel.'
              : 'Something went wrong while removing the profile.'
          );
        }
      }
    }

    /**
     * Resolved checked state for the marketing row (default opted-in until user opts out).
     * Persisted on state + localStorage (`wizard-email-marketing-consent-preference`).
     */
    resolveWizardEmailConsentChecked() {
      const s = this.flow.state;
      if (s.wizardEmailMarketingConsentPreference === true || s.wizardEmailMarketingConsentPreference === false) {
        return s.wizardEmailMarketingConsentPreference;
      }
      try {
        const r = localStorage.getItem('wizard-email-marketing-consent-preference');
        if (r === '1') return true;
        if (r === '0') return false;
      } catch (e) {}
      return true;
    }

    persistWizardEmailMarketingConsentPreference(checked) {
      this.flow.state.wizardEmailMarketingConsentPreference = checked;
      this.flow.updatePetData('emailConsent', checked);
      try {
        localStorage.setItem('wizard-email-marketing-consent-preference', checked ? '1' : '0');
      } catch (e) {}
      try {
        this.flow.storage.saveToLocalStorage(this.flow.state.getState(), this.flow.state.customerId);
      } catch (e) {}
    }

    /**
     * Wizard 2: consent row only when email field has non-whitespace content; skip link only when empty.
     */
    syncWizardEmailConsentVisibility() {
      const emailInput = this.currentStepElement?.querySelector('[name="ownerEmail"]');
      const wrap = this.currentStepElement?.querySelector('[data-wizard-email-consent-wrap]');
      const consent = this.currentStepElement?.querySelector('[data-field="emailConsent"]');
      const skipWrap = this.currentStepElement?.querySelector('[data-wizard-skip-email-wrap]');

      const hasText = !!(emailInput && emailInput.value.trim());

      if (skipWrap) {
        skipWrap.style.display = hasText ? 'none' : '';
      }

      if (!wrap || !consent) return;

      if (hasText) {
        wrap.style.display = '';
        const checked = this.resolveWizardEmailConsentChecked();
        consent.checked = checked;
        this.flow.updatePetData('emailConsent', checked);
      } else {
        wrap.style.display = 'none';
        consent.checked = false;
        this.flow.updatePetData('emailConsent', false);
      }
    }

    /**
     * Persist pet metaobject without creating a Shopify customer (skip email path).
     */
    async handleWizardSkipEmail() {
      const state = this.flow.state;
      const skipBtn = this.currentStepElement?.querySelector('[data-wizard-skip-email]');
      const nextButton = document.querySelector('[data-next-button]');

      const resetUi = () => {
        if (skipBtn) {
          skipBtn.disabled = false;
          skipBtn.classList.remove('is-loading');
          skipBtn.removeAttribute('aria-busy');
        }
        if (nextButton) {
          nextButton.classList.remove('is-loading');
          nextButton.removeAttribute('aria-busy');
        }
        this.updateButtonStates('email');
      };

      if (skipBtn) {
        skipBtn.disabled = true;
        skipBtn.classList.add('is-loading');
        skipBtn.setAttribute('aria-busy', 'true');
      }
      if (nextButton) {
        nextButton.disabled = true;
      }

      try {
        state.skippedEmailWithoutAddress = true;
        state.updatePetData('ownerEmail', '');
        state.updatePetData('emailConsent', false);

        if (this.flow.analytics && typeof this.flow.analytics.trackQuizEmailSkipped === 'function') {
          try {
            this.flow.analytics.trackQuizEmailSkipped();
          } catch (e) {
            console.warn('quiz_email_skipped analytics failed:', e);
          }
        }

        const custId = state.sessionCustomerId || state.customerId || null;

        if (!state.petMetaobjectId && this.flow.shopifyAPI?.backendApiUrl) {
          const result = await this.flow.shopifyAPI.createOrUpdatePetMetaobject({
            petData: this.getPetDataForMetaobject(state),
            calculations: this.getWizardCalculationsForPersistence(state),
            customerId: custId,
            resumeStep: 'calculation',
            selectedFlavors: state.selectedFlavorsFull?.length ? state.selectedFlavorsFull : state.selectedFlavorsTrial,
            selectedFlavorsTrial: state.selectedFlavorsTrial
          });
          if (result?.petMetaobjectId) state.petMetaobjectId = result.petMetaobjectId;
        } else if (state.petMetaobjectId && this.flow.shopifyAPI?.backendApiUrl) {
          await this.flow.shopifyAPI.createOrUpdatePetMetaobject({
            petData: this.getPetDataForMetaobject(state),
            calculations: this.getWizardCalculationsForPersistence(state),
            petMetaobjectId: state.petMetaobjectId,
            customerId: custId,
            resumeStep: 'calculation',
            selectedFlavors: state.selectedFlavorsFull?.length ? state.selectedFlavorsFull : state.selectedFlavorsTrial,
            selectedFlavorsTrial: state.selectedFlavorsTrial
          });
        }

        state._justCreated = true;
        try {
          this.flow.storage.saveToLocalStorage(state.getState(), state.customerId);
        } catch (e) {}

        this.flow.navigateNext();
      } catch (err) {
        console.error('Wizard 2 skip email failed:', err);
        const isNl = (document.documentElement.lang || '').toLowerCase().startsWith('nl');
        if (window.bzToast) {
          window.bzToast.showKey('skip_email_error');
        } else {
          alert(
            isNl
              ? 'Er ging iets mis. Probeer het opnieuw of vul je e-mailadres in.'
              : 'Something went wrong. Please try again or enter your email address.'
          );
        }
        resetUi();
      }
    }

    /**
     * Wizard 2 email step: valid email required for primary CTA; consent follows email field.
     */
    setupEmailValidation() {
      const emailInput = this.currentStepElement?.querySelector('[name="ownerEmail"]');
      const nextButton = document.querySelector('[data-next-button]');

      if (emailInput && nextButton) {
        this.setupMissingDataWarning();
        const missingStep = this.checkMissingRequiredSteps();

        const refresh = () => {
          const v = emailInput.value.trim();
          const emailOk = this.flow.state.isValidEmail(v);
          const hasMissingData = !!this.checkMissingRequiredSteps();
          nextButton.disabled = !emailOk || hasMissingData;
          this.syncWizardEmailConsentVisibility();
          this.setupMissingDataWarning();
        };

        // After renderStep: setupStepListeners runs before restoreFieldValues. Defer first sync so
        // inputs match saved state (refresh/back). One frame is enough (user-approved).
        requestAnimationFrame(() => {
          this.syncWizardEmailConsentVisibility();
          refresh();
        });

        emailInput.addEventListener('input', () => {
          const hasMissingData = !!this.checkMissingRequiredSteps();
          const v = emailInput.value.trim();
          const emailOk = this.flow.state.isValidEmail(v);
          nextButton.disabled = !emailOk || hasMissingData;
          this.syncWizardEmailConsentVisibility();

          const raw = emailInput.value || '';
          const rawTrimmed = raw.trim();
          const isValid = rawTrimmed ? this.flow.state.isValidEmail(raw) : false;
          const message = this.currentStepElement?.querySelector('[data-conditional="email-validation"]');
          if (message) {
            if (!rawTrimmed || isValid) {
              message.style.display = 'none';
            }
          }
          this.checkEmailMatch(emailInput.value);
          this.setupMissingDataWarning();
        });

        const nameInput = this.currentStepElement?.querySelector('[name="ownerName"]');
        if (nameInput) {
          nameInput.addEventListener('input', () => {
            refresh();
          });
        }

        const skipBtn = this.currentStepElement?.querySelector('[data-wizard-skip-email]');
        if (skipBtn && !skipBtn.dataset.boundWizardSkip) {
          skipBtn.dataset.boundWizardSkip = '1';
          skipBtn.addEventListener('click', e => {
            e.preventDefault();
            void this.handleWizardSkipEmail();
          });
        }

        const consentEl = this.currentStepElement?.querySelector('[data-field="emailConsent"]');
        if (consentEl && !consentEl.dataset.wizardConsentBound) {
          consentEl.dataset.wizardConsentBound = '1';
          consentEl.addEventListener('change', () => {
            this.persistWizardEmailMarketingConsentPreference(consentEl.checked);
          });
        }
      }
    }

    /**
     * Wizard 2: same customer/pet creation as Wizard 1, but clears skip-email flag on submit.
     */
    setupCustomerCreation() {
      if (this.flow.state.getCurrentStep() !== 'email') {
        return;
      }

      const nextButton = document.querySelector('[data-next-button]');
      if (!nextButton) return;

      if (nextButton.dataset.customerCreationHandler === 'true') {
        return;
      }
      nextButton.dataset.customerCreationHandler = 'true';

      nextButton.addEventListener(
        'click',
        async e => {
          if (this.flow.state.getCurrentStep() !== 'email') {
            return;
          }

          const petData = this.flow.state.getPetData();
          const emailInput = this.currentStepElement?.querySelector('[name="ownerEmail"]');
          const emailValue = emailInput ? emailInput.value.trim() : petData.ownerEmail || '';
          const isValidEmail = this.flow.state.isValidEmail(emailValue);

          if (!isValidEmail) {
            const message = this.currentStepElement?.querySelector('[data-conditional="email-validation"]');
            if (message) {
              message.style.display = emailValue ? 'flex' : 'none';
            }
            return;
          }

          this.flow.state.skippedEmailWithoutAddress = false;

          const labelEl = nextButton.querySelector('.next-button-label') || nextButton;
          const originalLabel = labelEl.textContent;

          const resetEmailLoadingState = () => {
            nextButton.disabled = false;
            nextButton.classList.remove('is-loading');
            nextButton.removeAttribute('aria-busy');
            labelEl.textContent = originalLabel;
          };

          const applyEmailLoadingState = () => {
            nextButton.disabled = true;
            nextButton.classList.add('is-loading');
            nextButton.setAttribute('aria-busy', 'true');
          };

          const alreadyHasCustomerAndPet =
            !!(this.flow.state.customerId && this.flow.state.petMetaobjectId);

          // Even when customer+pet already exist, still sync the pet→customer link.
          // Name-step pets are often created without customerId; skipping here left
          // pets with empty customer / custom.pets (portal dogs tab missing).
          if (alreadyHasCustomerAndPet) {
            e.stopPropagation();
            e.stopImmediatePropagation();

            if (nextButton.disabled) {
              return;
            }

            applyEmailLoadingState();

            try {
              const calculations = this.getWizardCalculationsForPersistence(this.flow.state);
              const customerIdToUse =
                this.flow.state.sessionCustomerId || this.flow.state.customerId || null;
              try {
                const syncResult = await this.flow.shopifyAPI.createCustomerViaBackend(
                  {
                    ownerName: petData.ownerName,
                    ownerEmail: petData.ownerEmail,
                    emailConsent: petData.emailConsent
                  },
                  petData,
                  calculations,
                  this.flow.state.petMetaobjectId,
                  customerIdToUse
                );
                if (syncResult?.customerId) {
                  this.flow.state.customerId = syncResult.customerId;
                  this.flow.state.sessionCustomerId = syncResult.customerId;
                }
              } catch (syncErr) {
                console.warn('Email step pet-customer sync failed (continuing):', syncErr);
              }

              if (this.flow.analytics && typeof this.flow.analytics.trackFacebookLead === 'function') {
                try {
                  this.flow.analytics.trackFacebookLead({
                    pet_name: petData.name
                  });
                  await new Promise(resolve => setTimeout(resolve, 200));
                } catch (err) {
                  console.warn('Facebook Lead event tracking failed:', err);
                }
              }

              if (this.flow.klaviyoManager && petData.ownerEmail) {
                if (!this.flow.klaviyoManager.hasPendingEvent(petData.ownerEmail)) {
                  try {
                    await this.flow.klaviyoManager.sendPetUpdatedEvent(
                      petData,
                      {
                        ownerEmail: petData.ownerEmail,
                        ownerName: petData.ownerName || ''
                      },
                      this.flow.state.petMetaobjectId
                    );
                  } catch (err) {
                    console.warn('Failed to send Klaviyo "Pet updated" event (non-blocking):', err);
                  }
                }
              }

              this.flow.state.sessionOwnerName = petData.ownerName;
              this.flow.state.sessionOwnerEmail = petData.ownerEmail;
              this.flow.state.sessionEmailConsent = petData.emailConsent !== undefined ? petData.emailConsent : true;

              nextButton.disabled = false;
              nextButton.classList.remove('is-loading');
              nextButton.removeAttribute('aria-busy');

              this.flow.navigateNext();
            } catch (error) {
              console.error('Error in email step (skip-create path):', error);
              resetEmailLoadingState();
            }
            return;
          }

          e.stopPropagation();
          e.stopImmediatePropagation();

          if (nextButton.disabled) {
            return;
          }

          applyEmailLoadingState();

          try {
            if (
              !petData ||
              typeof petData !== 'object' ||
              Object.keys(petData).length === 0 ||
              !petData.name ||
              typeof petData.name !== 'string' ||
              petData.name.trim().length === 0
            ) {
              console.error('petData is invalid:', petData);
              if (window.bzToast) window.bzToast.showKey('invalid_pet_data');
              else alert('Er is een fout opgetreden. Probeer de pagina te vernieuwen.');
              resetEmailLoadingState();
              return;
            }

            const customerData = {
              ownerName: petData.ownerName,
              ownerEmail: petData.ownerEmail,
              emailConsent: petData.emailConsent
            };

            const calculations = this.getWizardCalculationsForPersistence(this.flow.state);

            let loggedInCustomerId = null;
            try {
              await this.flow.detectLoggedInCustomer();
              loggedInCustomerId = this.flow.state.customerId || null;
            } catch (err) {}

            const customerIdForCheck = this.flow.state.sessionCustomerId || loggedInCustomerId;
            if (customerIdForCheck) {
              const existingPet = await this.flow.storage.petNameExists(petData.name, {
                flow: this.flow,
                customerId: customerIdForCheck
              });

              if (existingPet && existingPet.metaobjectId) {
                this.showDuplicatePetNameMessage(petData.name, existingPet);
              }
            }

            const isNewPet = !this.flow.state.petMetaobjectId;
            const customerIdToUse = this.flow.state.sessionCustomerId || loggedInCustomerId;

            const result = await this.flow.shopifyAPI.createCustomerViaBackend(
              customerData,
              petData,
              calculations,
              this.flow.state.petMetaobjectId,
              customerIdToUse
            );

            if (result.customerId) {
              this.flow.state.customerId = result.customerId;
              this.flow.state.sessionCustomerId = result.customerId;
            }

            if (result.petMetaobjectId) {
              this.flow.state.petMetaobjectId = result.petMetaobjectId;
            }

            this.flow.state.sessionOwnerName = petData.ownerName;
            this.flow.state.sessionOwnerEmail = petData.ownerEmail;
            this.flow.state.sessionEmailConsent = petData.emailConsent !== undefined ? petData.emailConsent : true;

            this.flow.storage.saveToLocalStorage(this.flow.state.getState(), this.flow.state.customerId);

            this.flow.state._justCreated = true;

            const backendApiUrl =
              window.__wizard1BackendApiUrl ||
              window.__wizardBackendApiUrl ||
              this.flow?.klaviyoManager?.backendApiUrl ||
              null;

            if (window.KlaviyoEventManager && backendApiUrl) {
              try {
                if (!this.flow.klaviyoManager) {
                  if (typeof KlaviyoEventManagerWizard !== 'undefined') {
                    this.flow.klaviyoManager = new KlaviyoEventManagerWizard(backendApiUrl, this.flow.config);
                  } else {
                    this.flow.klaviyoManager = new KlaviyoEventManager(backendApiUrl, this.flow.config);
                  }
                }

                this.flow.klaviyoManager.scheduleKlaviyoEvent(
                  petData,
                  customerData,
                  result.petMetaobjectId,
                  isNewPet
                );
              } catch (err) {
                console.warn('Failed to schedule Klaviyo event (non-blocking):', err);
              }
            }

            if (this.flow.analytics && typeof this.flow.analytics.trackFacebookLead === 'function') {
              try {
                this.flow.analytics.trackFacebookLead({
                  pet_name: petData.name
                });
                await new Promise(resolve => setTimeout(resolve, 200));
              } catch (err) {
                console.warn('Facebook Lead event tracking failed:', err);
              }
            }

            nextButton.disabled = false;
            nextButton.classList.remove('is-loading');
            nextButton.removeAttribute('aria-busy');

            this.flow.navigateNext();
          } catch (error) {
            console.error('Error creating customer:', error.message);

            const isEmailExistsError =
              error.message &&
              (error.message.includes('already exists') ||
                error.message.includes('already registered') ||
                error.message.includes('email address is already') ||
                error.message.includes('customer_email_exists'));

            if (isEmailExistsError) {
              this.showEmailExistsError();
            } else {
              if (window.bzToast) window.bzToast.showKey('account_creation_error');
              else alert(
                'Er is een fout opgetreden bij het aanmaken van je account. Probeer het opnieuw.'
              );
            }

            resetEmailLoadingState();
          }
        },
        { once: false }
      );
    }

    /**
     * Resolve order + shipping discount codes (creator OR default; never both).
     * Same rules as URL flow previously used; codes are applied to the cart via applyWizardCartDiscountCodes.
     */
    localizedDiscount(enCode, nlCode) {
      if (window.BzWizard && window.BzWizard.discountCode) {
        return window.BzWizard.discountCode(enCode, nlCode);
      }
      return String(enCode || nlCode || '').trim();
    }

    getWizardCartDiscountCodes() {
      if (window.BzWizard && window.BzWizard.id() === 'w3') {
        const pricing = window.BzWizard.current().pricing || {};
        const gift = this.flow?.state?.extrasOn?.w3 && window.BzWizard.giftCode
          ? window.BzWizard.giftCode('w3')
          : '';
        const sample = window.WizardW3 && window.WizardW3.hasSamples(this.flow?.state) && window.BzWizard.sampleCode
          ? window.BzWizard.sampleCode('w3')
          : '';
        const order = [
          this.localizedDiscount(pricing.order_discount_code, pricing.order_discount_code_nl),
          gift,
          sample
        ].filter(Boolean).join(',');
        return {
          orderDiscount: order,
          shippingDiscount: this.localizedDiscount(pricing.shipping_discount_code, pricing.shipping_discount_code_nl)
        };
      }
      if (window.BzWizard && window.BzWizard.id() === 'w5' && window.WizardW5) {
        const ship = this.getWizardShippingMoneyForCountry();
        return window.WizardW5.discountCodes(this.flow.state, ship, this);
      }
      const cfg = window.__wizardCheckoutDiscountCodes || {
        defaultOrderDiscount: '25OFF-W4',
        defaultOrderDiscountNl: '25KORTING-W4',
        largeOrderDiscount: '35OFF-W4',
        largeOrderDiscountNl: '35KORTING-W4',
        shipping: 'FREESHIPPING-W4',
        shippingNl: 'GRATISVERZENDING-W4',
        storageKey: 'wizard_creator_product_discount'
      };
      const pricing = window.BzWizard && window.BzWizard.current ? (window.BzWizard.current().pricing || {}) : {};
      let creator = '';
      try {
        creator = (sessionStorage.getItem(cfg.storageKey) || '').trim();
      } catch (e) {}
      if (window.WizardHousehold && window.WizardHousehold.releaseLargeDogOfferIfLight) {
        window.WizardHousehold.releaseLargeDogOfferIfLight(this);
      }
      const large = this.flow?.state?.largeDogOffer === 'accept' && this.flow.state.combinedWeightKg() >= 30;
      const orderBase = creator
        ? creator.trim()
        : this.localizedDiscount(
          large ? (pricing.order_discount_code_large || cfg.largeOrderDiscount) : (pricing.order_discount_code || cfg.defaultOrderDiscount),
          large ? (pricing.order_discount_code_large_nl || cfg.largeOrderDiscountNl) : (pricing.order_discount_code_nl || cfg.defaultOrderDiscountNl)
        );
      const giftCode = window.WizardPlan && window.WizardPlan.giftDiscountCode
        ? window.WizardPlan.giftDiscountCode(this.flow?.state)
        : '';
      const sample = window.BzWizard && window.BzWizard.sampleCode ? window.BzWizard.sampleCode('w4') : '';
      const orderDiscount = [orderBase, giftCode, sample].filter(Boolean).join(',');
      return {
        orderDiscount,
        shippingDiscount: this.localizedDiscount(
          pricing.shipping_discount_code || cfg.shipping,
          pricing.shipping_discount_code_nl || cfg.shippingNl
        )
      };
    }

    /**
     * Apply TRANSITION or creator + TRANSITIONSHIPPING to the Ajax cart (must run after add to cart, before checkout).
     * Comma-separated single `discount` field matches prior checkout URL behavior.
     */
    async applyWizardCartDiscountCodes() {
      if (window.BzWizard && window.BzWizard.id() === 'w5') {
        await this.ensureWizardShippingRatesLoaded();
      }
      const { orderDiscount, shippingDiscount } = this.getWizardCartDiscountCodes();
      const discount = [orderDiscount, shippingDiscount].filter(Boolean).join(',');
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ discount })
      });
      if (!response.ok) {
        const text = await response.text();
        let detail = response.statusText || `HTTP ${response.status}`;
        try {
          const errJson = JSON.parse(text);
          if (errJson.description) detail = errJson.description;
          else if (errJson.message) detail = errJson.message;
        } catch (parseErr) {
          if (text && text.length < 500) detail = text;
        }
        const err = new Error(detail);
        err.status = response.status;
        throw err;
      }
      return response.json();
    }

    async renderStep(step, params = {}) {
      if (step !== 'issues' && window.bzToast && window.bzToast.dismissStackedPrefix) {
        window.bzToast.dismissStackedPrefix('issue:');
      }
      if (step !== 'plan_onetime' && window.WizardOnetimePage) {
        window.WizardOnetimePage.leave();
      }
      if (step === 'plan_onetime') {
        document.querySelector('[data-quiz-container]')?.classList.add('onetime-step-active');
        document.body.classList.add('wizard-onetime-page');
      }

      const quizContainer = document.querySelector('[data-quiz-container]');
      quizContainer?.classList.toggle('get-started-step-active', step === 'get_started');
      quizContainer?.classList.toggle('lifetime-offer-step-active', step === 'lifetime_offer');
      const getStartedOn = this.flow.router && this.flow.router.getStartedEnabled && this.flow.router.getStartedEnabled();
      const prevStep = this.flow.router && this.flow.router.previousRoutedStep(step);
      const noBack = step === 'get_started' || step === 'lifetime_offer' || (!prevStep && !getStartedOn);
      quizContainer?.classList.toggle('wizard-no-back', !!noBack);
      if (step !== 'lifetime_offer' && window.WizardW5) window.WizardW5.leaveSticky();
      if (step === 'get_started') {
        this.ensureGetStartedShopifySectionInSlotVisible();
      } else {
        this.hideGetStartedShopifySectionSlot();
      }
      if (step === 'plan_overview' && window.BzWizard && window.BzWizard.id() === 'w3') {
        this.ensureW3PlanOverviewShopifySectionInSlotVisible();
      } else {
        this.hideW3PlanOverviewShopifySectionSlot();
      }

      const result = await super.renderStep(step, params);

      if (step === 'get_started') {
        const nextBtn = document.querySelector('[data-next-button]');
        if (nextBtn) nextBtn.disabled = false;
        if (typeof window.bzSyncHeadingAccents === 'function') {
          try { window.bzSyncHeadingAccents(); } catch (e) {}
        }
      }
      return result;
    }

    async loadStepTemplates() {
      const steps = [
        'get-started',
        'name', 'spayed', 'age', 'breed', 'food', 'eating', 'weight', 'composition',
        'activity', 'allergies', 'issues', 'snacks', 'email', 'calculation',
        'plan-overview', 'flavors', 'extras', 'plan-onetime', 'profile',
        'lifetime-offer', 'box-size'
      ];
      steps.forEach(step => {
        const templateId = `wizard-step-${step}`;
        const template = document.getElementById(templateId);
        if (template) {
          const key = step === 'plan-overview' ? 'plan_overview'
            : step === 'plan-onetime' ? 'plan_onetime'
            : step === 'get-started' ? 'get_started'
            : step === 'lifetime-offer' ? 'lifetime_offer'
            : step === 'box-size' ? 'box_size'
            : step;
          this.stepTemplates[key] = template.innerHTML;
        }
      });
    }

    async setupStepListeners(step, params = {}) {
      if (step === 'profile') {
        try {
          if (this.isFromPortalQueryParam(params)) {
            this.markProfileOrigin('portal');
          } else if (!sessionStorage.getItem(StepHandlerWizard.PROFILE_ORIGIN_KEY)) {
            const ref = document.referrer || '';
            if (!/account\.bluezonepets\.com/i.test(ref)) {
              this.markProfileOrigin('wizard');
            }
          }
        } catch (e) {}
        this.setPortalProfileChrome(this.isPortalProfileEdit(params));
      } else {
        this.setPortalProfileChrome(false);
      }

      if (step === 'lifetime_offer' || step === 'box_size') {
        if (window.WizardW5) window.WizardW5.mount(this, step);
        return;
      }

      if (step === 'flavors' || step === 'plan_overview' || step === 'extras') {
        if (window.WizardOnetimePage) window.WizardOnetimePage.leave();
        if (step === 'flavors' || step === 'extras') this.setupInstantFlavorModalListeners();
        if (window.WizardPlan) window.WizardPlan.mount(this, step);
        return;
      }

      if (step === 'plan_onetime') {
        this.setupInstantFlavorModalListeners();
        if (window.WizardOnetimePage) {
          await window.WizardOnetimePage.enter(this);
        }
        return;
      }

      if (window.WizardOnetimePage) window.WizardOnetimePage.leave();

      await super.setupStepListeners(step, params);
    }

    resetFooter(step) {
      super.resetFooter();
      const cur = step || this.flow?.state?.getCurrentStep?.();
      const nextLabel = document.querySelector('[data-next-button] .next-button-label');
      if (nextLabel) {
        if (window.BzWizard && window.BzWizard.id() === 'w3' && cur === 'plan_overview' && window.WizardW3 && window.WizardW3.planButtonLabel) {
          nextLabel.textContent = window.WizardW3.planButtonLabel(this.flow.state);
        } else if (window.BzWizard && window.BzWizard.id() === 'w3' && cur === 'profile') {
          nextLabel.textContent = window.__wizard3Copy?.checkout || 'Afrekenen';
        } else if (window.BzWizard && window.BzWizard.id() === 'w3' && cur === 'extras') {
          nextLabel.textContent = window.__wizard3Copy?.add || 'Voeg toe aan plan';
        } else if (cur === 'box_size' && window.BzWizard && window.BzWizard.id() === 'w5') {
          nextLabel.textContent = this.getLocaleString?.('quiz.wizard_5.buttons.flavors') || 'Kies smaken';
        } else if (cur === 'flavors' && window.BzWizard && window.BzWizard.id() === 'w5') {
          nextLabel.textContent = this.getLocaleString?.('quiz.wizard_5.buttons.checkout') || 'Afrekenen';
        } else if (cur === 'plan_overview' || cur === 'extras') {
          nextLabel.textContent = this.getLocaleString?.('quiz.buttons.next') || 'Continue';
        } else if (cur === 'plan_onetime') {
          nextLabel.textContent =
            this.getLocaleString?.('quiz.steps.plan_overview.onetime_checkout') ||
            (document.documentElement.lang === 'nl' ? 'Afrekenen' : 'Checkout');
        } else {
          nextLabel.textContent = this.getLocaleString?.('quiz.buttons.next') || 'Continue';
        }
      }
      if (cur === 'plan_overview') {
        const planFooter = document.querySelector('[data-plan-price-footer]');
        if (planFooter) {
          planFooter.style.display = '';
          planFooter.querySelectorAll('select').forEach((select) => {
            select.style.display = 'none';
          });
        }
      } else if (cur !== 'plan_onetime' && window.WizardOnetimePage) {
        window.WizardOnetimePage.hideFooterExtras();
      }
    }

    /**
     * After browser back-forward cache restore (e.g. return from Shopify checkout), the DOM can
     * still show is-loading / disabled on the primary CTA. Clear that and re-apply step rules.
     */
    resetNextButtonAfterBfcacheRestore() {
      const nextButton = document.querySelector('[data-next-button]');
      if (nextButton) {
        nextButton.classList.remove('is-loading');
        nextButton.removeAttribute('aria-busy');
      }
      const addDogBtn = document.querySelector('[data-wizard-add-another-dog]');
      if (addDogBtn) {
        addDogBtn.classList.remove('is-loading');
        addDogBtn.removeAttribute('aria-busy');
        addDogBtn.disabled = false;
      }
      const step = this.flow?.router?.getCurrentRoute?.()?.step || this.flow?.state?.getCurrentStep?.();
      if (!step) return;
      this.resetFooter(step);
      this.updateButtonStates(step);
    }

    /**
     * Wizard-2 keeps .next-button-label + spinner + chevron inside the button.
     * Parent StepHandler.updateButtonStates updates .next-button-label only (skips when .is-loading).
     * Plan overview label: checkout trial copy.
     */
    updateButtonStates(step) {
      if (step === 'bulk') {
        return;
      }

      const nextButton = document.querySelector('[data-next-button]');
      if (!nextButton) return;

      const labelEl = nextButton.querySelector('.next-button-label') || nextButton;
      const isLoading = nextButton.classList.contains('is-loading');

      if (step === 'email') {
        labelEl.textContent = this.getLocaleString('quiz.steps.email.button_next');
      } else if (step === 'plan_onetime') {
        labelEl.textContent =
          this.getLocaleString?.('quiz.steps.plan_overview.onetime_checkout') ||
          (document.documentElement.lang === 'nl' ? 'Afrekenen' : 'Checkout');
      } else if (window.BzWizard && window.BzWizard.id() === 'w3' && step === 'plan_overview' && window.WizardW3 && window.WizardW3.planButtonLabel) {
        labelEl.textContent = window.WizardW3.planButtonLabel(this.flow.state);
      } else if (window.BzWizard && window.BzWizard.id() === 'w3' && step === 'profile') {
        labelEl.textContent = window.__wizard3Copy?.checkout || (document.documentElement.lang === 'nl' ? 'Afrekenen' : 'Checkout');
      } else if (window.BzWizard && window.BzWizard.id() === 'w3' && step === 'extras') {
        labelEl.textContent = window.__wizard3Copy?.add || (document.documentElement.lang === 'nl' ? 'Voeg toe aan plan' : 'Add to plan');
      } else if (step === 'box_size' && window.BzWizard && window.BzWizard.id() === 'w5') {
        labelEl.textContent = this.getLocaleString('quiz.wizard_5.buttons.flavors') || 'Kies smaken';
      } else if (step === 'flavors' && window.BzWizard && window.BzWizard.id() === 'w5') {
        labelEl.textContent = this.getLocaleString('quiz.wizard_5.buttons.checkout') || 'Afrekenen';
      } else if (step !== 'email') {
        labelEl.textContent = this.getLocaleString('quiz.buttons.next');
      }

      if (step === 'get_started') {
        nextButton.disabled = false;
        return;
      }

      if (step === 'calculation') {
        nextButton.disabled = true;
        return;
      }

      if (step === 'weight') {
        nextButton.disabled = false;
        return;
      }

      if (step === 'lifetime_offer') {
        if (!isLoading) nextButton.disabled = false;
        return;
      }

      if (step === 'box_size') {
        nextButton.disabled = false;
        return;
      }

      if (step === 'flavors') {
        const ok = window.WizardPlan && window.WizardPlan.canContinueFlavors
          ? window.WizardPlan.canContinueFlavors(this.flow.state)
          : (this.flow.state.selectedFlavors || []).length > 0;
        nextButton.disabled = !ok;
        return;
      }

      if (step === 'email') {
        const emailInput = this.currentStepElement?.querySelector('[name="ownerEmail"]');
        const v = emailInput ? emailInput.value.trim() : '';
        const emailOk = v && this.flow.state.isValidEmail(v);
        const hasMissingData = typeof this.checkMissingRequiredSteps === 'function' && !!this.checkMissingRequiredSteps();
        if (!isLoading) {
          nextButton.disabled = !emailOk || hasMissingData;
        }
        if (typeof this.setupMissingDataWarning === 'function') {
          this.setupMissingDataWarning();
        }
        return;
      }

      if (step === 'plan_onetime') {
        if (window.WizardOnetimePage) window.WizardOnetimePage.syncFooter(this);
        return;
      }

      if (step === 'plan_overview' || step === 'extras') {
        nextButton.disabled = false;
        return;
      }

      const isValid = this.flow.state.validateStep(step);
      nextButton.disabled = !isValid;
    }

    applyCalculationFoodImages(calculationStep) {
      const dogs = this.flow.state.ensureDogs ? this.flow.state.ensureDogs() : [];
      const foods = dogs[0] && Array.isArray(dogs[0].currentFood) ? dogs[0].currentFood : [];
      const picked = ['frozen', 'raw', 'home', 'wet', 'dry'].find((id) => foods.indexOf(id) !== -1);
      if (!picked || picked === 'dry') return;
      const lang = String(window.__wizardCurrentLocale || 'nl').toLowerCase().indexOf('en') === 0 ? 'en' : 'nl';
      const file = { frozen: 'fresh', raw: 'raw', home: 'homecooked', wet: 'canned' }[picked];
      const base = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/';
      const images = {
        fresh: {
          nl: {
            negative: base + 'fresh-negative-nl_447be57e-62a1-443d-93c5-e07fc9fb6205.webp?v=1790771587',
            positive: base + 'fresh-positive-nl_c2c2c195-667c-4fb6-8273-d62dca257a20.webp?v=1790771588'
          },
          en: {
            negative: base + 'fresh-negative-en_7b03bc65-c1a8-4feb-9c46-ba628b8c6f00.webp?v=1790771586',
            positive: base + 'fresh-positive-en_761ac883-bf90-42be-abea-3e5f5b6b6cbf.webp?v=1790771586'
          },
          empty: base + 'fresh-negative-empty_cc1bb952-aa15-4c95-a078-d08cbdab90ed.webp?v=1790771577'
        },
        raw: {
          nl: {
            negative: base + 'raw-negative-nl_dd65b630-50c7-4aaa-82b9-a180eca80517.webp?v=1790771894',
            positive: base + 'raw-positive-nl_9d306da6-1284-4989-865c-5e657d49e776.webp?v=1790771895'
          },
          en: {
            negative: base + 'raw-negative-en_27247200-849b-4acb-af2b-a9222a15c434.webp?v=1790771586',
            positive: base + 'raw-positive-en_b63fa5bf-a414-448a-9a9a-bbb358aa5293.webp?v=1790771587'
          },
          empty: base + 'raw-negative-empty_9d924787-e5a6-49e6-b5ee-ad3c21373e04.webp?v=1790771577'
        },
        homecooked: {
          nl: {
            negative: base + 'homecooked-negative-nl_1f62ac95-8814-4e99-ba6a-a9e39ac3264e.webp?v=1790771587',
            positive: base + 'homecooked-positive-nl_ab18f000-590e-44bc-b031-eb9dd26d010a.webp?v=1790771586'
          },
          en: {
            negative: base + 'homecooked-negative-en_639582a1-cccd-475a-bf66-b3e6e7a68ed2.webp?v=1790771586',
            positive: base + 'homecooked-positive-en_17e8b462-7e59-40c3-b39e-d48e08582e73.webp?v=1790771586'
          },
          empty: base + 'homecooked-negative-empty_17f4de57-daf5-451c-b4f3-4298767de5d2.webp?v=1790771577'
        },
        canned: {
          nl: {
            negative: base + 'canned-negative-nl_a27d0bf6-8120-46ce-9c2c-c6bddc4a9dfc.webp?v=1790771586',
            positive: base + 'canned-positive-nl_08a80c1e-8d5f-47bc-a4f9-29f8a9ea3335.webp?v=1790771587'
          },
          en: {
            negative: base + 'canned-negative-en_f269869f-2195-4bb9-b3c7-ca68dc8a68b9.webp?v=1790771586',
            positive: base + 'canned-positive-en_a2220de8-1764-4b90-9327-35272e47ea37.webp?v=1790771587'
          },
          empty: base + 'canned-negative-empty_b16f3d71-6b0d-4ecf-8e17-1ba678068109.webp?v=1790771578'
        }
      }[file];
      const negative = images[lang].negative;
      const negativeEmpty = images.empty;
      const positive = images[lang].positive;
      const setSrc = (selector, src) => {
        const img = calculationStep.querySelector(selector);
        if (img) img.src = src;
      };
      setSrc('.calculation-bowl-image-negative-with-text', negative);
      setSrc('.calculation-bowl-image-negative-no-text', negativeEmpty);
      setSrc('.calculation-bowl-image-positive-with-text', positive);
    }

    async setupCalculationStep() {
      const calculationStep = this.currentStepElement?.querySelector('[data-calculation-step]');
      if (!calculationStep) return;
      if (calculationStep.dataset.setupComplete === 'true') return;
      calculationStep.dataset.setupComplete = 'true';
      this.applyCalculationFoodImages(calculationStep);

      this.cleanupCalculationStep?.();
      if (!this.calculationTimeouts) this.calculationTimeouts = [];

      try {
        this.flow.runCalculations();
        if (this.flow.state.petMetaobjectId) {
          try {
            const petData = this.getPetDataForMetaobject(this.flow.state);
            const calculations = this.getWizardCalculationsForPersistence(this.flow.state);
            const customerIdForSave =
              this.flow.state.sessionCustomerId || this.flow.state.customerId || null;
            await this.flow.shopifyAPI.createCustomerViaBackend(
              { ownerName: petData.ownerName || '', ownerEmail: petData.ownerEmail || '', emailConsent: petData.emailConsent !== false },
              petData,
              calculations,
              this.flow.state.petMetaobjectId,
              customerIdForSave
            );
            await this.flow.storage.autoSave(this.flow.state.getState(), customerIdForSave);
          } catch (e) {}
        }

        const dotsSpan = calculationStep.querySelector('[data-calculation-dots]');
        if (dotsSpan) {
          const dotStates = ['.', '..', '…', ''];
          let i = 0;
          dotsSpan.textContent = dotStates[0];
          this.calculationDotsInterval = setInterval(() => {
            i = (i + 1) % dotStates.length;
            dotsSpan.textContent = dotStates[i];
          }, 450);
        }

        calculationStep.classList.add('image-negative-active');
        this.calculationTimeouts.push(setTimeout(() => {
          calculationStep.classList.remove('image-negative-active');
          calculationStep.classList.add('image-positive-active');
        }, 4000));

        this.calculationTimeouts.push(setTimeout(() => {
          calculationStep.classList.add('fade-out');
          setTimeout(() => {
            this.flow.router.navigateNext('calculation', true);
          }, 800);
        }, 8000));
      } catch (e) {
        console.error('Calculation step error:', e);
        const missing = typeof this.checkMissingRequiredSteps === 'function' && this.checkMissingRequiredSteps();
        if (missing && this.flow.router) this.flow.router.navigate(missing);
      }
    }

    setupPlanOverviewInputs(step) {
      const inputs = this.currentStepElement?.querySelectorAll('[data-step="' + step + '"]');
      if (!inputs?.length) return;
      inputs.forEach(input => {
        const field = input.getAttribute('data-field');
        if (!field) return;
        if (input.type === 'radio' || input.type === 'checkbox') {
          input.addEventListener('change', async () => {
            const val = input.type === 'checkbox' ? (input.checked ? input.value : null) : input.value;
            if (field === 'selectedPlan' && ['1', '2', '3'].includes(String(val))) {
              this.flow.state.selectedPlan = String(val);
            }
            this.flow.storage.autoSave(this.flow.state.getState(), this.flow.state.customerId);
            await this.updatePlanOverviewContent();
          });
        }
      });
    }

    setupFlavorModalListeners() {
      if (window.__wizardFlavorModalListenersSetup) return;
      window.__wizardFlavorModalListenersSetup = true;
      document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-open-wizard-flavor-modal]');
        if (!openBtn) return;
        e.preventDefault();
        e.stopPropagation();
        const tab = openBtn.getAttribute('data-open-wizard-flavor-modal');
        if (!tab) return;
        if (window.wizardFlow?.stepHandler) window.wizardFlow.stepHandler.openFlavorModal(tab);
      });
    }

    setupInstantFlavorModalListeners() {
      if (window.__wizardInstantFlavorModalListenersSetup) return;
      window.__wizardInstantFlavorModalListenersSetup = true;
      const openInstant = (value) => {
        if (!value) return;
        const instant = document.querySelector('.flavor-modal-' + value);
        if (instant) instant.dataset.state = 'open';
      };
      document.addEventListener('click', (e) => {
        const el = e.target.closest('[data-open-flavor-modal]');
        if (!el) return;
        e.preventDefault();
        const value = el.getAttribute('data-open-flavor-modal');
        openInstant(value);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const el = e.target?.closest?.('[data-open-flavor-modal][role="button"]');
        if (!el) return;
        e.preventDefault();
        const value = el.getAttribute('data-open-flavor-modal');
        openInstant(value);
      });
    }

    openFlavorModal(activeTab) {
      const w3 = window.BzWizard && window.BzWizard.id() === 'w3';
      const modal = document.querySelector('[data-wizard-flavor-modal]');
      if (!modal) return;
      if (w3 && window.WizardW3) {
        activeTab = 'plan';
        const dog = window.WizardW3.activeDog(this.flow.state);
        const flavors = (dog && dog.flavors) || [];
        this.flow.state.selectedFlavorsFull = flavors.slice();
        this.flow.state.selectedFlavorsTrial = flavors.slice();
      }
      modal.classList.toggle('is-w3', !!w3);
      modal.style.display = 'flex';
      modal.dataset.activeTab = activeTab;
      const tabs = modal.querySelectorAll('[data-w2-flavor-tab]');
      const contents = modal.querySelectorAll('[data-w2-flavor-panel]');
      tabs.forEach(t => {
        t.classList.toggle('wizard-flavor-tab--active', t.getAttribute('data-w2-flavor-tab') === activeTab);
      });
      contents.forEach(c => {
        c.style.display = c.getAttribute('data-w2-flavor-panel') === activeTab ? '' : 'none';
      });
      this.updateFlavorModalInstruction(activeTab);
      this.updateFlavorModalAllergyWarnings();
      this.populateFlavorModalImages();
      this.syncFlavorModalToState('trial');
      this.syncFlavorModalToState('plan');
      this.updateFlavorModalSelectionDisabledState();
      this.updateFlavorModalSaveButton();
    }

    /**
     * Max selectable trial flavors = min(intro bag count, 3), at least 1 bag worth of variety.
     */
    getMaxTrialFlavorSelections() {
      const intro = this.flow.state.calculations?.introBagCount;
      const n = Number.isFinite(intro) && intro > 0 ? intro : 1;
      return Math.min(n, 3);
    }

    /**
     * Max selectable full-plan flavors = min(bag count, 3) — only three SKUs exist.
     */
    getMaxPlanFlavorSelections() {
      if (window.BzWizard && window.BzWizard.id() === 'w3' && window.WizardW3) {
        return window.WizardW3.maxFlavors();
      }
      const bc = this.flow.state.calculations?.bagCount;
      const n = Number.isFinite(bc) && bc > 0 ? bc : 1;
      return Math.min(n, 3);
    }

    /**
     * Trim plan flavor list to maxCount (drops lowest-priority flavors first).
     * @param {string[]} fullList
     * @param {number} maxCount
     * @returns {string[]}
     */
    trimPlanFlavorSelectionToMax(fullList, maxCount) {
      const selected = [...(fullList || [])];
      const removeOrder = FlavorDistribution.getFlavorTrimOrder();
      while (selected.length > maxCount) {
        const victim = removeOrder.find(f => selected.includes(f));
        if (!victim) break;
        selected.splice(selected.indexOf(victim), 1);
      }
      return selected;
    }

    updateFlavorModalInstruction(activeTab) {
      const modal = document.querySelector('[data-wizard-flavor-modal]');
      const instEl = modal?.querySelector('[data-wizard-flavor-modal-instruction]');
      if (!instEl) return;
      const activeDog = window.BzWizard && window.BzWizard.id() === 'w3' && window.WizardW3
        ? window.WizardW3.activeDog(this.flow.state)
        : null;
      const petName = (activeDog && activeDog.name) || this.flow.state.getPetData().name || '';
      const pronoun = this.flow.state.getPronoun?.() || 'haar';
      const applyPlaceholders = (s) =>
        String(s || '')
          .replace(/%\{pet_name\}/g, petName)
          .replace(/%\{pronoun\}/g, pronoun);
      if (activeTab === 'plan') {
        const max = this.getMaxPlanFlavorSelections();
        if (window.BzWizard && window.BzWizard.id() === 'w3' && window.__wizard3Copy) {
          const template = max === 1 ? window.__wizard3Copy.flavor_title_one : window.__wizard3Copy.flavor_title_many;
          instEl.textContent = String(template || '').replace('%{name}', petName).replace('%{max}', String(max));
          const save = document.querySelector('[data-wizard-flavor-modal-save]');
          if (save && window.__wizard3Copy.flavor_save) save.textContent = window.__wizard3Copy.flavor_save;
          return;
        }
        const key = max === 1
          ? 'quiz.steps.plan_overview.flavor_modal_plan_title_1'
          : 'quiz.steps.plan_overview.flavor_modal_plan_title_n';
        let s = this.getLocaleString?.(key) || '';
        instEl.textContent = applyPlaceholders(s).replace(/%\{max\}/g, String(max));
        return;
      }
      const max = this.getMaxTrialFlavorSelections();
      const key = max === 1
        ? 'quiz.steps.plan_overview.flavor_modal_trial_title_1'
        : 'quiz.steps.plan_overview.flavor_modal_trial_title_n';
      let s = this.getLocaleString?.(key) || '';
      instEl.textContent = applyPlaceholders(s).replace(/%\{max\}/g, String(max));
    }

    updateFlavorModalAllergyWarnings() {
      const modal = document.querySelector('[data-wizard-flavor-modal]');
      if (!modal) return;
      const activeDog = window.BzWizard && window.BzWizard.id() === 'w3' && window.WizardW3
        ? window.WizardW3.activeDog(this.flow.state)
        : null;
      const petData = activeDog || this.flow.state.getPetData();
      const allergies = this.normalizePetAllergies(petData.allergies || []);
      const petName = petData.name || '';
      const pronoun = this.flow.state.getPronoun?.() || 'haar';
      const warningText = String(this.getLocaleString?.('quiz.steps.flavors.allergy_warning') || '')
        .replace(/%\{pet_name\}/g, petName)
        .replace(/%\{pronoun\}/g, pronoun);
      FlavorDistribution.getFlavorDistributionOrder().forEach(fid => {
        modal.querySelectorAll(`[data-conditional="allergy-${fid}"]`).forEach(el => {
          const textEl = el.querySelector('[data-dynamic-text]');
          if (textEl) textEl.textContent = warningText;
          el.style.display = 'none';
        });
      });
      allergies.forEach(token => {
        const flavorId = this.canonicalAllergyToFlavorId(token);
        if (!flavorId) return;
        modal.querySelectorAll(`[data-conditional="allergy-${flavorId}"]`).forEach(message => {
          message.style.display = 'flex';
        });
      });
    }

    populateFlavorModalImages() {
      const state = this.flow.state;
      const config = this.flow.config;
      const isHalf = this.isPlanHalfBowl(state);
      const planVids = isHalf ? (config.variantIdsHalf || config.variantIds) : config.variantIds;
      const vids = planVids || config.variantIds || {};
      const pricingHalf = state.variantPricingHalf || {};
      const pricing = state.variantPricing || {};
      FlavorDistribution.getFlavorDistributionOrder().forEach(f => {
        const cards = document.querySelectorAll(`[data-wizard-flavor-modal] [data-flavor-id="${f}"]`);
        const vid = vids[f];
        const cached = isHalf ? (pricingHalf[f] || pricing[f]) : (pricing[f] || pricingHalf[f]);
        const setCard = (variant) => {
          if (!variant) return;
          cards.forEach(card => {
            card.dataset.variantId = String(variant.id || vid || '');
            const img = card.querySelector('.flavor-card-image img, [data-flavor-image] img');
            if (img && variant.image) img.src = variant.image;
            const tagline = card.querySelector('[data-flavor-tagline]');
            if (tagline) {
              tagline.textContent = (variant.tagline || variant.variantDescription || '').trim();
            }
          });
        };
        if (cached?.image || cached?.tagline || cached?.variantDescription) {
          setCard(cached);
        } else if (vid) {
          this.flow.shopifyAPI.getVariant(vid).then(variant => {
            setCard(variant);
          }).catch(() => {});
        }
      });
    }

    closeFlavorModal() {
      const modal = document.querySelector('[data-wizard-flavor-modal]');
      if (!modal) return;
      modal.style.display = 'none';
      modal.classList.remove('is-w3');
    }

    populateSellingPlanNamesFromLiquid() {
      const liquidNames = window.__wizard1SellingPlanNames || {};
      if (Object.keys(liquidNames).length > 0) {
        this.flow.state.sellingPlanNames = { ...(this.flow.state.sellingPlanNames || {}), ...liquidNames };
      }
    }

    parseRecurringSentenceTemplate(tpl) {
      const s = String(tpl || '');
      const tMark = '%{plan_title}';
      const aMark = '%{amount}';
      const ti = s.indexOf(tMark);
      if (ti < 0) {
        return { before: s, mid: '', after: '' };
      }
      const before = s.slice(0, ti);
      const rest = s.slice(ti + tMark.length);
      const ai = rest.indexOf(aMark);
      if (ai < 0) {
        return { before, mid: rest, after: '' };
      }
      return { before, mid: rest.slice(0, ai), after: rest.slice(ai + aMark.length) };
    }

    getFullPlanFirstShipmentDateStr() {
      const daysUntilFullPlanShipment = this.getEffectiveIntroMatchDays(this.flow.state);
      const shipDate = new Date();
      shipDate.setHours(0, 0, 0, 0);
      shipDate.setDate(shipDate.getDate() + daysUntilFullPlanShipment);
      const w2loc = (window.__wizardCurrentLocale || '').toLowerCase();
      const dateLocale = w2loc.startsWith('nl')
        ? 'nl-NL'
        : w2loc.startsWith('en')
          ? 'en-GB'
          : typeof navigator !== 'undefined' && navigator.language
            ? navigator.language
            : 'en-GB';
      let dateStr = shipDate.toLocaleDateString(dateLocale, { day: 'numeric', month: 'short' });
      dateStr = String(dateStr).toUpperCase();
      return dateStr;
    }

    async fetchSellingPlanNameIfNeeded(sellingPlanId) {
      const sid = sellingPlanId == null ? '' : String(sellingPlanId);
      if (!sid) return null;
      const state = this.flow.state;
      state.sellingPlanNames = state.sellingPlanNames || {};
      if (state.sellingPlanNames[sid]) return state.sellingPlanNames[sid];
      const api = this.flow.shopifyAPI;
      if (!api || typeof api.executeGraphQL !== 'function') return null;
      const gid = `gid://shopify/SellingPlan/${sid}`;
      try {
        const data = await api.executeGraphQL(
          `query SellingPlanName($id: ID!) { node(id: $id) { ... on SellingPlan { name } } }`,
          { id: gid }
        );
        if (!data || !data.node) return null;
        const name = data.node.name;
        if (name) {
          state.sellingPlanNames[sid] = name;
        }
        return name || null;
      } catch (e) {
        return null;
      }
    }

    async ensurePlanOverviewSellingPlanNames() {
      const state = this.flow.state;
      const config = this.flow.getConfig?.() || this.flow.config || {};
      const calcs = state.calculations || {};
      const matchDays = calcs.matchDays || 54;
      const isHalf = this.isPlanHalfBowl(state);
      const base = this.getPlanBaseIntervalDays(matchDays, isHalf);
      const map = config.sellingPlanMapping || {};
      for (const mult of [1, 2, 3]) {
        const days = base * mult;
        const id = map[String(days)] || map[days];
        if (id) await this.fetchSellingPlanNameIfNeeded(id);
      }
    }

    getSellingPlanTitleForMultiplier(mult) {
      const m = parseInt(String(mult), 10) || 1;
      const state = this.flow.state;
      const config = this.flow.getConfig?.() || this.flow.config || {};
      const calcs = state.calculations || {};
      const base = this.getPlanBaseIntervalDays(calcs.matchDays || 54, this.isPlanHalfBowl(state));
      const days = base * m;
      const map = config.sellingPlanMapping || {};
      const id = map[String(days)] || map[days];
      state.sellingPlanNames = state.sellingPlanNames || {};
      if (id && state.sellingPlanNames[String(id)]) {
        return state.sellingPlanNames[String(id)];
      }
      return (this.getLocaleString?.('quiz.steps.plan_overview.repeats_every') || 'every %{days} days').replace(
        /%\{days\}/g,
        String(days)
      );
    }

    getBulkModalRoot() {
      return document.querySelector('[data-wizard-bulk-modal]');
    }

    updateBulkModalSaveButtonLabel() {
      const modal = this.getBulkModalRoot();
      const btn = modal?.querySelector('[data-wizard-bulk-modal-save]');
      if (!btn) return;
      const checked = modal?.querySelector('[data-bulk-radio-modal]:checked');
      const m = parseInt(String(checked?.value || '1'), 10) || 1;
      const key =
        m >= 2 ? 'quiz.steps.plan_overview.bulk_modal_save_stock_up' : 'quiz.steps.plan_overview.bulk_modal_save_fast';
      btn.textContent = this.getLocaleString?.(key) || '';
    }

    openBulkModal() {
      const modal = this.getBulkModalRoot();
      if (!modal) return;
      const saved = String(this.flow.state.selectedPlan || '1');
      modal.querySelectorAll('[data-bulk-radio-modal]').forEach(r => {
        r.checked = String(r.value) === saved;
      });
      this.updateBulkOptions();
      this.updateBulkModalSaveButtonLabel();
      modal.style.display = 'flex';
      if (!this._bulkModalEscapeHandler) {
        this._bulkModalEscapeHandler = e => {
          if (e.key !== 'Escape') return;
          const m = this.getBulkModalRoot();
          if (m && m.style.display === 'flex') {
            e.preventDefault();
            this.closeBulkModal();
          }
        };
      }
      document.addEventListener('keydown', this._bulkModalEscapeHandler);
    }

    /**
     * Hide bulk modal and persist the selected radio to state (X, overlay, Escape, or save button).
     */
    async closeBulkModal() {
      const modal = this.getBulkModalRoot();
      if (modal && modal.style.display === 'flex') {
        const sel = modal.querySelector('[data-bulk-radio-modal]:checked');
        const val = sel ? String(sel.value) : '1';
        this.flow.state.selectedPlan = val;
        this.flow.storage?.autoSave?.(this.flow.state.getState(), this.flow.state.customerId);
        modal.style.display = 'none';
        try {
          await this.updatePlanOverviewContent();
        } catch (e) {}
      } else if (modal) {
        modal.style.display = 'none';
      }
      if (this._bulkModalEscapeHandler) {
        document.removeEventListener('keydown', this._bulkModalEscapeHandler);
      }
    }

    async saveBulkModal() {
      await this.closeBulkModal();
    }

    setupWizardBulkModal() {
      if (window.__wizardBulkModalListenersSetup) return;
      window.__wizardBulkModalListenersSetup = true;
      const modal = document.querySelector('[data-wizard-bulk-modal]');
      if (!modal) return;
      modal.addEventListener('click', e => {
        if (e.target === modal) this.closeBulkModal();
      });
      modal.querySelectorAll('[data-wizard-bulk-modal-close]').forEach(btn => {
        btn.addEventListener('click', () => this.closeBulkModal());
      });
      modal.querySelector('[data-wizard-bulk-modal-save]')?.addEventListener('click', () => {
        this.saveBulkModal();
      });
      modal.addEventListener('change', e => {
        if (e.target?.matches?.('[data-bulk-radio-modal]')) this.updateBulkModalSaveButtonLabel();
      });
      if (!window.__wizardOpenBulkModalDelegation) {
        window.__wizardOpenBulkModalDelegation = true;
        document.addEventListener('click', e => {
          const trigger = e.target.closest('[data-wizard-open-bulk-modal]');
          if (!trigger) return;
          if (this.flow.state.getCurrentStep?.() !== 'plan_overview') return;
          e.preventDefault();
          window.wizardFlow?.stepHandler?.openBulkModal?.();
        });
      }
    }

    /**
     * Recurring full-plan amounts for the selected period (same math as recurring line + sticky compare).
     * @param {string} [periodOverride] - 'day' | 'week' | 'shipment'
     * @returns {{ currentDisplayCents: number, compareDisplayCents: number, mult: number }}
     */
    getRecurringPlanOverviewDisplayAmounts(periodOverride) {
      const state = this.flow.state;
      const period = periodOverride || state.selectedPricePeriod || 'day';
      const calcs = state.calculations || {};
      const isHalf = this.isPlanHalfBowl(state);
      const matchDays = calcs.matchDays || 54;
      const baseInterval = this.getPlanBaseIntervalDays(matchDays, isHalf);
      const mult = parseInt(String(state.selectedPlan || '1'), 10) || 1;
      const multInterval = baseInterval * mult;
      const pricing = isHalf
        ? (state.variantPricingHalf || state.variantPricing || {})
        : (state.variantPricing || {});
      const distMult = this.getPlanBulkDistribution(mult);
      const planCents = this.calculateFullPlanAdditiveDiscountTotalCents(distMult, pricing);
      const planCents1 = this.calculateFullPlanAdditiveDiscountTotalCents(this.getPlanBulkDistribution(1), pricing);
      const d1 = Math.round(this.getPlanBulkDisplayCents(planCents1, baseInterval, period));
      const dCur = Math.round(this.getPlanBulkDisplayCents(planCents, multInterval, period));
      let compareDisplayCents = d1;
      let currentDisplayCents = dCur;
      if (period === 'shipment' && mult >= 2) {
        const cmpMult = this.calculateCompareAtTotalCents(distMult, pricing);
        compareDisplayCents = Math.round(this.getPlanBulkDisplayCents(cmpMult, multInterval, period));
        currentDisplayCents = Math.round(this.getPlanBulkDisplayCents(planCents, multInterval, period));
      }
      return { currentDisplayCents, compareDisplayCents, mult };
    }

    updateRecurringPlanOverviewLine() {
      const tpl =
        this.getLocaleString?.('quiz.steps.plan_overview.recurring_sentence') ||
        '%{plan_title} at %{amount} ';
      const parts = this.parseRecurringSentenceTemplate(tpl);
      const period = this.flow.state.selectedPricePeriod || 'day';
      document.querySelectorAll('[data-plan-overview-period-select]').forEach(ov => {
        if (ov && ov.value !== period) ov.value = period;
      });
      const fmt = c => this.formatWizardMoney(Math.round(Number(c) || 0));
      const { currentDisplayCents, compareDisplayCents, mult: multFromCalc } =
        this.getRecurringPlanOverviewDisplayAmounts(period);

      const line = this.currentStepElement?.querySelector('[data-wizard-recurring-line]');
      if (line) {
        const beforeEl = line.querySelector('[data-recurring-part-before]');
        const midEl = line.querySelector('[data-recurring-part-mid]');
        const afterEl = line.querySelector('[data-recurring-part-after]');
        const amtWrap = line.querySelector('[data-recurring-plan-amount-wrap]');
        const titleEl = line.querySelector('[data-selling-plan-title-text]');
        const btn = line.querySelector('[data-wizard-open-bulk-modal]');
        if (beforeEl) {
          beforeEl.textContent = parts.before;
          beforeEl.style.display = parts.before ? '' : 'none';
        }
        if (midEl) midEl.textContent = parts.mid;
        if (afterEl) {
          afterEl.textContent = parts.after;
          afterEl.style.display = parts.after ? '' : 'none';
        }
        const mult = parseInt(String(this.flow.state.selectedPlan || '1'), 10) || 1;
        const titleText = this.getSellingPlanTitleForMultiplier(mult);
        if (titleEl) titleEl.textContent = titleText;
        if (btn) {
          const hint = this.getLocaleString?.('quiz.steps.plan_overview.bulk_modal_trigger_aria') || '';
          btn.setAttribute('aria-label', hint ? `${titleText}. ${hint}` : titleText);
        }
        if (amtWrap) {
          if (multFromCalc >= 2 && compareDisplayCents > currentDisplayCents) {
            amtWrap.innerHTML = `<span class="wizard-recurring-price-compare">${fmt(compareDisplayCents)}</span> <span class="wizard-recurring-price-final">${fmt(currentDisplayCents)}</span>`;
          } else {
            amtWrap.innerHTML = `<span class="wizard-recurring-price-single">${fmt(currentDisplayCents)}</span>`;
          }
        }
      }
    }

    updatePlanOverviewSavingsBadges() {
      const trialEl = this.currentStepElement?.querySelector('[data-wizard-trial-savings-badge]');
      const fullEl = this.currentStepElement?.querySelector('[data-wizard-full-savings-badge]');
      const trialPct = this.getWizardTrialOrderDiscountPercent();
      const pctStr = String(trialPct);
      if (trialEl) {
        trialEl.textContent =
          this.getLocaleString?.('quiz.steps.plan_overview.trial_savings_badge', { percent: pctStr }) ||
          `${pctStr}%`;
      }
      if (fullEl) {
        const fullPct = this.getWizardFullPlanBundleDiscountPercent();
        const yStr = String(fullPct);
        fullEl.textContent =
          this.getLocaleString?.('quiz.steps.plan_overview.full_savings_badge', { percent: yStr }) ||
          `${yStr}%`;
      }
    }

    syncFlavorModalToState(activeTab) {
      const state = this.flow.state;
      const content = document.querySelector(`[data-w2-flavor-panel="${activeTab}"]`);
      if (!content) return;
      const isTrial = activeTab === 'trial';
      const selected = isTrial ? (state.selectedFlavorsTrial || []) : (state.selectedFlavorsFull || []);
      const selector = isTrial ? '[data-flavor-checkbox-trial]' : '[data-flavor-checkbox-plan]';
      content.querySelectorAll(selector).forEach(cb => {
        cb.checked = selected.includes(cb.value);
      });
      content.querySelectorAll('[data-flavor-badge]').forEach(badge => {
        const card = badge.closest('[data-flavor-card]');
        badge.style.display = selected.includes(card?.dataset?.flavorId) ? 'flex' : 'none';
      });
    }

    /**
     * Disable unchecked flavor checkboxes when trial/plan panel is at max selections (max > 1 only).
     * When max === 1, all cards stay selectable; change handler auto-switches selection.
     */
    updateFlavorModalSelectionDisabledState() {
      const modal = document.querySelector('[data-wizard-flavor-modal]');
      if (!modal) return;
      const updatePanel = (panelId, isTrial) => {
        const content = modal.querySelector(`[data-w2-flavor-panel="${panelId}"]`);
        if (!content) return;
        const max = isTrial ? this.getMaxTrialFlavorSelections() : this.getMaxPlanFlavorSelections();
        const selector = isTrial ? '[data-flavor-checkbox-trial]' : '[data-flavor-checkbox-plan]';
        const checked = max > 1 ? content.querySelectorAll(`${selector}:checked`).length : 0;
        content.querySelectorAll('[data-flavor-card]').forEach(card => {
          const input = card.querySelector(selector);
          if (!input) return;
          if (max === 1) {
            input.disabled = false;
            card.classList.remove('wizard-flavor-card--max-selected');
            card.removeAttribute('aria-disabled');
            return;
          }
          const shouldDisable = checked >= max && !input.checked;
          input.disabled = shouldDisable;
          card.classList.toggle('wizard-flavor-card--max-selected', shouldDisable);
          if (shouldDisable) card.setAttribute('aria-disabled', 'true');
          else card.removeAttribute('aria-disabled');
        });
      };
      updatePanel('trial', true);
      updatePanel('plan', false);
    }

    updateFlavorModalSaveButton() {
      const modal = document.querySelector('[data-wizard-flavor-modal]');
      if (!modal) return;
      const activeTab = modal.dataset.activeTab || 'trial';
      const content = modal.querySelector(`[data-w2-flavor-panel="${activeTab}"]`);
      if (!content) return;
      const isTrial = activeTab === 'trial';
      let count = 0;
      let valid = true;
      if (isTrial) {
        count = content.querySelectorAll('[data-flavor-checkbox-trial]:checked').length;
        const max = this.getMaxTrialFlavorSelections();
        valid = count >= 1 && count <= max;
      } else {
        count = content.querySelectorAll('[data-flavor-checkbox-plan]:checked').length;
        const maxPlan = this.getMaxPlanFlavorSelections();
        valid = count >= 1 && count <= maxPlan;
      }
      const saveBtn = modal.querySelector('[data-wizard-flavor-modal-save]');
      if (saveBtn) saveBtn.disabled = !valid;
    }

    onWizardFlavorModalInputChange(e) {
      const input = e.target;
      const modal = input.closest('[data-wizard-flavor-modal]');
      if (!modal) return;
      const content = input.closest('[data-w2-flavor-panel]');
      if (!content) return;
      const tab = content.getAttribute('data-w2-flavor-panel');
      const isTrial = tab === 'trial';
      const selector = isTrial ? '[data-flavor-checkbox-trial]' : '[data-flavor-checkbox-plan]';
      if (!input.matches(selector)) return;

      const max = isTrial ? this.getMaxTrialFlavorSelections() : this.getMaxPlanFlavorSelections();

      if (max === 1 && input.checked) {
        content.querySelectorAll(`${selector}:checked`).forEach(cb => {
          if (cb === input) return;
          cb.checked = false;
          const otherCard = cb.closest('[data-flavor-card]');
          const otherBadge = otherCard?.querySelector('[data-flavor-badge]');
          if (otherBadge) otherBadge.style.display = 'none';
        });
      } else if (max > 1 && input.checked) {
        const checked = content.querySelectorAll(`${selector}:checked`);
        if (checked.length > max) {
          input.checked = false;
        }
      }

      const card = input.closest('[data-flavor-card]');
      const badge = card?.querySelector('[data-flavor-badge]');
      if (badge) badge.style.display = input.checked ? 'flex' : 'none';

      this.updateFlavorModalSelectionDisabledState();
      this.updateFlavorModalSaveButton();
    }

    setupWizardFlavorModalDetailsLinks() {
      const modal = document.querySelector('[data-wizard-flavor-modal]');
      if (!modal || modal.dataset.w2DetailsLinksBound === '1') return;
      modal.dataset.w2DetailsLinksBound = '1';
      modal.querySelectorAll('.flavor-card-details-link').forEach(link => {
        link.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          const value = link.getAttribute('data-open-flavor-modal');
          if (value) {
            const instant = document.querySelector('.flavor-modal-' + value);
            if (instant) instant.dataset.state = 'open';
          }
        });
      });
    }

    bindPlanOverviewOnetimeLink() {
      const link = this.currentStepElement?.querySelector('[data-wizard-onetime-open]');
      if (!link || link.dataset.w2OnetimeOpenBound) return;
      link.dataset.w2OnetimeOpenBound = '1';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.flow.router.navigate('plan_onetime');
      });
    }

    async setupPlanOverviewStep() {
      const state = this.flow.state;
      const config = this.flow.config;

      if (state.selectedPlan === 'half') {
        if (!state.planBowlValue) state.planBowlValue = 'Half';
        state.selectedPlan = '1';
      }
      if (!['1', '2', '3'].includes(String(state.selectedPlan || ''))) state.selectedPlan = '1';

      this.flow.runCalculations();

      const maxTrialFlavors = Math.min(this.getCappedTrialBagCountForWizard(state.calculations || {}), 3);
      const maxPlanFlavors = Math.min(Math.max(1, state.calculations?.bagCount || 1), 3);

      const allergies = this.normalizePetAllergies(state.petData.allergies || []);
      const allFlavors = FlavorDistribution.getFlavorDistributionOrder();
      const excluded = new Set();
      allergies.forEach(a => {
        const f = this.canonicalAllergyToFlavorId(a);
        if (f) excluded.add(f);
      });
      const allowedFlavors = allFlavors.filter(f => !excluded.has(f));
      const defaultFlavor = FlavorDistribution.getDefaultFlavorId();

      state.selectedFlavorsTrial = (state.selectedFlavorsTrial || []).slice(0, maxTrialFlavors);
      state.selectedFlavorsFull = this.trimPlanFlavorSelectionToMax(state.selectedFlavorsFull || [], maxPlanFlavors);

      if (window.WizardHousehold && typeof window.WizardHousehold.maybeLargeDogOffer === 'function') {
        window.WizardHousehold.maybeLargeDogOffer(this);
      }

      const editProfileBtn = this.currentStepElement?.querySelector('[data-wizard-edit-profile]');
      if (editProfileBtn) {
        editProfileBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.markProfileOrigin('wizard');
          this.flow.router.navigate('profile');
        });
      }

      const addDogBtn = this.currentStepElement?.querySelector('[data-wizard-add-another-dog]');
      if (addDogBtn && !addDogBtn.dataset.w2AddDogBound) {
        addDogBtn.dataset.w2AddDogBound = '1';
        addDogBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          if (addDogBtn.disabled) return;
          await this.handleAddAnotherDog();
        });
      }

      this.populateSellingPlanNamesFromLiquid();

      // Instant "plan-overview-section" → [data-plan-overview-slot] in wizard-flow.liquid
      this.ensurePlanOverviewShopifySectionInSlotVisible();

      this.setupWizardBulkModal();

      const nextBtn = document.querySelector('[data-next-button]');
      if (nextBtn) nextBtn.disabled = false;

      const productId = config.productId || '10659607675144';
      try {
        await this.ensurePlanBowlProduct(productId);
      } catch (e) {}

      const isHalf = this.isPlanHalfBowl(state);
      const planVids = isHalf ? (config.variantIdsHalf || config.variantIds) : config.variantIds;
      const trialVids = config.variantIds || {};
      const flavorsNeedingPricing = [...new Set([...(state.selectedFlavorsTrial || []), ...(state.selectedFlavorsFull || [])])];
      state.variantPricing = state.variantPricing || {};
      state.variantPricingHalf = state.variantPricingHalf || {};
      for (const f of flavorsNeedingPricing) {
        const vid = state.selectedFlavorsTrial?.includes(f) ? trialVids[f] : (planVids[f] || trialVids[f]);
        if (!vid || state.variantPricing[f]) continue;
        try {
          const v = await this.flow.shopifyAPI.getVariant(vid);
          if (v) state.variantPricing[f] = v;
        } catch (e) {}
      }
      if (isHalf && config.variantIdsHalf) {
        for (const f of Object.keys(config.variantIdsHalf)) {
          if (state.variantPricingHalf[f]) continue;
          try {
            const v = await this.flow.shopifyAPI.getVariant(config.variantIdsHalf[f]);
            if (v) state.variantPricingHalf[f] = v;
          } catch (e) {}
        }
      }
      this.syncWizardPresentmentCurrencyCode();

      this.bindWizardFlavorModal();
      this.setupWizardFlavorModalDetailsLinks();

      this.updateDynamicText?.('plan_overview');
      await this.updatePlanOverviewContent();
      this.setupStickyFooterPeriodSelectors?.();
    }

    saveFlavorModal() {
      const modal = document.querySelector('[data-wizard-flavor-modal]');
      if (!modal) return;
      if (window.BzWizard && window.BzWizard.id() === 'w3' && window.WizardW3) {
        const planContent = modal.querySelector('[data-w2-flavor-panel="plan"]');
        if (!planContent) return;
        const maxPlan = this.getMaxPlanFlavorSelections();
        const pickedPlan = Array.from(planContent.querySelectorAll('[data-flavor-checkbox-plan]:checked')).map(cb => cb.value);
        if (pickedPlan.length < 1 || pickedPlan.length > maxPlan) return;
        const index = window.WizardW3.activeIndex(this.flow.state);
        this.flow.state.setDogField(index, 'flavors', pickedPlan);
        this.flow.state.setDogField(index, 'flavorsDefaulted', true);
        this.flow.storage.autoSave(this.flow.state.getState(), this.flow.state.customerId);
        this.closeFlavorModal();
        window.WizardW3.mount(this, 'plan_overview');
        return;
      }
      const trialContent = modal.querySelector('[data-w2-flavor-panel="trial"]');
      const planContent = modal.querySelector('[data-w2-flavor-panel="plan"]');
      if (!trialContent || !planContent) return;
      const maxTrial = this.getMaxTrialFlavorSelections();
      const pickedTrial = Array.from(trialContent.querySelectorAll('[data-flavor-checkbox-trial]:checked')).map(cb => cb.value);
      if (pickedTrial.length < 1 || pickedTrial.length > maxTrial) return;
      const maxPlan = this.getMaxPlanFlavorSelections();
      const pickedPlan = Array.from(planContent.querySelectorAll('[data-flavor-checkbox-plan]:checked')).map(cb => cb.value);
      if (pickedPlan.length < 1 || pickedPlan.length > maxPlan) return;
      this.flow.state.selectedFlavorsTrial = pickedTrial;
      this.flow.state.selectedFlavorsFull = pickedPlan;
      this.flow.storage.autoSave(this.flow.state.getState(), this.flow.state.customerId);
      this.closeFlavorModal();
      this.updatePlanOverviewContent();
    }

    /**
     * Shopify variant price from API is euros (decimal string). Convert to cents.
     */
    _wizardMoneyStringToCents(value) {
      if (value == null) return 0;
      const s = String(value).trim();
      if (!s) return 0;

      // Expect Shopify Storefront values like "22.23" (dot decimal). Handle extra precision safely.
      // Avoid floating point drift by doing string math + rounding to 2 decimals.
      const m = s.match(/^(-?\d+)(?:\.(\d+))?$/);
      if (!m) {
        const n = Number(s);
        return Number.isFinite(n) ? Math.round(n * 100) : 0;
      }
      const sign = m[1].startsWith('-') ? -1 : 1;
      const intPart = Math.abs(parseInt(m[1], 10)) || 0;
      const fracRaw = m[2] || '';
      const fracPadded = (fracRaw + '000').slice(0, 3); // need 3 digits to round
      const d1 = fracPadded.charCodeAt(0) ? fracPadded[0] : '0';
      const d2 = fracPadded.charCodeAt(1) ? fracPadded[1] : '0';
      const d3 = fracPadded.charCodeAt(2) ? fracPadded[2] : '0';
      const cents2 = (parseInt(d1, 10) || 0) * 10 + (parseInt(d2, 10) || 0);
      const roundUp = (parseInt(d3, 10) || 0) >= 5;
      let cents = intPart * 100 + cents2 + (roundUp ? 1 : 0);
      return sign * cents;
    }

    _variantUnitPriceToCents(variant) {
      if (!variant || variant.price == null) return 0;
      return this._wizardMoneyStringToCents(variant.price);
    }

    _variantCompareAtToCents(variant) {
      if (!variant || variant.price == null) return 0;
      if (variant.compareAtPrice != null && variant.compareAtPrice !== '') {
        return this._wizardMoneyStringToCents(variant.compareAtPrice);
      }
      return this._variantUnitPriceToCents(variant);
    }

    /**
     * Wizard 2 freebie line in plan overview: compare = variant price; final = price after collection discount.
     * Compare-at is not used (checkout discount is applied via Shopify, not variant fields).
     * @param {Object} variant
     * @param {number} discountPercent - 0–100
     * @returns {{ compareCents: number, finalCents: number }}
     */
    _wizardFreebieOfferCents(variant, discountPercent) {
      const unitCents = this._variantUnitPriceToCents(variant);
      const discPct = Math.min(100, Math.max(0, Number(discountPercent ?? 100)));
      return {
        compareCents: unitCents,
        finalCents: Math.round(unitCents * (1 - discPct / 100))
      };
    }

    /**
     * Full-plan shipment total (recurring): one combined discount on **compare-at** subtotal.
     * Combined % = 10 (subscription) + min(20, max(0, totalItems − 1)) (bulk), applied once.
     * @param {Object} distribution - { flavorId: quantity }
     * @param {Object} variantPricing - flavor -> variant
     * @returns {number} discounted total cents
     */
    calculateFullPlanAdditiveDiscountTotalCents(distribution, variantPricing) {
      const totalCompare = this.calculateCompareAtTotalCents(distribution, variantPricing);
      const totalItems = Object.values(distribution || {}).reduce((s, q) => s + q, 0);
      if (totalItems === 0 || !totalCompare) return 0;
      const bulkPercent = Math.min(20, Math.max(0, totalItems - 1));
      const combinedPercent = 10 + bulkPercent;
      return Math.round(totalCompare * (1 - combinedPercent / 100));
    }

    /**
     * Legacy: sequential 10% on unit price then volume % — used only if trial pack compare-at is unavailable.
     * @param {Object} distribution - { flavorId: quantity }
     * @param {Object} variantPricing - flavor -> variant (Shopify shape, price in euros)
     * @returns {number} discounted total cents
     */
    calculateDiscountedTotalCents(distribution, variantPricing) {
      const totalItems = Object.values(distribution).reduce((sum, q) => sum + q, 0);
      if (totalItems === 0) return 0;
      const volumeDiscountPercent = Math.min(20, Math.max(0, totalItems - 1));
      let total = 0;
      FlavorDistribution.forEachFlavorInDistributionOrder(distribution, (flavorId, quantity) => {
        const variant = variantPricing[flavorId];
        if (!variant || variant.price == null) return;
        const priceCents = this._variantUnitPriceToCents(variant);
        const subscriptionPricePerUnit = Math.round(priceCents * 0.9);
        const volumeDiscountedPricePerUnit = Math.round(
          subscriptionPricePerUnit * (1 - volumeDiscountPercent / 100)
        );
        total += quantity * volumeDiscountedPricePerUnit;
      });
      return Math.round(total);
    }

    /**
     * Pre-discount compare-at total (for bulk strikethrough), cents.
     */
    calculateCompareAtTotalCents(distribution, variantPricing) {
      let total = 0;
      FlavorDistribution.forEachFlavorInDistributionOrder(distribution, (flavorId, quantity) => {
        const variant = variantPricing[flavorId];
        if (!variant || variant.price == null) return;
        total += this._variantCompareAtToCents(variant) * quantity;
      });
      return Math.round(total);
    }

    /**
     * Plan bag distribution matching wizard-1 getBulkDistribution (ratio-preserving × multiplier).
     */
    getPlanBulkDistribution(multiplier = 1) {
      const state = this.flow.state;
      const calcs = state.calculations || {};
      const fullFlavors = state.selectedFlavorsFull || [];
      let baseBagCount = calcs.bagCount || 0;
      if (!baseBagCount && calcs.matchDays && calcs.daysPerBag && fullFlavors.length) {
        baseBagCount = Math.max(1, Math.ceil(calcs.matchDays / calcs.daysPerBag));
      }
      const engine = this.flow.calculationEngine;
      if (!fullFlavors.length || !baseBagCount || !engine) return {};
      const base = engine.calculateFlavorDistribution(baseBagCount, fullFlavors);
      if (multiplier <= 1) return { ...base };
      const result = {};
      Object.keys(base).forEach(flavorId => {
        result[flavorId] = base[flavorId] * multiplier;
      });
      return result;
    }

    /**
     * Intro trial bags for Wizard 2 trial SKU + UI: cap at 3 when introMatchDays >= 7 (does not affect full-plan JSON).
     */
    getCappedTrialBagCountForWizard(calculations) {
      const calcs = calculations || {};
      const raw = Math.max(1, calcs.introBagCount || 1);
      if (calcs.introMatchDays != null && calcs.introMatchDays >= 7) {
        return Math.min(raw, 3);
      }
      return raw;
    }

    buildTrialPackVariantMapKeyFromDistribution(dist, isHalf) {
      const d = dist || {};
      const r = Math.max(0, Math.round(Number(d.rund) || 0));
      const k = Math.max(0, Math.round(Number(d.kip) || 0));
      const v = Math.max(0, Math.round(Number(d.vis) || 0));
      return `${r},${k},${v}:${isHalf ? 'half' : 'full'}`;
    }

    getWizardFlavorCartDisplayName(f) {
      const t =
        typeof this.getTranslatedFlavorName === 'function' ? this.getTranslatedFlavorName(f) : '';
      const s = (t && String(t).trim()) || '';
      if (s) return s;
      const fallback = { rund: 'Rund', kip: 'Kip', vis: 'Vis' };
      return fallback[f] || f;
    }

    /**
     * Full-plan flavor sentence for W2 cart visible property (same distribution as _subscription_products).
     */
    buildWizardFullPlanFlavorSummaryForCartLine(dist) {
      const parts = [];
      FlavorDistribution.forEachFlavorInDistributionOrder(dist, (fl, qty) => {
        parts.push(`${qty}× ${this.getWizardFlavorCartDisplayName(fl)}`);
      });
      if (parts.length === 0) return '';
      const isNl = this.getWizardPrimaryLocaleCode() === 'nl';
      if (parts.length === 1) return parts[0];
      if (parts.length === 2) {
        return isNl ? `${parts[0]} en ${parts[1]}` : `${parts[0]} and ${parts[1]}`;
      }
      const last = parts[2];
      return isNl ? `${parts[0]}, ${parts[1]} en ${last}` : `${parts[0]}, ${parts[1]} and ${last}`;
    }

    /**
     * Arrow for dynamic trial cart property name (U+2937 ⤷, not U+21B3 ↳).
     */
    getWizardTrialCartPropertyNameArrow() {
      return '\u2937';
    }

    /**
     * Dynamic cart line property name: pet name in the key (no trailing ":" — checkout adds one separator).
     * Locale: quiz.cart_line_properties.wizard_trial_line_name
     */
    buildWizardTrialCartPropertyName() {
      const petName = String(this.flow.state.getPetData().name || '').trim();
      const key = 'quiz.cart_line_properties.wizard_trial_line_name';
      const resolved = this.getLocaleString?.(key, { pet_name: petName }) || '';
      const s = String(resolved).trim();
      if (s && s !== key && !s.startsWith('quiz.cart_line_properties')) {
        return s;
      }
      const arrow = this.getWizardTrialCartPropertyNameArrow();
      const isNl = this.getWizardPrimaryLocaleCode() === 'nl';
      return isNl ? `${arrow} Daarna voor ${petName}` : `${arrow} After that for ${petName}`;
    }

    /**
     * Dynamic cart line property value: flavors + (repeat interval + daily price).
     * EN: … (repeats every N days at €…/day) · NL: … (herhaalt elke N dagen voor €…/dag)
     */
    buildWizardTrialCartPropertyValue() {
      const state = this.flow.state;
      const mult = parseInt(String(state.selectedPlan || '1'), 10) || 1;
      const calcs = state.calculations || {};
      const matchDays = calcs.matchDays || 54;
      const isHalf = this.isPlanHalfBowl(state);
      const baseInterval = this.getPlanBaseIntervalDays(matchDays, isHalf);
      const frequencyDays = Math.round(baseInterval * mult);

      const fullDist = this.getPlanBulkDistribution(mult);
      const flavorPart = this.buildWizardFullPlanFlavorSummaryForCartLine(fullDist);
      const { currentDisplayCents } = this.getRecurringPlanOverviewDisplayAmounts('day');
      const amount = this.formatWizardMoney(Math.round(currentDisplayCents));
      const isNl = this.getWizardPrimaryLocaleCode() === 'nl';

      if (isNl) {
        const inner =
          frequencyDays === 1
            ? `herhaalt elke dag voor ${amount}/dag`
            : `herhaalt elke ${frequencyDays} dagen voor ${amount}/dag`;
        return `${flavorPart} (${inner})`;
      }
      const innerEn =
        frequencyDays === 1
          ? `repeats every day at ${amount}/day`
          : `repeats every ${frequencyDays} days at ${amount}/day`;
      return `${flavorPart} (${innerEn})`;
    }

    /**
     * Trial product subtotal from Shopify **unit price** (variant.price) × bag qty per flavor,
     * or a single trial-pack variant’s unit price when the bundle SKU is used.
     */
    getTrialBaseShopifyProductTotalCents() {
      const state = this.flow.state;
      const fromPack = state.wizardTrialPackBasePriceCents;
      if (fromPack != null && !Number.isNaN(Number(fromPack))) {
        return Math.round(Number(fromPack));
      }
      const trial = state.selectedFlavorsTrial || [];
      const calcs = state.calculations || {};
      const introBagCount = this.getCappedTrialBagCountForWizard(calcs);
      const engine = this.flow.calculationEngine;
      const isHalf = this.isPlanHalfBowl(state);
      const pricing = isHalf
        ? state.variantPricingHalf || state.variantPricing || {}
        : state.variantPricing || {};
      if (!trial.length || !engine) return 0;
      const dist = engine.calculateFlavorDistribution(introBagCount, trial);
      let total = 0;
      FlavorDistribution.forEachFlavorInDistributionOrder(dist, (flavorId, quantity) => {
        const variant = pricing[flavorId];
        if (!variant || variant.price == null) return;
        total += this._variantUnitPriceToCents(variant) * quantity;
      });
      return Math.round(total);
    }

    getWizardTrialProductDiscountPercent() {
      const cfg = window.__wizardCheckoutDiscountCodes || {};
      const isReferral = this.isWizardReferralOrCreatorMode();
      const raw = isReferral ? cfg.referralTrialOrderDiscountPercent : cfg.trialOrderDiscountPercent;
      const p = Number(raw);
      if (Number.isFinite(p) && p >= 0 && p <= 100) return p;
      return isReferral ? 40 : 25;
    }

    /** Trial pack total after TRIAL order discount on the Shopify base subtotal (see getTrialBaseShopifyProductTotalCents). */
    getTrialPriceCents() {
      const pct = this.getWizardTrialProductDiscountPercent();
      const p = Math.min(100, Math.max(0, Number(pct) || 0));

      // Preferred: when we have the actual trial-pack bundle variant price in cents, discount that single line.
      const state = this.flow.state;
      const fromPack = state?.wizardTrialPackBasePriceCents;
      if (fromPack != null && !Number.isNaN(Number(fromPack))) {
        const base = Math.round(Number(fromPack));
        if (base <= 0) return 0;
        // Shopify rounding for % discounts: floor the discount amount per line item, then subtract.
        const discount = Math.floor((base * p) / 100);
        return Math.max(0, base - discount);
      }

      // Fallback: match Shopify-style rounding by discounting per flavor line (then summing).
      // This avoids 1-cent drift vs discounting the total once.
      const trial = state.selectedFlavorsTrial || [];
      const calcs = state.calculations || {};
      const introBagCount = this.getCappedTrialBagCountForWizard(calcs);
      const engine = this.flow.calculationEngine;
      const isHalf = this.isPlanHalfBowl(state);
      const pricing = isHalf
        ? state.variantPricingHalf || state.variantPricing || {}
        : state.variantPricing || {};
      if (!trial.length || !engine) return 0;

      const dist = engine.calculateFlavorDistribution(introBagCount, trial);
      let total = 0;
      FlavorDistribution.forEachFlavorInDistributionOrder(dist, (flavorId, quantity) => {
        const variant = pricing[flavorId];
        if (!variant || variant.price == null) return;
        const lineBase = this._variantUnitPriceToCents(variant) * quantity;
        const discount = Math.floor((lineBase * p) / 100);
        total += Math.max(0, lineBase - discount);
      });
      return Math.round(total);
    }

    getPlanPriceCents() {
      const state = this.flow.state;
      const isHalf = this.isPlanHalfBowl(state);
      const mult = parseInt(String(state.selectedPlan || '1'), 10) || 1;
      const dist = this.getPlanBulkDistribution(mult);
      const pricing = isHalf ? (state.variantPricingHalf || state.variantPricing || {}) : (state.variantPricing || {});
      return this.calculateFullPlanAdditiveDiscountTotalCents(dist, pricing);
    }

    async ensureWizardShippingRatesLoaded() {
      if (window.__wizardShippingRates && typeof window.__wizardShippingRates === 'object') return;
      const url = window.__wizardShippingRatesUrl;
      if (!url) {
        window.__wizardShippingRates = {};
        return;
      }
      try {
        const r = await fetch(url);
        window.__wizardShippingRates = await r.json();
      } catch (e) {
        window.__wizardShippingRates = {};
      }
    }

    getWizardShippingMoneyForCountry() {
      const rates = window.__wizardShippingRates || {};
      const nlDefaults = {
        currency: 'EUR',
        cheapestShipping: 6.99,
        freeShippingThreshold: 70,
        deliveryDays: 1
      };
      const nlRow = rates.NL;
      const nlEffective =
        nlRow && typeof nlRow === 'object'
          ? {
              currency: String(nlRow.currency || 'EUR').toUpperCase(),
              cheapestShipping: Number.isFinite(Number(nlRow.cheapestShipping))
                ? Number(nlRow.cheapestShipping)
                : nlDefaults.cheapestShipping,
              freeShippingThreshold: Number.isFinite(Number(nlRow.freeShippingThreshold))
                ? Number(nlRow.freeShippingThreshold)
                : nlDefaults.freeShippingThreshold,
              deliveryDays: Number.isFinite(Number(nlRow.deliveryDays))
                ? Math.max(0, Math.round(Number(nlRow.deliveryDays)))
                : nlDefaults.deliveryDays
            }
          : { ...nlDefaults };
      const cc = String(
        (typeof window !== 'undefined' && window.__wizardCurrentCountry) || 'NL'
      ).toUpperCase();
      const hasCountryRow = Object.prototype.hasOwnProperty.call(rates, cc) && rates[cc] && typeof rates[cc] === 'object';
      const row = hasCountryRow ? rates[cc] : nlEffective;
      const shipping = Number(row.cheapestShipping);
      const freeShippingThreshold = Number(row.freeShippingThreshold);
      const deliveryDays = Number(row.deliveryDays);
      const currency = String(row.currency || 'EUR').toUpperCase();
      return {
        shipping: Number.isFinite(shipping) ? shipping : nlEffective.cheapestShipping,
        freeShippingThreshold: Number.isFinite(freeShippingThreshold)
          ? freeShippingThreshold
          : nlEffective.freeShippingThreshold,
        deliveryDays: Number.isFinite(deliveryDays)
          ? Math.max(0, Math.round(deliveryDays))
          : nlEffective.deliveryDays,
        currency: currency || 'EUR',
        shippingCountry: cc,
        usedNetherlandsFallback: !hasCountryRow
      };
    }

    /**
     * Transit days for the shopper's country (NL fallback when unknown).
     */
    getWizardDeliveryDaysForCountry(countryCode) {
      if (countryCode != null && String(countryCode).trim()) {
        const rates = window.__wizardShippingRates || {};
        const cc = String(countryCode).toUpperCase();
        const row = rates[cc];
        if (row && Number.isFinite(Number(row.deliveryDays))) {
          return Math.max(0, Math.round(Number(row.deliveryDays)));
        }
      }
      return this.getWizardShippingMoneyForCountry().deliveryDays;
    }

    /**
     * Food-only intro match days from the calculation engine (no shipping, no half-bowl stretch).
     */
    getWizardFoodIntroMatchDays(state) {
      const calcs = (state || this.flow.state).calculations || {};
      return calcs.introMatchDays ?? 21;
    }

    /**
     * Half-bowl stretch applied to food intro days only (no shipping).
     */
    getWizardStretchedFoodIntroMatchDays(state) {
      const s = state || this.flow.state;
      const introMatchDays = this.getWizardFoodIntroMatchDays(s);
      const transitionFoodDays = s.calculations?.transitionFoodDays ?? 3;
      if (!this.isPlanHalfBowl(s)) return introMatchDays;
      return transitionFoodDays + 2 * (introMatchDays - transitionFoodDays);
    }

    /**
     * Food intro days + country shipping (for pet metaobject intromatchdays).
     */
    getWizardIntroMatchDaysForMetaobject(state) {
      return Math.round(
        this.getWizardFoodIntroMatchDays(state) + this.getWizardDeliveryDaysForCountry()
      );
    }

    /**
     * Calculations payload for backend/metaobject: introMatchDays includes shipping transit.
     */
    getWizardCalculationsForPersistence(state) {
      const s = state || this.flow.state;
      const calcs = typeof s.getCalculations === 'function' ? s.getCalculations() : s.calculations || {};
      return {
        ...calcs,
        introMatchDays: this.getWizardIntroMatchDaysForMetaobject(s)
      };
    }

    /**
     * Format cents using shipping-table currency (aligns shipping line with zone currency).
     */
    formatWizardShippingMoney(cents, shippingCurrencyCode) {
      const c = Math.round(Number(cents) || 0);
      const currency = String(shippingCurrencyCode || 'EUR').toUpperCase();
      const locale = this.getWizardFormatLocaleForMoney();
      if (typeof this.formatMoney === 'function') {
        return this.formatMoney(c, currency, locale);
      }
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(c / 100, currency, locale);
      }
      return (c / 100).toFixed(2);
    }

    getStoredWizardProductDiscountCode() {
      try {
        const key = window.__wizardCheckoutDiscountCodes?.storageKey || 'wizard_creator_product_discount';
        return (sessionStorage.getItem(key) || '').trim().toLowerCase();
      } catch (e) {
        return '';
      }
    }

    isWizardReferralOrCreatorMode() {
      const c = this.getStoredWizardProductDiscountCode();
      if (!c) return false;
      const def = String(window.__wizardCheckoutDiscountCodes?.defaultOrderDiscount || 'W4')
        .trim()
        .toLowerCase();
      return c !== def;
    }

    parseDiscountCodeDisplayName(code) {
      const s = String(code || '').trim();
      if (!s) return '';
      const m = s.match(/^([a-zA-Z]+)/);
      if (!m) return '';
      const raw = m[1];
      return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
    }

    /**
     * Set state.presentmentCurrencyCode from Storefront variant payloads (same idea as buybox-2).
     * Clears the code when no variant in memory carries currency (e.g. after country invalidation).
     */
    syncWizardPresentmentCurrencyCode() {
      const state = this.flow?.state;
      if (!state) return;
      const codes = [];
      const push = code => {
        if (code == null || code === '') return;
        const u = String(code).trim().toUpperCase();
        if (u) codes.push(u);
      };
      const walk = map => {
        if (!map || typeof map !== 'object') return;
        Object.values(map).forEach(v => {
          if (!v) return;
          push(v.currency || v.currencyCode);
        });
      };
      walk(state.variantPricing);
      walk(state.variantPricingHalf);
      const gv = state._wizardTransitionGuideVariant;
      if (gv) push(gv.currency || gv.currencyCode);
      const sv = state._wizardScoopFreebieVariant;
      if (sv) push(sv.currency || sv.currencyCode);
      if (codes.length) {
        state.presentmentCurrencyCode = codes[0];
      } else {
        state.presentmentCurrencyCode = null;
      }
    }

    getWizardPresentmentCurrencyCode() {
      const state = this.flow?.state;
      if (state && !state.presentmentCurrencyCode) {
        this.syncWizardPresentmentCurrencyCode();
      }
      if (state?.presentmentCurrencyCode) {
        return String(state.presentmentCurrencyCode).toUpperCase();
      }
      const active = typeof window !== 'undefined' && window.Shopify?.currency?.active;
      if (active) return String(active).toUpperCase();
      return 'EUR';
    }

    getWizardFormatLocaleForMoney() {
      if (typeof window === 'undefined') return null;
      return (
        window.__wizardCurrentLocaleFull ||
        window.__wizardCurrentLocale ||
        window.__wizard1CurrentLocaleFull ||
        window.__wizard1CurrentLocale ||
        null
      );
    }

    formatWizardMoney(cents) {
      const c = Math.round(Number(cents) || 0);
      const currency = this.getWizardPresentmentCurrencyCode();
      const locale = this.getWizardFormatLocaleForMoney();
      if (typeof this.formatMoney === 'function') {
        return this.formatMoney(c, currency, locale);
      }
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(c / 100, currency, locale);
      }
      return (c / 100).toFixed(2);
    }

    wizardEscapeHtml(s) {
      const d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }

    /**
     * Compare (strikethrough) + final (green) only when final is below compare; otherwise one gray undiscounted price.
     * @param {number} compareCents
     * @param {number} finalCents
     * @param {{ summaryTotal?: boolean, currencyCode?: string }} [options]
     * @returns {string} HTML fragment
     */
    wizardOfferPricePairHtml(compareCents, finalCents, options = {}) {
      const fmt =
        options.currencyCode
          ? c => this.formatWizardShippingMoney(c, options.currencyCode)
          : c => this.formatWizardMoney(c);
      const cmp = Math.round(Number(compareCents) || 0);
      const fin = Math.round(Number(finalCents) || 0);
      const summaryTotal = !!options.summaryTotal;
      if (fin < cmp) {
        const finalClasses = summaryTotal
          ? 'wizard-offer-price wizard-offer-price--final wizard-offer-price--summary-total'
          : 'wizard-offer-price wizard-offer-price--final';
        return `<span class="wizard-offer-price wizard-offer-price--compare">${fmt(cmp)}</span><span class="${finalClasses}">${fmt(fin)}</span>`;
      }
      const singleClasses = summaryTotal
        ? 'wizard-offer-price wizard-offer-price--undiscounted wizard-offer-price--summary-total'
        : 'wizard-offer-price wizard-offer-price--undiscounted';
      return `<span class="${singleClasses}">${fmt(fin)}</span>`;
    }

    /**
     * Effective bundle discount % for trial (compare vs final for product + shipping + freebies).
     * Populated in updatePlanOverviewContent as this._w2TrialBundle.
     */
    getWizardTrialOrderDiscountPercent() {
      if (this._w2TrialBundle && this._w2TrialBundle.pct != null) return this._w2TrialBundle.pct;
      return 25;
    }

    getWizardFullPlanBundleDiscountPercent() {
      if (this._w2FullBundle && this._w2FullBundle.pct != null) return this._w2FullBundle.pct;
      return 0;
    }

    async buildWizardPlanBundleTotals() {
      const state = this.flow.state;
      const config = this.flow.config || this.flow.getConfig?.() || {};
      await this.ensureWizardShippingRatesLoaded();
      const shipMoney = this.getWizardShippingMoneyForCountry();
      const shippingCompareCents = Math.round(Number(shipMoney.shipping) * 100);
      const freeThresholdCents = Math.round(Number(shipMoney.freeShippingThreshold) * 100);

      const freebieDiscPct = config.transitionGuideAutomaticDiscountPercent ?? 100;

      let guideCompareCents = 0;
      let guideFinalCents = 0;
      const fid = config.freebieVariantId;
      if (fid && this.flow.shopifyAPI?.getVariant) {
        let gv = state._wizardTransitionGuideVariant;
        if (!gv) {
          try {
            gv = await this.flow.shopifyAPI.getVariant(fid);
            state._wizardTransitionGuideVariant = gv;
          } catch (e) {}
        }
        if (gv) {
          const guideOffer = this._wizardFreebieOfferCents(gv, freebieDiscPct);
          guideCompareCents = guideOffer.compareCents;
          guideFinalCents = guideOffer.finalCents;
        }
      }

      let scoopCompareCents = 0;
      let scoopFinalCents = 0;
      const scoopId = config.scoopFreebieVariantId;
      if (scoopId && this.flow.shopifyAPI?.getVariant) {
        let sv = state._wizardScoopFreebieVariant;
        if (!sv) {
          try {
            sv = await this.flow.shopifyAPI.getVariant(scoopId);
            state._wizardScoopFreebieVariant = sv;
          } catch (e) {}
        }
        if (sv) {
          const scoopOffer = this._wizardFreebieOfferCents(sv, freebieDiscPct);
          scoopCompareCents = scoopOffer.compareCents;
          scoopFinalCents = scoopOffer.finalCents;
        }
      }

      const productCompareCents = this.getTrialCompareAtTotalCents();
      const productFinalCents = this.getTrialPriceCents();
      const trialCompareTotal =
        productCompareCents + shippingCompareCents + guideCompareCents + scoopCompareCents;
      const trialFinalTotal = productFinalCents + 0 + guideFinalCents + scoopFinalCents;
      const trialPct =
        trialCompareTotal > 0
          ? Math.round(((trialCompareTotal - trialFinalTotal) / trialCompareTotal) * 100)
          : 0;

      const isHalf = this.isPlanHalfBowl(state);
      const mult = parseInt(String(state.selectedPlan || '1'), 10) || 1;
      const pricing = isHalf
        ? state.variantPricingHalf || state.variantPricing || {}
        : state.variantPricing || {};
      const dist = this.getPlanBulkDistribution(mult);
      const fullProductCompare = this.calculateCompareAtTotalCents(dist, pricing);
      const fullProductFinal = this.calculateFullPlanAdditiveDiscountTotalCents(dist, pricing);
      const shipFinalFull = fullProductFinal >= freeThresholdCents ? 0 : shippingCompareCents;
      const fullCompareTotal = fullProductCompare + shippingCompareCents;
      const fullFinalTotal = fullProductFinal + shipFinalFull;
      const fullPct =
        fullCompareTotal > 0
          ? Math.round(((fullCompareTotal - fullFinalTotal) / fullCompareTotal) * 100)
          : 0;

      return {
        trial: {
          compareTotal: trialCompareTotal,
          finalTotal: trialFinalTotal,
          pct: trialPct,
          productCompareCents,
          productFinalCents,
          shippingCompareCents,
          shippingFinalCents: 0,
          guideCompareCents,
          guideFinalCents,
          scoopCompareCents,
          scoopFinalCents
        },
        full: {
          compareTotal: fullCompareTotal,
          finalTotal: fullFinalTotal,
          pct: fullPct,
          productCompareCents: fullProductCompare,
          productFinalCents: fullProductFinal,
          shippingCompareCents,
          shippingFinalCents: shipFinalFull
        },
        shippingCompareCents,
        freeThresholdCents,
        shippingCurrency: shipMoney.currency
      };
    }

    updateWizardPlanOfferStacksAndSummaries(bundleData) {
      const fmt = c => this.formatWizardMoney(c);
      const t = bundleData.trial;
      const f = bundleData.full;
      const shipLabel = this.getLocaleString?.('quiz.steps.plan_overview.offer_stack_shipping') || 'Shipping';
      const guideLabel = this.getLocaleString?.('quiz.steps.plan_overview.offer_stack_transition') || 'Transition guide';
      const scoopLabel = this.getLocaleString?.('quiz.steps.plan_overview.offer_stack_scoop') || 'Scoop';

      const trialProductPrices = this.currentStepElement?.querySelector('[data-wizard-trial-product-prices]');
      if (trialProductPrices) {
        trialProductPrices.innerHTML = this.wizardOfferPricePairHtml(t.productCompareCents, t.productFinalCents);
      }
      const trialDyn = this.currentStepElement?.querySelector('[data-wizard-trial-offer-dynamic]');
      if (trialDyn) {
        trialDyn.innerHTML = `
          <div class="wizard-offer-row">
            <span class="wizard-offer-row__label">${this.wizardEscapeHtml(shipLabel)}</span>
            <div class="wizard-offer-row__prices">
              ${this.wizardOfferPricePairHtml(t.shippingCompareCents, t.shippingFinalCents, {
                currencyCode: bundleData.shippingCurrency
              })}
            </div>
          </div>
          <div class="wizard-offer-row">
            <span class="wizard-offer-row__label">${this.wizardEscapeHtml(guideLabel)}</span>
            <div class="wizard-offer-row__prices">
              ${this.wizardOfferPricePairHtml(t.guideCompareCents, t.guideFinalCents)}
            </div>
          </div>
          <div class="wizard-offer-row">
            <span class="wizard-offer-row__label">${this.wizardEscapeHtml(scoopLabel)}</span>
            <div class="wizard-offer-row__prices">
              ${this.wizardOfferPricePairHtml(t.scoopCompareCents, t.scoopFinalCents)}
            </div>
          </div>`;
      }
      const trialStack = this.currentStepElement?.querySelector('[data-wizard-trial-offer-stack]');
      if (trialStack) trialStack.hidden = false;

      const trialSave = Math.max(0, t.compareTotal - t.finalTotal);
      const trialSum = this.currentStepElement?.querySelector('[data-wizard-trial-summary]');
      if (trialSum) {
        const lbl = this.getLocaleString?.('quiz.steps.plan_overview.summary_first_shipment') || 'First shipment';
        const badge = this.getLocaleString?.('quiz.steps.plan_overview.summary_savings_badge', {
          amount: fmt(trialSave)
        }) || '';
        trialSum.innerHTML = `
          <div class="wizard-plan-summary__row">
            <span class="wizard-plan-summary__label">${this.wizardEscapeHtml(lbl)}</span>
            <div class="wizard-plan-summary__right">
              <div class="wizard-plan-summary__badge wizard-plan-card-savings-badge">${badge}</div>
              <div class="wizard-plan-summary__amounts">
                ${this.wizardOfferPricePairHtml(t.compareTotal, t.finalTotal, { summaryTotal: true })}
              </div>
            </div>
          </div>`;
        trialSum.hidden = false;
      }

      const fullProductPrices = this.currentStepElement?.querySelector('[data-wizard-full-product-prices]');
      if (fullProductPrices) {
        fullProductPrices.innerHTML = this.wizardOfferPricePairHtml(f.productCompareCents, f.productFinalCents);
      }
      const fullDyn = this.currentStepElement?.querySelector('[data-wizard-full-offer-dynamic]');
      if (fullDyn) {
        fullDyn.innerHTML = `
          <div class="wizard-offer-row">
            <span class="wizard-offer-row__label">${this.wizardEscapeHtml(shipLabel)}</span>
            <div class="wizard-offer-row__prices">
              ${this.wizardOfferPricePairHtml(f.shippingCompareCents, f.shippingFinalCents, {
                currencyCode: bundleData.shippingCurrency
              })}
            </div>
          </div>`;
      }
      const fullStack = this.currentStepElement?.querySelector('[data-wizard-full-offer-stack]');
      if (fullStack) fullStack.hidden = false;

      const fullSave = Math.max(0, f.compareTotal - f.finalTotal);
      const fullSum = this.currentStepElement?.querySelector('[data-wizard-full-summary]');
      if (fullSum) {
        const lbl = this.getLocaleString?.('quiz.steps.plan_overview.summary_future_shipments') || 'Future shipments';
        const badge = this.getLocaleString?.('quiz.steps.plan_overview.summary_savings_badge', {
          amount: fmt(fullSave)
        }) || '';
        fullSum.innerHTML = `
          <div class="wizard-plan-summary__row">
            <span class="wizard-plan-summary__label">${this.wizardEscapeHtml(lbl)}</span>
            <div class="wizard-plan-summary__right">
              <div class="wizard-plan-summary__badge wizard-plan-card-savings-badge">${badge}</div>
              <div class="wizard-plan-summary__amounts">
                ${this.wizardOfferPricePairHtml(f.compareTotal, f.finalTotal, { summaryTotal: true })}
              </div>
            </div>
          </div>`;
        fullSum.hidden = false;
      }
    }

    /**
     * Stable JSON fingerprint for inputs that affect `buildWizardPlanBundleTotals` trial %.
     * Persisted next to `wizardOfferBarPct` so we know when to invalidate the saved %.
     */
    buildWizardPricingFingerprint() {
      const s = this.flow.state;
      const country = String((typeof window !== 'undefined' && window.__wizardCurrentCountry) || 'NL').toUpperCase();
      const payload = {
        country,
        petData: { ...s.petData },
        calculations: { ...s.calculations },
        selectedFlavorsTrial: [...(s.selectedFlavorsTrial || [])].sort(),
        selectedFlavorsFull: [...(s.selectedFlavorsFull || [])].sort(),
        selectedPlan: s.selectedPlan,
        planBowlValue: s.planBowlValue
      };
      return JSON.stringify(payload);
    }

    updateWizardOfferBarForPlanOverview() {
      if (window.BzWizard && window.BzWizard.id() === 'w3' && window.WizardW3) {
        window.WizardW3.syncShell(this.flow.state.getCurrentStep?.());
        return;
      }
      if (window.BzWizard && window.BzWizard.id() === 'w5' && window.WizardW5) {
        window.WizardW5.paintOffer(this);
        return;
      }
      const el = document.querySelector('[data-wizard-offer-text]');
      if (!el) return;
      const state = this.flow.state;
      if (window.WizardHousehold && window.WizardHousehold.releaseLargeDogOfferIfLight) {
        window.WizardHousehold.releaseLargeDogOfferIfLight(this);
      }
      if (window.BzWizard && window.BzWizard.id() === 'w4' && state.largeDogOffer === 'accept' && state.combinedWeightKg() >= 30) {
        const large = window.__wizardPlanCopy && window.__wizardPlanCopy.offer && window.__wizardPlanCopy.offer.large;
        if (large) {
          el.innerHTML = window.__wizardUnescapeHtml ? window.__wizardUnescapeHtml(large) : large;
          return;
        }
      }
      const fpNow = this.buildWizardPricingFingerprint();
      const savedFp = state.wizardOfferBarFingerprint;
      const savedPct = state.wizardOfferBarPct;
      let pct = null;
      if (typeof savedFp === 'string' && savedFp === fpNow && savedPct != null && Number.isFinite(Number(savedPct))) {
        pct = Math.round(Number(savedPct));
      } else if (this._w2TrialBundleFingerprint === fpNow && this._w2TrialBundle?.pct != null) {
        pct = Math.round(Number(this._w2TrialBundle.pct));
      }
      if (pct == null || !Number.isFinite(pct)) {
        // Before plan overview: show referral/creator offer bar using a stable % (e.g. 50%),
        // including optional "from Name" suffix based on discount code parsing.
        if (this.isWizardReferralOrCreatorMode()) {
          const cfg = window.__wizardCheckoutDiscountCodes || {};
          const pre = Number(cfg.referralOfferBarPercentBeforePlanOverview);
          const pctPre = Number.isFinite(pre) ? Math.round(pre) : 50;
          const pctStr = String(pctPre);
          const name = this.parseDiscountCodeDisplayName(this.getStoredWizardProductDiscountCode());
          const vars = { percent: pctStr };
          let key = 'quiz.wizard.offer.referral_offer_bar';
          if (name) {
            key = 'quiz.wizard.offer.referral_offer_bar_named';
            vars.name = name;
          }
          const out = this.getLocaleString?.(key, vars) || '';
          if (out && !out.startsWith('quiz.')) {
            el.textContent = out;
            return;
          }
        }

        if (window.__wizardDefaultOfferBarText != null) {
          el.innerHTML = window.__wizardUnescapeHtml
            ? window.__wizardUnescapeHtml(window.__wizardDefaultOfferBarText)
            : window.__wizardDefaultOfferBarText;
        }
        return;
      }
      const pctStr = String(pct);
      const referral = this.isWizardReferralOrCreatorMode();
      const name = this.parseDiscountCodeDisplayName(this.getStoredWizardProductDiscountCode());
      let key = 'quiz.wizard.offer.plan_overview_evergreen';
      const vars = { percent: pctStr };
      if (referral && name) {
        key = 'quiz.wizard.offer.plan_overview_referral_named';
        vars.name = name;
      } else if (referral) {
        key = 'quiz.wizard.offer.plan_overview_referral';
      }
      const out = this.getLocaleString?.(key, vars) || '';
      if (out && !out.startsWith('quiz.')) {
        el.textContent = out;
      } else if (window.__wizardDefaultOfferBarText != null) {
        el.innerHTML = window.__wizardUnescapeHtml
          ? window.__wizardUnescapeHtml(window.__wizardDefaultOfferBarText)
          : window.__wizardDefaultOfferBarText;
      }
    }

    updateWizardFullPlanDescriptionHtml() {
      const el = this.currentStepElement?.querySelector('[data-full-plan-description]');
      if (!el) return;
      const mult = parseInt(String(this.flow.state.selectedPlan || '1'), 10) || 1;
      const titleText = this.getSellingPlanTitleForMultiplier(mult);
      const titleLower = String(titleText || '').toLowerCase();
      const hint = this.getLocaleString?.('quiz.steps.plan_overview.bulk_modal_trigger_aria') || '';
      const btnLabel = this.wizardEscapeHtml(titleLower);
      const aria = hint ? `${titleText}. ${hint}` : titleText;
      const btn = `<button type="button" class="link underlined-link wizard-full-plan-bulk-link" data-wizard-open-bulk-modal aria-label="${this.wizardEscapeHtml(aria)}"><span>${btnLabel}</span></button>`;
      const tpl = this.getLocaleString?.('quiz.steps.plan_overview.full_plan_description_html') || '';
      if (tpl && tpl.indexOf('%{plan_title}') >= 0) {
        el.innerHTML = tpl.replace('%{plan_title}', btn);
      } else {
        el.textContent = (this.getLocaleString?.('quiz.steps.plan_overview.full_plan_description') || '')
          .replace(/%\{pet_name\}/g, this.flow.state.getPetData().name || '');
      }
    }

    /** Trial product line “compare” = Shopify base subtotal (unit price × qty) before TRIAL %. */
    getTrialCompareAtTotalCents() {
      return this.getTrialBaseShopifyProductTotalCents();
    }

    normalizeStickyTrialAmountCents(packTotalCents, period, effectiveIntroDays) {
      const c = Number(packTotalCents) || 0;
      if (c <= 0) return 0;
      const eff = Math.max(1, Math.round(Number(effectiveIntroDays) || 1));
      const p = period || 'day';
      if (p === 'day') return c / eff;
      if (p === 'week') return (c / eff) * 7;
      return c;
    }

    /**
     * Per-period display amount in cents (before formatMoney). Matches footer / recurring line logic.
     * @param {number} shipmentTotalCents - full shipment subscription total
     * @param {number} intervalDays - calendar days that shipment covers
     * @param {string} period - 'day' | 'week' | 'shipment'
     */
    getPlanBulkDisplayCents(shipmentTotalCents, intervalDays, period) {
      const p = period || 'day';
      const id = Math.max(0, Math.round(Number(intervalDays) || 0));
      const c = Number(shipmentTotalCents) || 0;
      if (p === 'day' && id > 0) return c / id;
      if (p === 'week' && id > 0) return (c / id) * 7;
      return c;
    }

    escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    escapeAttr(str) {
      return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }

    isPlanHalfBowl(state) {
      const s = state || this.flow.state;
      const vals = s.planBowlOptionValues;
      const v = s.planBowlValue;
      if (!v) return false;
      if (vals && vals.length >= 2) return v === vals[1];
      return String(v).trim().toLowerCase() === 'half';
    }

    getPlanBowlMeta(state) {
      return this.isPlanHalfBowl(state) ? 'half-plan' : 'full-plan';
    }

    getPetDataForMetaobject(state) {
      const s = state || this.flow.state;
      return {
        ...s.getPetData(),
        planBowl: this.getPlanBowlMeta(s),
      };
    }

    /**
     * Calendar days one shipment is meant to cover (1× bulk), before 2×/3× multipliers.
     * Full plan: matchDays. Half plan: same bag count but half portions → food lasts ~2× longer → 2× matchDays.
     */
    getPlanBaseIntervalDays(matchDays, isHalf) {
      const m = Math.round(Number(matchDays) || 54);
      return isHalf ? m * 2 : m;
    }

    /**
     * Calendar days for trial period: half-bowl food stretch, then + country shipping transit.
     */
    getEffectiveIntroMatchDays(state) {
      const stretchedFood = this.getWizardStretchedFoodIntroMatchDays(state);
      const shippingDays = this.getWizardDeliveryDaysForCountry();
      return Math.round(stretchedFood + shippingDays);
    }

    /**
     * Customer-visible next-shipment line property value: "in X days" / "over X dagen" (singular/plural).
     * @param {number} offsetDays - Same basis as getEffectiveIntroMatchDays (food stretch + shipping transit).
     * @returns {string}
     */
    buildNextShipmentRelativePropertyValue(offsetDays) {
      const n = Math.max(0, Math.round(Number(offsetDays)));
      const labels =
        typeof window !== 'undefined' && window.__wizardCartLinePropertyLabels
          ? window.__wizardCartLinePropertyLabels
          : {};
      const useSingular = n === 1;
      const key = useSingular ? 'next_shipment_value_singular' : 'next_shipment_value_plural';
      let template = labels[key] != null ? String(labels[key]).trim() : '';
      if (!template) {
        const primary = this.getWizardPrimaryLocaleCode();
        template =
          primary === 'nl'
            ? useSingular
              ? 'over %{count} dag'
              : 'over %{count} dagen'
            : useSingular
              ? 'in %{count} day'
              : 'in %{count} days';
      }
      return template.replace(/%\{count\}/g, String(n));
    }

    /**
     * Visible cart line property name for next shipment date (locale from theme `| t`, else fallback).
     */
    getNextShipmentLinePropertyLabel() {
      const fromTheme =
        typeof window !== 'undefined' && window.__wizardCartLinePropertyLabels?.next_shipment != null
          ? String(window.__wizardCartLinePropertyLabels.next_shipment).trim()
          : '';
      if (fromTheme) return fromTheme;
      const raw =
        (typeof window !== 'undefined' && window.__wizardCurrentLocale) ||
        (typeof document !== 'undefined' && document.documentElement?.getAttribute?.('lang')) ||
        'en';
      const primary = String(raw).split('-')[0].toLowerCase();
      return primary === 'nl' ? 'Volgende levering' : 'Next shipment';
    }

    /**
     * Visible cart line property for trial intro (locale from theme `| t`, else fallback).
     */
    getTrialForLinePropertyLabel() {
      const fromTheme =
        typeof window !== 'undefined' && window.__wizardCartLinePropertyLabels?.trial_for != null
          ? String(window.__wizardCartLinePropertyLabels.trial_for).trim()
          : '';
      if (fromTheme) return fromTheme;
      const raw =
        (typeof window !== 'undefined' && window.__wizardCurrentLocale) ||
        (typeof document !== 'undefined' && document.documentElement?.getAttribute?.('lang')) ||
        'en';
      const primary = String(raw).split('-')[0].toLowerCase();
      return primary === 'nl' ? 'Transitieplan voor' : 'Transition plan for';
    }

    /**
     * English indefinite article before a noun phrase (e.g. "18kg adult Border Collie").
     * @param {string} phrase
     * @returns {'a'|'an'}
     */
    englishIndefiniteArticleBeforePhrase(phrase) {
      const s = String(phrase || '').trim();
      if (!s) return 'a';
      const first = s[0].toLowerCase();
      if ('aeiou'.includes(first)) return 'an';
      if (/^\d/.test(s)) {
        const m = /^(\d+)/.exec(s);
        const digits = m ? m[1] : '';
        const n = digits ? parseInt(digits, 10) : 0;
        if (digits && digits[0] === '8') return 'an';
        if (n === 11 || n === 18) return 'an';
        return 'a';
      }
      return 'a';
    }

    /**
     * Primary locale for Wizard 2 copy (nl vs default en).
     * @returns {'nl'|'en'}
     */
    getWizardPrimaryLocaleCode() {
      const raw =
        (typeof window !== 'undefined' && window.__wizardCurrentLocale) ||
        (typeof window !== 'undefined' && window.__wizard1CurrentLocale) ||
        (typeof document !== 'undefined' && document.documentElement?.getAttribute?.('lang')) ||
        'en';
      return String(raw).split('-')[0].toLowerCase() === 'nl' ? 'nl' : 'en';
    }

    /**
     * Short age word for profile "suitable for" (lowercase, no month/year ranges).
     * @param {Object} petData
     * @returns {string}
     */
    getWizardProfileSuitableAgeDescriptor(petData) {
      const ag = petData?.ageGroup;
      if (ag == null || String(ag).trim() === '') return '';
      const slug = String(ag).trim();
      const key = `quiz.steps.plan_overview.profile_age_${slug}`;
      const raw = (this.getLocaleString?.(key) || '').trim();
      if (!raw) return '';
      return raw.charAt(0).toLowerCase() + raw.slice(1);
    }

    /**
     * Breed shown in profile summary: list label by locale, else custom typed breed, else dog/hond.
     * "Don't know" / mixed-breed options use fallback (dog/hond), not "Weet ik niet" / "Mixed".
     * @param {Object} petData
     * @returns {string}
     */
    getWizardProfileSuitableBreedDisplay(petData) {
      const fallback = (
        this.getLocaleString?.('quiz.steps.plan_overview.profile_suitable_breed_fallback') || 'dog'
      ).trim();

      if (petData?.breedUnknown || petData?.breedMixed) {
        return fallback;
      }

      const raw = (petData?.breed && String(petData.breed).trim()) || '';
      if (!raw) {
        return fallback;
      }

      if (raw === 'dont_know' || raw === 'mixed') {
        return fallback;
      }

      if (raw === 'other') {
        return (this.getLocaleString?.('quiz.steps.breed.option_other') || raw).trim();
      }

      const breeds = typeof window !== 'undefined' ? window.Wizard1Breeds : null;
      if (Array.isArray(breeds)) {
        const breedObj = breeds.find(b => b.value === raw);
        if (breedObj) {
          if (breedObj.value === 'dont_know' || breedObj.value === 'mixed') {
            return fallback;
          }
          const loc = this.getWizardPrimaryLocaleCode();
          const labelKey = loc === 'nl' ? 'label_nl' : 'label_en';
          return (breedObj[labelKey] || breedObj.label_en || raw).trim();
        }
      }
      return raw;
    }

    /**
     * Map stored allergy values (checkbox / API) to the same labels as the allergies step (`quiz.steps.allergies.option_*`).
     * Canonical: kip, rund, zalm, wit_kleine_vis; legacy tokens normalized via same keys where applicable.
     * @param {string} storedValue
     * @returns {string}
     */
    getAllergenDisplayLabelForLocale(storedValue) {
      const raw = String(storedValue ?? '').trim();
      if (!raw) return '';
      const k = raw.toLowerCase();
      /** @type {Record<string, string>} */
      const toLocaleKey = {
        gevogelte: 'quiz.steps.allergies.option_poultry',
        poultry: 'quiz.steps.allergies.option_poultry',
        chicken: 'quiz.steps.allergies.option_poultry',
        kip: 'quiz.steps.allergies.option_poultry',
        rund: 'quiz.steps.allergies.option_beef',
        beef: 'quiz.steps.allergies.option_beef',
        zalm: 'quiz.steps.allergies.option_salmon',
        salmon: 'quiz.steps.allergies.option_salmon',
        wit_kleine_vis: 'quiz.steps.allergies.option_white_small_fish',
        witvis: 'quiz.steps.allergies.option_white_small_fish',
        whitefish: 'quiz.steps.allergies.option_white_small_fish',
        vis: 'quiz.steps.allergies.option_white_small_fish',
        lam: 'quiz.steps.allergies.option_lamb',
        lamb: 'quiz.steps.allergies.option_lamb',
        eend: 'quiz.steps.allergies.option_duck',
        duck: 'quiz.steps.allergies.option_duck'
      };
      const localeKey = toLocaleKey[k];
      if (localeKey) {
        const label = (this.getLocaleString?.(localeKey) || '').trim();
        if (label) return label;
      }
      return raw;
    }

    /**
     * Capitalise first letter only (rest unchanged).
     * @param {string} raw
     * @returns {string}
     */
    capitalizeProfileBowlName(raw) {
      const s = String(raw || '').trim();
      if (!s) return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    /**
     * Bowl label: max 7 graphemes + … when length ≥ 8 (after capitalisation).
     * @param {string} raw
     * @returns {string}
     */
    formatProfileBowlDisplayName(raw) {
      const full = this.capitalizeProfileBowlName(raw);
      if (!full) return '';
      if (full.length >= 8) {
        return full.slice(0, 7) + '\u2026';
      }
      return full;
    }

    getWizardProfileSuitableForText(petData) {
      const weight =
        petData?.weight != null && Number(petData.weight) > 0
          ? `${Math.round(Number(petData.weight))}kg`
          : '';
      const age = this.getWizardProfileSuitableAgeDescriptor(petData);
      const breed = this.getWizardProfileSuitableBreedDisplay(petData);
      const parts = [weight, age, breed].filter(Boolean);
      const sentence = parts.join(' ');
      const isNl = this.getWizardPrimaryLocaleCode() === 'nl';
      if (isNl) {
        return (
          this.getLocaleString?.('quiz.steps.plan_overview.profile_suitable_for', { sentence }) ||
          `Perfect voor een ${sentence}`
        );
      }
      const article = this.englishIndefiniteArticleBeforePhrase(sentence);
      return (
        this.getLocaleString?.('quiz.steps.plan_overview.profile_suitable_for', { article, sentence }) ||
        `Perfect for ${article} ${sentence}`
      );
    }

    /**
     * Wizard 2 trial checkout: one trial-pack line (Proefpakket) + Firmhouse trial selling plan; full recurring plan id in `_full_selling_plan`.
     * Hidden: `_subscription_products` (full-plan variants only), `_plan_type`, `_next_shipment_offset_days` (= X in visible "Over X dagen"),
     * `_full_selling_plan`, `_acquisition_flow`, `_pet_name`. One visible property: name ⤷ Daarna/After that for {pet}; value flavors + (repeat every N days + daily price).
     * @returns {Object} cartItems, distribution (trial), frequencyDays, fullPlanBagCount, trialVariantId, …
     */
    buildWizardTrialSubscriptionCartItems() {
      const state = this.flow.state;
      const config = typeof this.flow.getConfig === 'function' ? this.flow.getConfig() : this.flow.config;
      const petData = state.getPetData();
      const calculations = state.getCalculations();
      const selectedFlavorsTrial = state.selectedFlavorsTrial || [];
      const engine = this.flow.calculationEngine;

      if (!petData.name || !selectedFlavorsTrial.length || !calculations.matchDays) {
        throw new Error('Missing required data for cart');
      }

      const trialBagCount = this.getCappedTrialBagCountForWizard(calculations);
      const distribution = engine.calculateFlavorDistribution(trialBagCount, selectedFlavorsTrial);
      const multiplier = parseInt(String(state.selectedPlan || '1'), 10) || 1;
      const matchDays = calculations.matchDays;
      const isHalf = this.isPlanHalfBowl(state);
      const baseInterval = this.getPlanBaseIntervalDays(matchDays, isHalf);
      const frequencyDays = Math.round(baseInterval * multiplier);
      const fullPlanMap = config.sellingPlanMapping || {};
      const fullPlanSellingPlanId = fullPlanMap[String(frequencyDays)] || fullPlanMap[frequencyDays];

      if (!fullPlanSellingPlanId) {
        throw new Error(`No selling plan found for ${frequencyDays} days`);
      }

      const trialPlanMap = config.trialSellingPlanMapping || {};
      const nextShipmentOffsetDays = Math.round(Number(this.getEffectiveIntroMatchDays(state)));
      if (nextShipmentOffsetDays > 100) {
        throw new Error(`No trial selling plan for ${nextShipmentOffsetDays} days (maximum is 100)`);
      }
      const trialSellingPlanId =
        trialPlanMap[String(nextShipmentOffsetDays)] || trialPlanMap[nextShipmentOffsetDays];

      if (!trialSellingPlanId) {
        throw new Error(`No trial selling plan for ${nextShipmentOffsetDays} days`);
      }

      const fullPlanDist = this.getPlanBulkDistribution(multiplier);
      const fullPlanBagCount = Object.values(fullPlanDist).reduce((sum, q) => sum + q, 0);

      const petLineProps = this.buildPetLineItemProperties(petData.name, '');

      const subscriptionProducts = [];
      const portion = state.planPortion === 'mostly' ? 'mostly' : 'complete';
      const combinedKg = typeof state.combinedWeightKg === 'function' ? state.combinedWeightKg() : Number(petData.weight) || 0;
      const ongoing = config.ongoingVariants || [];
      FlavorDistribution.forEachFlavorInDistributionOrder(fullPlanDist, (flavorId, qty) => {
        if (!qty) return;
        const row = ongoing.find((variant) =>
          variant.flavor === flavorId &&
          variant.portion === portion &&
          combinedKg >= variant.min_kg &&
          combinedKg <= variant.max_kg
        );
        const vidNum = parseInt(String(row && row.shopify_variant_id), 10);
        if (!vidNum) {
          throw new Error(`No ongoing variant for ${flavorId} ${portion} at ${combinedKg} kg`);
        }
        subscriptionProducts.push({
          variant_id: `gid://shopify/ProductVariant/${vidNum}`,
          quantity: qty
        });
      });
      const subscriptionProductsJson = JSON.stringify(subscriptionProducts);

      const bands = config.checkoutBoxVariants || [];
      const band = (window.WizardPlan && window.WizardPlan.checkoutBox && window.BzWizard && window.BzWizard.id() === 'w4')
        ? window.WizardPlan.checkoutBox(this)
        : (bands.find((row) => combinedKg >= row.min_kg && combinedKg <= row.max_kg) || bands[bands.length - 1]);
      const trialVidRaw = band && band.shopify_variant_id;
      const variantId = parseInt(String(trialVidRaw), 10);
      if (!variantId) {
        throw new Error(`No first-box variant for ${combinedKg} kg`);
      }

      const trialCartPropertyName = this.buildWizardTrialCartPropertyName();
      const trialCartPropertyValue = this.buildWizardTrialCartPropertyValue();
      const planBowlMeta = this.getPlanBowlMeta(state);
      const bulkMultiplierMeta = multiplier > 1 ? `${multiplier}x` : '';

      const cartItems = [
        {
          variantId,
          quantity: 1,
          sellingPlanId: trialSellingPlanId,
          properties: {
            ...petLineProps,
            [trialCartPropertyName]: trialCartPropertyValue,
            _plan_type: window.BzWizard.current().pricing.first_box_kind,
            _plan_bowl: planBowlMeta,
            _bulk_multiplier: bulkMultiplierMeta,
            _next_shipment_offset_days: String(nextShipmentOffsetDays),
            _full_selling_plan: String(fullPlanSellingPlanId),
            _subscription_products: subscriptionProductsJson,
            _acquisition_flow: window.BzWizard.flow(),
            _journey_id: window.BzWizard.id(),
            _journey_payload: JSON.stringify(state.ensureDogs ? state.ensureDogs() : [petData]),
            ...(state.petMetaobjectId
              ? { _pet_metaobject_id: String(state.petMetaobjectId) }
              : {})
          }
        }
      ];

      return {
        cartItems,
        distribution,
        frequencyDays,
        fullPlanBagCount,
        matchDays,
        multiplier,
        calculations,
        selectedFlavorsTrial,
        subscriptionProductsJson,
        nextShipmentOffsetDays,
        trialVariantId: variantId
      };
    }

    /**
     * Visible label for bowl size (portion wording). Option `value` stays the Shopify value;
     * labels come from locale so static card copy (e.g. Volledig plan) stays separate.
     */
    planBowlDisplayLabel(optionIndex, rawShopifyValue, totalOptions) {
      if (totalOptions !== 2) return rawShopifyValue != null ? String(rawShopifyValue) : '';
      const fullL = this.getLocaleString?.('quiz.steps.plan_overview.full_plan_subtitle_full');
      const halfL = this.getLocaleString?.('quiz.steps.plan_overview.full_plan_subtitle_half');
      if (optionIndex === 0) return fullL || String(rawShopifyValue);
      if (optionIndex === 1) return halfL || String(rawShopifyValue);
      return String(rawShopifyValue);
    }

    fillPlanBowlSelectFallback(select) {
      if (!select) return;
      const state = this.flow.state;
      const fullL = this.getLocaleString?.('quiz.steps.plan_overview.full_plan_subtitle_full') || 'Full portions';
      const halfL = this.getLocaleString?.('quiz.steps.plan_overview.full_plan_subtitle_half') || 'Half portions';
      const vals = [fullL, halfL];
      state.planBowlOptionValues = vals;
      if (!state.planBowlValue || !vals.includes(state.planBowlValue)) {
        state.planBowlValue = vals[0];
      }
      const sig = 'fallback:' + vals.join('\u0000');
      if (select.dataset.bowlSig !== sig) {
        select.dataset.bowlSig = sig;
        select.innerHTML = vals.map(v => `<option value="${this.escapeAttr(v)}">${this.escapeHtml(v)}</option>`).join('');
      }
      select.value = state.planBowlValue;
      this.syncPlanBowlCustomUI(select);
      this.setupPlanBowlCustomDropdown(select, state);
    }

    /**
     * Rich bowl dropdown: row titles from option text (locale-mapped in ensurePlanBowlProduct), subtitles from locale.
     */
    syncPlanBowlCustomUI(select) {
      const root = this.currentStepElement;
      if (!root || !select) return;
      const dropdown = root.querySelector('[data-plan-bowl-dropdown]');
      const triggers = root.querySelectorAll('[data-plan-bowl-trigger]');
      const labels = root.querySelectorAll('[data-plan-bowl-trigger-label]');
      const fields = root.querySelectorAll('[data-plan-bowl-field]');
      if (!dropdown || triggers.length === 0 || labels.length === 0 || fields.length === 0) return;

      const opts = Array.from(select.options);
      if (opts.length < 2) {
        fields.forEach(f => f.classList.add('wizard-plan-bowl-field--incomplete'));
        dropdown.innerHTML = '';
        const t = opts[0]?.textContent || '';
        labels.forEach(l => { l.textContent = t; });
        return;
      }
      fields.forEach(f => f.classList.remove('wizard-plan-bowl-field--incomplete'));

      const subFull = this.getLocaleString?.('quiz.steps.plan_overview.plan_bowl_subtitle_full') || '';
      const subHalf = this.getLocaleString?.('quiz.steps.plan_overview.plan_bowl_subtitle_half') || '';

      const wrap = document.createElement('div');
      wrap.className = 'wizard-plan-bowl-options';
      wrap.setAttribute('role', 'presentation');

      [0, 1].forEach(idx => {
        const opt = opts[idx];
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'wizard-plan-bowl-row';
        row.setAttribute('role', 'option');
        row.setAttribute('data-plan-bowl-option', '');
        row.setAttribute('data-bowl-index', String(idx));
        row.setAttribute('data-value', opt.value);
        row.id = `wizard-plan-bowl-opt-${idx}`;

        const imgWrap = document.createElement('span');
        imgWrap.className = 'wizard-plan-bowl-row-img';
        const img = document.createElement('img');
        img.src = idx === 0 ? BOWL_URLS.plan.full : BOWL_URLS.plan.half;
        img.width = 44;
        img.height = 44;
        img.alt = '';
        img.className = 'wizard-plan-bowl-thumb';
        img.loading = 'lazy';
        imgWrap.appendChild(img);

        const text = document.createElement('span');
        text.className = 'wizard-plan-bowl-row-text';
        const titleEl = document.createElement('span');
        titleEl.className = 'wizard-plan-bowl-row-title';
        titleEl.textContent = opt.textContent;
        const subEl = document.createElement('span');
        subEl.className = 'wizard-plan-bowl-row-sub';
        subEl.textContent = idx === 0 ? subFull : subHalf;
        text.appendChild(titleEl);
        text.appendChild(subEl);
        row.appendChild(imgWrap);
        row.appendChild(text);
        wrap.appendChild(row);
      });

      dropdown.innerHTML = '';
      dropdown.appendChild(wrap);

      const si = select.selectedIndex >= 0 ? select.selectedIndex : 0;
      const labelText = opts[si]?.textContent || '';
      labels.forEach(l => { l.textContent = labelText; });
      this._updatePlanBowlRowVisualState(select);
    }

    _updatePlanBowlRowVisualState(select) {
      const root = this.currentStepElement;
      const dropdown = root?.querySelector('[data-plan-bowl-dropdown]');
      if (!dropdown || !select) return;
      const rows = dropdown.querySelectorAll('[data-plan-bowl-option]');
      if (!rows.length) return;
      const sel = Math.max(0, select.selectedIndex);
      rows.forEach((row, i) => {
        const selected = i === sel;
        row.classList.toggle('wizard-plan-bowl-row--selected', selected);
        row.classList.toggle('wizard-plan-bowl-row--unselected', !selected);
        row.classList.toggle('wizard-plan-bowl-row--omit-top', !selected && i === 1 && sel === 0);
        row.classList.toggle('wizard-plan-bowl-row--omit-bottom', !selected && i === 0 && sel === 1);
        row.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    _positionPlanBowlDropdown(select) {
      const root = this.currentStepElement;
      const dd = root?.querySelector('[data-plan-bowl-dropdown]');
      const sel = select || root?.querySelector('[data-plan-bowl-select]');
      const trigger = sel?._w2BowlLastTrigger || root?.querySelector('[data-plan-bowl-trigger]');
      if (!dd || !trigger || !sel) return;
      const tr = trigger.getBoundingClientRect();
      const gap = 8;
      const maxW = Math.min(Math.max(tr.width * 1.2, 280), window.innerWidth - 16);
      dd.style.width = `${Math.round(maxW)}px`;
      let left = tr.left + tr.width / 2 - maxW / 2;
      left = Math.max(gap, Math.min(left, window.innerWidth - maxW - gap));
      dd.style.left = `${Math.round(left)}px`;
      dd.style.right = 'auto';

      let h = dd.getBoundingClientRect().height;
      if (h < 8) h = 220;

      let topPx = tr.bottom + gap;
      const footer = document.querySelector('.quiz-footer');
      const fr = footer?.getBoundingClientRect();
      const wouldOverlapFooter = fr && topPx + h > fr.top - gap;
      if (wouldOverlapFooter) {
        const aboveTop = tr.top - h - gap;
        topPx = Math.max(gap, aboveTop);
      }
      dd.style.top = `${Math.round(topPx)}px`;
    }

    setupPlanBowlCustomDropdown(select, state) {
      if (!select || select.dataset.w2BowlCustomBound === '1') return;
      const root = this.currentStepElement;
      if (!root) return;
      const fields = root.querySelectorAll('[data-plan-bowl-field]');
      const triggers = root.querySelectorAll('[data-plan-bowl-trigger]');
      const dropdown = root.querySelector('[data-plan-bowl-dropdown]');
      if (!fields.length || !triggers.length || !dropdown) return;
      select.dataset.w2BowlCustomBound = '1';

      const isInsideCombo = target =>
        [...fields].some(f => f.contains(target)) || dropdown.contains(target);

      const lastTrigger = () => select._w2BowlLastTrigger || triggers[0];

      const close = () => {
        if (dropdown.hidden) return;
        dropdown.hidden = true;
        triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
        document.removeEventListener('keydown', onDocKey);
        document.removeEventListener('click', onDocClick, true);
      };

      const open = fromTrigger => {
        if (!dropdown.hidden) return;
        select._w2BowlLastTrigger = fromTrigger || triggers[0];
        this.syncPlanBowlCustomUI(select);
        dropdown.hidden = false;
        void dropdown.offsetHeight;
        this._positionPlanBowlDropdown(select);
        requestAnimationFrame(() => this._positionPlanBowlDropdown(select));
        triggers.forEach(t => t.setAttribute('aria-expanded', 'true'));
        setTimeout(() => {
          document.addEventListener('click', onDocClick, true);
          document.addEventListener('keydown', onDocKey);
        }, 0);
      };

      const onDocClick = e => {
        if (isInsideCombo(e.target)) return;
        close();
      };

      const onDocKey = e => {
        if (dropdown.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          lastTrigger().focus();
          return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          const rows = [...dropdown.querySelectorAll('[data-plan-bowl-option]')];
          if (!rows.length) return;
          e.preventDefault();
          const active = document.activeElement;
          let idx = rows.indexOf(active);
          if (idx < 0) idx = select.selectedIndex;
          if (e.key === 'ArrowDown') idx = Math.min(rows.length - 1, idx + 1);
          else idx = Math.max(0, idx - 1);
          rows[idx]?.focus();
        }
      };

      triggers.forEach(trigger => {
        trigger.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          if (dropdown.hidden) open(trigger);
          else close();
        });

        trigger.addEventListener('keydown', e => {
          if (dropdown.hidden && (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            open(trigger);
            const rows = [...dropdown.querySelectorAll('[data-plan-bowl-option]')];
            const i = Math.min(Math.max(0, select.selectedIndex), rows.length - 1);
            rows[i]?.focus();
          }
        });
      });

      dropdown.addEventListener('keydown', e => {
        const row = e.target.closest('[data-plan-bowl-option]');
        if (!row) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          row.click();
        }
      });

      dropdown.addEventListener('click', e => {
        const row = e.target.closest('[data-plan-bowl-option]');
        if (!row) return;
        const val = row.getAttribute('data-value');
        if (val == null) return;
        select.value = val;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const labels = root.querySelectorAll('[data-plan-bowl-trigger-label]');
        const opt = select.options[select.selectedIndex];
        if (opt) labels.forEach(l => { l.textContent = opt.textContent; });
        this._updatePlanBowlRowVisualState(select);
        close();
        lastTrigger().focus();
      });

      if (!window.__wizardPlanBowlResizeBound) {
        window.__wizardPlanBowlResizeBound = () => {
          if (this.flow.state?.currentStep !== 'plan_overview') return;
          const r = this.currentStepElement;
          const dd = r?.querySelector('[data-plan-bowl-dropdown]');
          const sel = r?.querySelector('[data-plan-bowl-select]');
          if (dd && !dd.hidden && sel) this._positionPlanBowlDropdown(sel);
        };
        window.addEventListener('resize', window.__wizardPlanBowlResizeBound);
      }
    }

    extractKomValuesFromVariants(product) {
      const ordered = [];
      const seen = new Set();
      for (const v of product.variants || []) {
        const opts = v.selectedOptions || [];
        const row = opts.find(o => BOWL_OPTION_NAMES.includes(String(o.name).trim().toLowerCase()));
        if (row?.value && !seen.has(row.value)) {
          seen.add(row.value);
          ordered.push(row.value);
        }
      }
      return ordered;
    }

    findBowlProductOption(product) {
      return (product.options || []).find(
        o => o.name && BOWL_OPTION_NAMES.includes(String(o.name).trim().toLowerCase())
      );
    }

    attachPlanBowlSelectListener(select, state) {
      if (!select || select.dataset.w2BowlListener) return;
      select.dataset.w2BowlListener = '1';
      select.addEventListener('change', async () => {
        state.planBowlValue = select.value;
        await this.flow.storage.autoSave(state.getState(), state.customerId);
        await this.updatePlanOverviewContent();
      });
    }

    async ensurePlanBowlProduct(productId) {
      const select = this.currentStepElement?.querySelector('[data-plan-bowl-select]');
      const state = this.flow.state;
      if (select && select.options.length === 0) {
        this.fillPlanBowlSelectFallback(select);
      }

      const pid = productId || this.flow.config.productId || '10659607675144';
      if (!this._w2ProductById) this._w2ProductById = {};
      let product = this._w2ProductById[pid];
      if (!product) {
        try {
          product = await this.flow.shopifyAPI.getProduct(pid);
          this._w2ProductById[pid] = product;
        } catch (e) {
          if (select && select.options.length === 0) this.fillPlanBowlSelectFallback(select);
          this.attachPlanBowlSelectListener(select, state);
          if (select) {
            this.syncPlanBowlCustomUI(select);
            this.setupPlanBowlCustomDropdown(select, state);
          }
          return null;
        }
      }

      if (select && product) {
        let vals = [];
        const bowlOpt = this.findBowlProductOption(product);
        if (bowlOpt?.values?.length) vals = [...bowlOpt.values];
        if (!vals.length) vals = this.extractKomValuesFromVariants(product);

        if (vals.length) {
          const prevVals = state.planBowlOptionValues;
          const wasHalf = prevVals && prevVals.length >= 2 && state.planBowlValue === prevVals[1];
          const prevVal = state.planBowlValue;
          state.planBowlOptionValues = vals;
          const sig = vals.join('\u0000');
          if (select.dataset.bowlSig !== sig) {
            select.dataset.bowlSig = sig;
            select.innerHTML = vals
              .map((v, i) => {
                const label = this.planBowlDisplayLabel(i, v, vals.length);
                return `<option value="${this.escapeAttr(v)}">${this.escapeHtml(label)}</option>`;
              })
              .join('');
          }
          if (!vals.includes(prevVal)) {
            state.planBowlValue = wasHalf && vals.length >= 2 ? vals[1] : vals[0];
          }
          select.value = state.planBowlValue;
        } else if (select.options.length === 0) {
          this.fillPlanBowlSelectFallback(select);
        }
      }

      this.attachPlanBowlSelectListener(select, state);
      if (select) {
        this.syncPlanBowlCustomUI(select);
        this.setupPlanBowlCustomDropdown(select, state);
      }
      return product;
    }

    bindWizardFlavorModal() {
      const flavorModal = document.querySelector('[data-wizard-flavor-modal]');
      if (!flavorModal || flavorModal.dataset.w2FlavorModalBound === '1') return;
      flavorModal.dataset.w2FlavorModalBound = '1';
      flavorModal.addEventListener('click', (e) => {
        if (e.target === flavorModal) this.closeFlavorModal();
      });
      flavorModal.querySelectorAll('[data-wizard-flavor-modal-close]').forEach(btn => {
        btn.addEventListener('click', () => this.closeFlavorModal());
      });
      flavorModal.querySelectorAll('[data-w2-flavor-tab]').forEach(tab => {
        tab.addEventListener('click', () => {
          const t = tab.getAttribute('data-w2-flavor-tab');
          if (!t) return;
          flavorModal.dataset.activeTab = t;
          flavorModal.querySelectorAll('[data-w2-flavor-tab]').forEach(x => {
            x.classList.toggle('wizard-flavor-tab--active', x.getAttribute('data-w2-flavor-tab') === t);
          });
          flavorModal.querySelectorAll('[data-w2-flavor-panel]').forEach(c => {
            c.style.display = c.getAttribute('data-w2-flavor-panel') === t ? '' : 'none';
          });
          this.updateFlavorModalInstruction(t);
          this.updateFlavorModalAllergyWarnings();
          this.syncFlavorModalToState('trial');
          this.syncFlavorModalToState('plan');
          this.updateFlavorModalSelectionDisabledState();
          this.updateFlavorModalSaveButton();
        });
      });
      flavorModal.querySelectorAll('[data-flavor-checkbox-trial], [data-flavor-checkbox-plan]').forEach(input => {
        input.addEventListener('change', (ev) => this.onWizardFlavorModalInputChange(ev));
      });
      flavorModal.querySelector('[data-wizard-flavor-modal-save]')?.addEventListener('click', () => this.saveFlavorModal());
    }

    async updatePlanOverviewContent() {
      this.bindWizardFlavorModal();
      if (window.BzWizard && window.BzWizard.id() === 'w3') return;
      const state = this.flow.state;
      const config = this.flow.config;
      const calcs = state.calculations || {};
      const petData = state.getPetData();
      const productId = config.productId || '10659607675144';
      let product = null;
      try {
        product = await this.ensurePlanBowlProduct(productId);
      } catch (e) {}

      await this.ensureWizardShippingRatesLoaded();

      const isHalf = this.isPlanHalfBowl(state);
      const variantIds = isHalf ? (config.variantIdsHalf || config.variantIds) : config.variantIds;

      const effectiveIntroMatchDays = this.getEffectiveIntroMatchDays(state);
      const matchDays = calcs.matchDays || 54;
      const daysPerBag = calcs.daysPerBag || 28;
      const dailyFoodG = Math.round(calcs.dailyFoodG || 0);

      const trialBowl = this.currentStepElement?.querySelector('[data-trial-bowl]');
      const planBowl = this.currentStepElement?.querySelector('[data-plan-bowl]');
      if (trialBowl) trialBowl.src = BOWL_URLS.trial[isHalf ? 'half' : 'full'];
      if (planBowl) planBowl.src = BOWL_URLS.plan[isHalf ? 'half' : 'full'];

      const productTitle = product?.title || 'Forever Food';
      const trialCardTitle = this.getLocaleString?.('quiz.steps.plan_overview.trial_product_label') || '';
      const fullCardTitle = this.getLocaleString?.('quiz.steps.plan_overview.full_product_label') || '';
      const trialTitleEl = this.currentStepElement?.querySelector('[data-wizard-trial-card] [data-product-title]');
      const fullTitleEl = this.currentStepElement?.querySelector('[data-wizard-full-card] [data-product-title]');
      if (trialTitleEl) trialTitleEl.textContent = trialCardTitle;
      if (fullTitleEl) fullTitleEl.textContent = fullCardTitle;

      const bowlSelect = this.currentStepElement?.querySelector('[data-plan-bowl-select]');
      if (bowlSelect && state.planBowlValue && bowlSelect.value !== state.planBowlValue) {
        bowlSelect.value = state.planBowlValue;
      }
      if (bowlSelect) {
        const trigLabels = this.currentStepElement?.querySelectorAll('[data-plan-bowl-trigger-label]');
        const opt = bowlSelect.selectedIndex >= 0 && bowlSelect.options[bowlSelect.selectedIndex];
        if (opt && trigLabels?.length) {
          trigLabels.forEach(l => { l.textContent = opt.textContent; });
        }
        this._updatePlanBowlRowVisualState(bowlSelect);
      }

      const trialDesc = this.currentStepElement?.querySelector('[data-trial-description]');
      if (trialDesc) {
        const rawPet = String(petData?.name || '').trim();
        const petNameForTrial = this.formatProfileBowlDisplayName(rawPet) || rawPet;
        trialDesc.textContent = this.getLocaleString?.('quiz.steps.plan_overview.trial_description', {
          pet_name: petNameForTrial,
          intro_match_days: String(effectiveIntroMatchDays)
        }) || '';
      }

      const trialInDays = this.currentStepElement?.querySelector('[data-delivery-trial-in-days]');
      if (trialInDays) trialInDays.textContent = (this.getLocaleString?.('quiz.steps.plan.in_days') || 'Over %{days} dagen').replace(/%\{days\}/g, effectiveIntroMatchDays);

      const planShipDateEl = this.currentStepElement?.querySelector('[data-wizard-plan-shipment-date]');
      if (planShipDateEl) planShipDateEl.textContent = this.getFullPlanFirstShipmentDateStr();

      await this.ensurePlanOverviewSellingPlanNames();
      this.updateWizardFullPlanDescriptionHtml();

      const aanpassenText = this.getLocaleString?.('quiz.steps.plan_overview.aanpassen') || 'aanpassen';

      const trialFlavors = state.selectedFlavorsTrial || [];
      const fullFlavors = state.selectedFlavorsFull || [];
      /** Quiz locale only (rund/kip/vis) — do not use Shopify variant Flavor metafield (can mismatch EN vs images). */
      const flavorDisplayName = f => {
        const t =
          typeof this.getTranslatedFlavorName === 'function' ? this.getTranslatedFlavorName(f) : '';
        const s = (t && String(t).trim()) || '';
        if (s) return s;
        const fallback = { rund: 'Rund', kip: 'Kip', vis: 'Vis' };
        return fallback[f] || f;
      };

      const buildFlavorLineHtml = (flavors, tab) => {
        const counts = {};
        FlavorDistribution.orderSelectedFlavors(flavors).forEach(f => {
          counts[f] = (counts[f] || 0) + 1;
        });
        const parts = FlavorDistribution.getFlavorDistributionOrder()
          .filter(f => counts[f])
          .map(f => {
          const n = counts[f];
          const instant = FLAVOR_TO_INSTANT[f] || f;
          const name = flavorDisplayName(f);
          return `<span class="wizard-flavor-qty">${n}x </span><a href="#" class="wizard-flavor-link" data-open-flavor-modal="${instant}">${name}</a>`;
        });
        return parts.join(', ') + ' <a href="#" class="wizard-flavor-aanpassen" data-open-wizard-flavor-modal="' + tab + '">(' + aanpassenText + ')</a>';
      };

      const buildFlavorDistributionLineHtml = (dist, tab) => {
        const parts = [];
        FlavorDistribution.forEachFlavorInDistributionOrder(dist, (f, n) => {
            const instant = FLAVOR_TO_INSTANT[f] || f;
            const name = flavorDisplayName(f);
            parts.push(`<span class="wizard-flavor-qty">${n}x </span><a href="#" class="wizard-flavor-link" data-open-flavor-modal="${instant}">${name}</a>`);
          });
        return parts.join(', ') + ' <a href="#" class="wizard-flavor-aanpassen" data-open-wizard-flavor-modal="' + tab + '">(' + aanpassenText + ')</a>';
      };

      const introBagCountForTrial = this.getCappedTrialBagCountForWizard(calcs);
      let trialIntroDist = {};
      if (trialFlavors.length && this.flow.calculationEngine) {
        trialIntroDist = this.flow.calculationEngine.calculateFlavorDistribution(introBagCountForTrial, trialFlavors);
      }

      const trialDistEl = this.currentStepElement?.querySelector('[data-delivery-trial-flavor-distribution]');
      const planBagDist = this.getPlanBulkDistribution(1);
      const fullFlavorInline = this.currentStepElement?.querySelector('[data-full-plan-flavor-inline]');
      const trialFlavorHtml = Object.keys(trialIntroDist).length
        ? buildFlavorDistributionLineHtml(trialIntroDist, 'trial')
        : buildFlavorLineHtml(trialFlavors, 'trial');
      const fullFlavorHtml = Object.keys(planBagDist).length
        ? buildFlavorDistributionLineHtml(planBagDist, 'plan')
        : buildFlavorLineHtml(fullFlavors, 'plan');
      if (trialDistEl) trialDistEl.innerHTML = trialFlavorHtml;
      if (fullFlavorInline) fullFlavorInline.innerHTML = fullFlavorHtml;

      const trialBagsContainer = this.currentStepElement?.querySelector('[data-trial-bags]');
      if (trialBagsContainer) {
        const trialOrdered = FlavorDistribution.getFlavorsWithPositiveQuantity(trialIntroDist);
        trialBagsContainer.innerHTML = '';
        for (const f of trialOrdered) {
          const v = state.variantPricing?.[f];
          let imgUrl = v?.image;
          if (!imgUrl && (config.variantIds || {})[f]) {
            try {
              const variant = await this.flow.shopifyAPI.getVariant(config.variantIds[f]);
              if (variant?.image) {
                imgUrl = variant.image;
                state.variantPricing = state.variantPricing || {};
                state.variantPricing[f] = variant;
              }
            } catch (e) {}
          }
          const img = document.createElement('img');
          img.className = 'wizard-bag-img wizard-bag-stack-img';
          img.alt = flavorDisplayName(f);
          img.setAttribute('role', 'button');
          img.tabIndex = 0;
          img.setAttribute('aria-label', flavorDisplayName(f));
          img.setAttribute('data-open-flavor-modal', FLAVOR_TO_INSTANT[f] || f);
          img.loading = 'lazy';
          if (imgUrl) img.src = imgUrl;
          trialBagsContainer.appendChild(img);
        }
      }

      const planBagsContainer = this.currentStepElement?.querySelector('[data-plan-bags]');
      if (planBagsContainer) {
        // One image per flavor in the real bag mix (same dist as flavor line), not one image per bag
        const ordered = FlavorDistribution.getFlavorsWithPositiveQuantity(planBagDist);
        const planPricing = isHalf ? (state.variantPricingHalf || state.variantPricing) : state.variantPricing;
        planBagsContainer.innerHTML = '';
        for (const f of ordered) {
          const v = planPricing?.[f];
          let imgUrl = v?.image;
          if (!imgUrl && variantIds[f]) {
            try {
              const variant = await this.flow.shopifyAPI.getVariant(variantIds[f]);
              if (variant?.image) {
                imgUrl = variant.image;
                if (isHalf) { state.variantPricingHalf = state.variantPricingHalf || {}; state.variantPricingHalf[f] = variant; }
                else { state.variantPricing = state.variantPricing || {}; state.variantPricing[f] = variant; }
              }
            } catch (e) {}
          }
          const img = document.createElement('img');
          img.className = 'wizard-bag-img wizard-bag-stack-img';
          img.alt = flavorDisplayName(f);
          img.setAttribute('role', 'button');
          img.tabIndex = 0;
          img.setAttribute('aria-label', flavorDisplayName(f));
          img.setAttribute('data-open-flavor-modal', FLAVOR_TO_INSTANT[f] || f);
          img.loading = 'lazy';
          if (imgUrl) img.src = imgUrl;
          planBagsContainer.appendChild(img);
        }
      }

      const profileHeading = this.currentStepElement?.querySelector('[data-profile-name-heading]');
      const profileNameEl = this.currentStepElement?.querySelector('[data-profile-name]');
      if (profileHeading && profileNameEl) {
        const raw = (petData.name || '').trim();
        const fullForA11y = this.capitalizeProfileBowlName(raw);
        if (fullForA11y) {
          profileHeading.setAttribute('aria-label', fullForA11y);
          profileNameEl.textContent = this.formatProfileBowlDisplayName(raw);
        } else {
          profileHeading.removeAttribute('aria-label');
          profileNameEl.textContent = '';
        }
      }

      const suitableFor = this.currentStepElement?.querySelector('[data-profile-suitable-for]');
      if (suitableFor) {
        suitableFor.textContent = this.getWizardProfileSuitableForText(petData);
      }

      const freeFrom = this.currentStepElement?.querySelector('[data-profile-free-from]');
      if (freeFrom) {
        const allergiesRaw = petData.allergies || [];
        const allergies = allergiesRaw.filter(a => {
          const s = String(a ?? '').trim().toLowerCase();
          return s && s !== 'none';
        });
        if (allergies.length === 0) {
          freeFrom.classList.add('wizard-profile-bullet--hidden');
        } else {
          freeFrom.classList.remove('wizard-profile-bullet--hidden');
          const allergy = allergies
            .map(a => this.getAllergenDisplayLabelForLocale(String(a).trim()))
            .filter(Boolean)
            .join(', ')
            .toLowerCase();
          freeFrom.innerHTML = (this.getLocaleString?.('quiz.steps.plan_overview.profile_free_from') || '').replace(/%\{allergy\}/g, allergy);
        }
      }

      const gramsPerDay = this.currentStepElement?.querySelector('[data-profile-grams-per-day]');
      if (gramsPerDay) gramsPerDay.innerHTML = (this.getLocaleString?.('quiz.steps.plan_overview.profile_grams_per_day') || '').replace(/%\{grams\}/g, dailyFoodG).replace(/%\{product_title\}/g, productTitle);

      const planSavedNotice = this.currentStepElement?.querySelector('[data-plan-saved-notice]');
      if (planSavedNotice) {
        const pronoun = this.flow.state.getPronoun?.() || 'haar';
        planSavedNotice.textContent = (this.getLocaleString?.('quiz.steps.plan_overview.plan_saved_notice') || '')
          .replace(/%\{pet_name\}/g, petData.name || '')
          .replace(/%\{pronoun\}/g, pronoun);
      }

      try {
        delete state.wizardTrialPackBasePriceCents;
        const calcEngine = this.flow.calculationEngine;
        if (calcEngine && trialFlavors.length) {
          const td = calcEngine.calculateFlavorDistribution(introBagCountForTrial, trialFlavors);
          const pk = this.buildTrialPackVariantMapKeyFromDistribution(td, isHalf);
          const tid = (config.trialPackVariantMap || {})[pk];
          if (tid && this.flow.shopifyAPI?.getVariant) {
            const v = await this.flow.shopifyAPI.getVariant(tid);
            if (v) {
              state.wizardTrialPackBasePriceCents = this._variantUnitPriceToCents(v);
            }
          }
        }
      } catch (e) {
        /* non-blocking */
      }

      try {
        const bundles = await this.buildWizardPlanBundleTotals();
        this.syncWizardPresentmentCurrencyCode();
        this._w2TrialBundle = bundles.trial;
        this._w2FullBundle = bundles.full;
        const fp = this.buildWizardPricingFingerprint();
        state.wizardOfferBarFingerprint = fp;
        state.wizardOfferBarPct = bundles.trial.pct;
        this._w2TrialBundleFingerprint = fp;
        this.updateWizardPlanOfferStacksAndSummaries(bundles);
        this.updateWizardOfferBarForPlanOverview();
      } catch (e) {
        this._w2TrialBundle = null;
        this._w2FullBundle = null;
        this._w2TrialBundleFingerprint = null;
        this.updateWizardOfferBarForPlanOverview();
      }

      this.updateBulkOptions();
      this.updateRecurringPlanOverviewLine();
      this.updatePlanOverviewSavingsBadges();
      this.updateStickyFooter();
      this.updateRewardsPunchCard();
    }

    /**
     * Plan gifts punchcard between full plan and dog profile (rewards_v1:on only).
     */
    updateRewardsPunchCard() {
      const root = this.currentStepElement?.querySelector('[data-bz-sf-punch]');
      if (!root || !window.BzStorefrontPunch || typeof window.BzStorefrontPunch.render !== 'function') {
        if (root) root.hidden = true;
        return;
      }
      const state = this.flow.state || {};
      const petData = state.petData || {};
      const planFlavors = Array.isArray(state.selectedFlavorsFull) && state.selectedFlavorsFull.length
        ? state.selectedFlavorsFull
        : (state.selectedFlavors || []);
      const locale =
        (document.documentElement?.getAttribute?.('lang') || 'nl').toLowerCase().indexOf('en') === 0
          ? 'en'
          : 'nl';
      const rewardsOn =
        typeof window.bzRewardsExperimentOn === 'function' ? window.bzRewardsExperimentOn() : false;

      window.BzStorefrontPunch.render(root, {
        planFlavors,
        allergies: Array.isArray(petData.allergies) ? petData.allergies : [],
        locale,
        visible: rewardsOn,
        box1Freebies: { scoop: true, guide: true },
      });
    }

    updateBulkOptions() {
      const bulkScope = this.getBulkModalRoot();
      if (!bulkScope) return;
      const state = this.flow.state;
      const calcs = state.calculations || {};
      const matchDays = calcs.matchDays || 54;
      const isHalf = this.isPlanHalfBowl(state);
      const baseInterval = this.getPlanBaseIntervalDays(matchDays, isHalf);

      const formatFreq = (days) => (this.getLocaleString?.('quiz.steps.plan_overview.repeats_every') || '').replace(/%\{days\}/g, days);
      // Same bag ratios as wizard-1 getBulkDistribution (baseBagCount × multiplier), not ceil((matchDays×n)/daysPerBag)
      const dist1 = this.getPlanBulkDistribution(1);
      const dist2 = this.getPlanBulkDistribution(2);
      const dist3 = this.getPlanBulkDistribution(3);
      const qtyStr = (d) => Object.entries(d).map(([f, n]) => `${n}x ${f}`).join(', ');

      const setEl = (sel, text) => {
        const el = bulkScope.querySelector(sel);
        if (el) el.textContent = text;
      };
      const config = this.flow.getConfig?.() || this.flow.config || {};
      const spMap = config.sellingPlanMapping || {};
      const names = this.flow.state.sellingPlanNames || {};
      const titleForMult = mult => {
        const days = baseInterval * mult;
        const sid = spMap[String(days)] || spMap[days];
        if (sid && names[String(sid)]) return names[String(sid)];
        return formatFreq(days);
      };
      setEl('[data-bulk-frequency-1]', titleForMult(1));
      setEl('[data-bulk-frequency-2]', titleForMult(2));
      setEl('[data-bulk-frequency-3]', titleForMult(3));
      setEl('[data-bulk-quantities-1]', qtyStr(dist1));
      setEl('[data-bulk-quantities-2]', qtyStr(dist2));
      setEl('[data-bulk-quantities-3]', qtyStr(dist3));

      const planPricing = isHalf ? (state.variantPricingHalf || state.variantPricing || {}) : (state.variantPricing || {});
      const planCents1 = this.calculateFullPlanAdditiveDiscountTotalCents(dist1, planPricing);
      const planCents2 = this.calculateFullPlanAdditiveDiscountTotalCents(dist2, planPricing);
      const planCents3 = this.calculateFullPlanAdditiveDiscountTotalCents(dist3, planPricing);

      const period = state.selectedPricePeriod || 'day';
      const fmt = c => this.formatWizardMoney(Math.round(Number(c) || 0));

      const d1 = Math.round(this.getPlanBulkDisplayCents(planCents1, baseInterval, period));
      setEl('[data-bulk-price-base-1]', fmt(d1));

      /**
       * Day/week: strikethrough = same discounted per-period rate as 1× (matches card 1).
       * Shipment ("doos"): strikethrough = full compare-at for that shipment (2×/3× bag totals).
       */
      const oneXRateRounded = Math.round(this.getPlanBulkDisplayCents(planCents1, baseInterval, period));
      const cmp2 = this.calculateCompareAtTotalCents(dist2, planPricing);
      const cmp3 = this.calculateCompareAtTotalCents(dist3, planPricing);

      const int2 = baseInterval * 2;
      const int3 = baseInterval * 3;
      const sub2 = bulkScope.querySelector('[data-bulk-price-subscription-2]');
      const fin2 = bulkScope.querySelector('[data-bulk-price-final-2]');
      const strike2 =
        period === 'shipment'
          ? Math.round(this.getPlanBulkDisplayCents(cmp2, int2, period))
          : oneXRateRounded;
      if (sub2) {
        sub2.textContent = fmt(strike2);
        sub2.style.display = '';
      }
      if (fin2) {
        fin2.textContent = fmt(Math.round(this.getPlanBulkDisplayCents(planCents2, int2, period)));
        fin2.style.display = '';
      }

      const sub3 = bulkScope.querySelector('[data-bulk-price-subscription-3]');
      const fin3 = bulkScope.querySelector('[data-bulk-price-final-3]');
      const strike3 =
        period === 'shipment'
          ? Math.round(this.getPlanBulkDisplayCents(cmp3, int3, period))
          : oneXRateRounded;
      if (sub3) {
        sub3.textContent = fmt(strike3);
        sub3.style.display = '';
      }
      if (fin3) {
        fin3.textContent = fmt(Math.round(this.getPlanBulkDisplayCents(planCents3, int3, period)));
        fin3.style.display = '';
      }

      const baseDailyCents = baseInterval > 0 ? planCents1 / baseInterval : 0;
      const daily2xCents = baseInterval > 0 ? planCents2 / int2 : 0;
      const daily3xCents = baseInterval > 0 ? planCents3 / int3 : 0;
      const annual2 = Math.round((baseDailyCents - daily2xCents) * 365);
      const sav2 = bulkScope.querySelector('[data-bulk-annual-savings-2]');
      if (sav2) sav2.textContent = this.getLocaleString?.('quiz.steps.bulk.annual_savings', { amount: fmt(annual2) }) || '';

      const annual3 = Math.round((baseDailyCents - daily3xCents) * 365);
      const sav3 = bulkScope.querySelector('[data-bulk-annual-savings-3]');
      if (sav3) sav3.textContent = this.getLocaleString?.('quiz.steps.bulk.annual_savings', { amount: fmt(annual3) }) || '';

      bulkScope.querySelectorAll('[data-bulk-modal-period-select]').forEach(sel => {
        if (sel.value !== period) sel.value = period;
      });
    }

    syncAllWizardPricePeriodSelects(period) {
      const p = period != null && period !== '' ? period : this.flow.state.selectedPricePeriod || 'day';
      document.querySelectorAll('[data-plan-overview-period-select], [data-bulk-modal-period-select]').forEach(sel => {
        if (sel.value !== p) sel.value = p;
      });
    }

    updateStickyFooter() {
      const trialCompareEl = document.querySelector('[data-sticky-trial-compare]');
      const trialFinalEl = document.querySelector('[data-sticky-trial-final]');
      const fullCompareEl = document.querySelector('[data-sticky-full-compare]');
      const fullFinalEl = document.querySelector('[data-sticky-full-final]');
      const overviewPeriodSelect = document.querySelector('[data-plan-overview-period-select]');
      const bulkPeriodSample = document.querySelector('[data-bulk-modal-period-select]');

      const fmt = c => this.formatWizardMoney(Math.round(Number(c) || 0));
      const isHalf = this.isPlanHalfBowl(this.flow.state);
      const effectiveIntroMatchDays = this.getEffectiveIntroMatchDays(this.flow.state);
      const period =
        this.flow.state.selectedPricePeriod ||
        overviewPeriodSelect?.value ||
        bulkPeriodSample?.value ||
        'day';

      const trialBundle = this._w2TrialBundle;
      const trialComparePack =
        trialBundle?.compareTotal != null
          ? Math.round(Number(trialBundle.compareTotal))
          : this.getTrialCompareAtTotalCents();
      const trialFinalPack =
        trialBundle?.finalTotal != null
          ? Math.round(Number(trialBundle.finalTotal))
          : this.getTrialPriceCents();

      const trialCompareDisp = this.normalizeStickyTrialAmountCents(
        trialComparePack,
        period,
        effectiveIntroMatchDays
      );
      const trialFinalDisp = this.normalizeStickyTrialAmountCents(
        trialFinalPack,
        period,
        effectiveIntroMatchDays
      );

      if (trialCompareEl) {
        trialCompareEl.textContent =
          trialComparePack > 0 ? fmt(Math.round(trialCompareDisp)) : '';
        trialCompareEl.style.textDecoration = trialComparePack > 0 ? 'line-through' : '';
      }
      if (trialFinalEl) {
        trialFinalEl.textContent = trialComparePack > 0 ? fmt(Math.round(trialFinalDisp)) : '';
      }

      const mult = parseInt(String(this.flow.state.selectedPlan || '1'), 10) || 1;
      const calcs = this.flow.state.calculations || {};
      const matchDays = calcs.matchDays || 54;
      const baseInterval = this.getPlanBaseIntervalDays(matchDays, isHalf);
      const multInterval = baseInterval * mult;
      const pricing = isHalf
        ? this.flow.state.variantPricingHalf || this.flow.state.variantPricing || {}
        : this.flow.state.variantPricing || {};
      const distMult = this.getPlanBulkDistribution(mult);
      const fullCompareTotal = this.calculateCompareAtTotalCents(distMult, pricing);
      const fullFinalTotal = this.calculateFullPlanAdditiveDiscountTotalCents(distMult, pricing);

      const fullCompareDisp = Math.round(
        this.getPlanBulkDisplayCents(fullCompareTotal, multInterval, period)
      );
      const fullFinalDisp = Math.round(
        this.getPlanBulkDisplayCents(fullFinalTotal, multInterval, period)
      );

      if (fullCompareEl) {
        fullCompareEl.textContent = fullCompareTotal > 0 ? fmt(fullCompareDisp) : '';
        fullCompareEl.style.textDecoration = fullCompareTotal > 0 ? 'line-through' : '';
      }
      if (fullFinalEl) {
        fullFinalEl.textContent = fullCompareTotal > 0 ? fmt(fullFinalDisp) : '';
      }

      const trialLabelEl = document.querySelector('[data-sticky-trial-label]');
      if (trialLabelEl) {
        trialLabelEl.textContent =
          this.getLocaleString?.('quiz.steps.plan_overview.trial_subtitle_full') || '';
      }

      this.syncAllWizardPricePeriodSelects(period);

      if (this.flow.state.getCurrentStep?.() === 'plan_overview') {
        this.updateRecurringPlanOverviewLine();
        this.updateBulkOptions();
      }
    }

    setupStickyFooterPeriodSelectors() {
      if (!window.__w2PeriodSelectDelegationBound) {
        window.__w2PeriodSelectDelegationBound = true;
        document.addEventListener('change', e => {
          const t = e.target;
          if (!t || !t.matches?.('[data-plan-overview-period-select], [data-bulk-modal-period-select]')) {
            return;
          }
          this.flow.state.selectedPricePeriod = t.value;
          this.syncAllWizardPricePeriodSelects(t.value);
          this.updateStickyFooter();
        });
      }
      const period = this.flow.state.selectedPricePeriod || 'day';
      this.syncAllWizardPricePeriodSelects(period);
    }

    async handleAddToCart() {
      await this._runWizardCartAndCheckout({ mode: 'checkout' });
    }

    /**
     * Add current dog's trial subscription to cart (no freebie), persist metaobject, reset quiz for next dog.
     * Mirrors wizard-1 handleAddAnotherDog.
     */
    async handleAddAnotherDog() {
      await this._runWizardCartAndCheckout({ mode: 'add_dog' });
    }

    /**
     * Normalize pet metaobject id for comparing cart line `_pet_metaobject_id` (GID or numeric).
     * @param {string|number|null|undefined} value
     * @returns {string}
     */
    normalizeWizardPetMetaobjectIdForCart(value) {
      if (value == null || value === '') return '';
      const s = String(value).trim();
      const m = s.match(/Metaobject\/(\d+)\s*$/i);
      if (m) return m[1];
      if (/^\d+$/.test(s)) return s;
      return s;
    }

    wizardLineItemPropertiesAsObject(properties) {
      if (!properties) return {};
      if (Array.isArray(properties)) {
        const o = {};
        properties.forEach(p => {
          if (p && p.name != null) o[String(p.name)] = p.value != null ? String(p.value) : '';
        });
        return o;
      }
      return properties;
    }

    /**
     * True if this cart line is a wizard-4 trial with the same pet as `normalizedPetId` (numeric string).
     */
    wizardLineItemIsTrialForPet(item, normalizedPetId) {
      if (!normalizedPetId || !item) return false;
      const props = this.wizardLineItemPropertiesAsObject(item.properties);
      const planType = props._plan_type != null ? String(props._plan_type).toLowerCase() : '';
      if (planType !== 'trial') return false;
      const linePet = props._pet_metaobject_id != null ? String(props._pet_metaobject_id).trim() : '';
      if (!linePet) return false;
      return this.normalizeWizardPetMetaobjectIdForCart(linePet) === normalizedPetId;
    }

    wizardCheckoutFreebieSellingPlanId(config) {
      return String(config?.freebieSellingPlanId || '').trim();
    }

    /**
     * Digital (Digitaal / yearly) selling plan attaches only to the Transitiegids.
     * Scoop stays a true one-time physical line so checkout Recurring shipments omit it.
     * Prefer freebieVariantId; fall back to first freebieVariantIds entry (guide).
     */
    wizardCheckoutFreebieUsesDigitalPlan(config, variantId) {
      const fromConfig = parseInt(String(config?.freebieVariantId || '').trim(), 10) || 0;
      const fromList = Array.isArray(config?.freebieVariantIds)
        ? parseInt(String(config.freebieVariantIds[0] || '').trim(), 10) || 0
        : 0;
      const guideId = fromConfig || fromList;
      const vid = parseInt(String(variantId || ''), 10) || 0;
      return Boolean(guideId && vid && guideId === vid);
    }

    /**
     * All checkout gift variant IDs (guide, scoop, and any future gifts in freebieVariantIds).
     */
    wizardCheckoutFreebieVariantIds(config) {
      const seen = new Set();
      const out = [];
      const push = (raw) => {
        const id = String(raw || '').trim();
        if (!id || seen.has(id)) return;
        seen.add(id);
        out.push(id);
      };
      if (Array.isArray(config?.freebieVariantIds)) {
        config.freebieVariantIds.forEach(push);
      }
      push(config?.freebieVariantId);
      push(config?.scoopFreebieVariantId);
      return out;
    }

    wizardCartLineSellingPlanId(line) {
      if (!line) return '';
      const fromAlloc = line.selling_plan_allocation?.selling_plan?.id;
      if (fromAlloc != null && String(fromAlloc).trim()) return String(fromAlloc).trim();
      if (line.selling_plan != null && String(line.selling_plan).trim()) {
        return String(line.selling_plan).trim();
      }
      return '';
    }

    /**
     * Line item `key` values for existing trial lines belonging to this pet (for replace-before-add).
     * @param {{ items?: Array<{ key?: string, properties?: * }> }} cartJson
     * @param {string|number|null|undefined} petMetaobjectIdRaw
     * @returns {string[]}
     */
    getWizardCartLineKeysForExistingTrialsOfPet(cartJson, petMetaobjectIdRaw) {
      const normalized = this.normalizeWizardPetMetaobjectIdForCart(petMetaobjectIdRaw);
      if (!normalized) return [];
      const items = cartJson && Array.isArray(cartJson.items) ? cartJson.items : [];
      const keys = [];
      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        if (it && it.key && this.wizardLineItemIsTrialForPet(it, normalized)) {
          keys.push(String(it.key));
        }
      }
      return keys;
    }

    /**
     * Remove cart lines by Shopify line-item key (quantity 0 via /cart/update.js).
     * @param {string[]} lineKeys
     */
    async removeWizardCartLineItemsByKeys(lineKeys) {
      if (!lineKeys || !lineKeys.length) return;
      const updates = {};
      lineKeys.forEach(k => {
        updates[k] = 0;
      });
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) {
        const text = await response.text().catch(() => '');
        let detail = response.statusText || `HTTP ${response.status}`;
        try {
          const errJson = JSON.parse(text);
          if (errJson.description) detail = errJson.description;
          else if (errJson.message) detail = errJson.message;
        } catch (parseErr) {
          if (text && text.length < 500) detail = text;
        }
        const err = new Error(detail);
        err.status = response.status;
        throw err;
      }
      await response.json();
    }

    leaveForCheckout(url) {
      if (typeof this.flow?.rememberCheckoutReturn === 'function') this.flow.rememberCheckoutReturn();
      window.location.href = url;
    }

    /**
     * @param {{ mode: 'checkout' | 'add_dog' }} opts
     */
    async _runWizardCartAndCheckout(opts) {
      const mode = opts?.mode || 'checkout';
      const isCheckout = mode === 'checkout';
      const state = this.flow.state;
      const petData = state.getPetData();
      const config = typeof this.flow.getConfig === 'function' ? this.flow.getConfig() : this.flow.config;

      const button = isCheckout ? document.querySelector('[data-next-button]') : null;
      const extrasStep = window.BzWizard && window.BzWizard.id() === 'w3' && this.flow.state.getCurrentStep?.() === 'extras';
      const skipBtn = extrasStep ? document.querySelector('[data-w3-skip]') : null;
      const spinSkip = !!(extrasStep && opts?.loadingTarget === 'skip');
      const labelEl = button?.querySelector('.next-button-label');
      const defaultNextLabel =
        this.flow.state.getCurrentStep?.() === 'plan_overview'
          ? this.getLocaleString?.('quiz.steps.plan_overview.checkout_trial_button') ||
            (document.documentElement.lang === 'nl' ? 'Transitieplan afrekenen' : 'Checkout transition plan')
          : this.getLocaleString?.('quiz.buttons.next') ||
            this.getLocaleString?.('quiz.steps.bulk.add_to_cart') ||
            'Doorgaan';

      const addDogBtn = !isCheckout ? document.querySelector('[data-wizard-add-another-dog]') : null;
      const nextBtnDuringAddDog = !isCheckout ? document.querySelector('[data-next-button]') : null;

      const resetAddDogUi = () => {
        if (addDogBtn) {
          addDogBtn.disabled = false;
          addDogBtn.classList.remove('is-loading');
          addDogBtn.removeAttribute('aria-busy');
        }
        if (nextBtnDuringAddDog) {
          nextBtnDuringAddDog.disabled = false;
        }
      };

      /* Spinner only: CSS hides label/chevron; do not swap to add_to_cart_loading text */
      if (isCheckout && button) {
        button.disabled = true;
        if (!spinSkip) {
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
        }
      }
      if (skipBtn) {
        skipBtn.disabled = true;
        if (spinSkip) {
          skipBtn.classList.add('is-loading');
          skipBtn.setAttribute('aria-busy', 'true');
        }
      }

      /* Add another dog: spinner on add-dog button only; checkout disabled without spinner */
      if (!isCheckout) {
        if (addDogBtn) {
          addDogBtn.disabled = true;
          addDogBtn.classList.add('is-loading');
          addDogBtn.setAttribute('aria-busy', 'true');
        }
        if (nextBtnDuringAddDog) {
          nextBtnDuringAddDog.disabled = true;
        }
      }

      const resetCheckoutButton = () => {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          if (labelEl) labelEl.textContent = defaultNextLabel;
        }
        const profileBtn = document.querySelector('[data-profile-save-button]');
        if (profileBtn && window.BzWizard && window.BzWizard.id() === 'w3') {
          profileBtn.disabled = false;
          profileBtn.textContent = window.__wizard3Copy?.checkout || profileBtn.textContent;
        }
        if (skipBtn) {
          skipBtn.disabled = false;
          skipBtn.classList.remove('is-loading');
          skipBtn.removeAttribute('aria-busy');
        }
      };

      try {
        const stepNow = this.flow.state.getCurrentStep?.();
        const w3Checkout = window.BzWizard && window.BzWizard.id() === 'w3' && stepNow === 'profile';
        const usePlan = window.WizardPlan && (
          stepNow === 'extras' ||
          w3Checkout ||
          (stepNow === 'flavors' && window.BzWizard && window.BzWizard.id() === 'w5')
        );
        if (usePlan && window.WizardPlan.removeWizardLines) {
          await window.WizardPlan.removeWizardLines();
        }
        const built = usePlan
          ? await window.WizardPlan.buildCheckout(this)
          : this.buildWizardTrialSubscriptionCartItems();
        let {
          cartItems,
          distribution,
          fullPlanBagCount,
          matchDays,
          multiplier,
          calculations,
          selectedFlavorsTrial,
          trialVariantId,
          nextShipmentOffsetDays
        } = built;

        let existingCart = { items: [] };
        try {
          const r = await fetch('/cart.js');
          if (r.ok) existingCart = await r.json();
        } catch (e) {
          /* non-blocking */
        }

        const petIdRaw = state.petMetaobjectId ? String(state.petMetaobjectId) : '';
        const duplicateTrialKeys = petIdRaw
          ? this.getWizardCartLineKeysForExistingTrialsOfPet(existingCart, petIdRaw)
          : [];
        if (duplicateTrialKeys.length) {
          await this.removeWizardCartLineItemsByKeys(duplicateTrialKeys);
          try {
            const r2 = await fetch('/cart.js');
            if (r2.ok) existingCart = await r2.json();
          } catch (e) {
            /* non-blocking */
          }
        }

        const pendingFreebiePlanUpdates = [];
        if (isCheckout && !usePlan) {
          const pid = state.petMetaobjectId ? String(state.petMetaobjectId) : '';
          const guideVariantId = String(config.freebieVariantId || '').trim();
          const freebiePlanId = this.wizardCheckoutFreebieSellingPlanId(config);
          const checkoutFreebies = this.wizardCheckoutFreebieVariantIds(config).map(id => ({
            variantId: parseInt(id, 10) || 0,
            properties: pid && String(id) === guideVariantId ? { _pet_metaobject_id: pid } : {}
          }));
          for (const freebie of checkoutFreebies) {
            if (!freebie.variantId) continue;
            const existingLine = (existingCart.items || []).find(
              it => parseInt(String(it.variant_id), 10) === freebie.variantId
            );
            const attachDigitalPlan =
              this.wizardCheckoutFreebieUsesDigitalPlan(config, freebie.variantId) && freebiePlanId;
            if (!existingLine) {
              cartItems = cartItems.concat([
                {
                  variantId: freebie.variantId,
                  quantity: 1,
                  properties: freebie.properties,
                  sellingPlanId: attachDigitalPlan ? freebiePlanId : undefined
                }
              ]);
              continue;
            }
            const existingPlan = this.wizardCartLineSellingPlanId(existingLine);
            if (attachDigitalPlan) {
              if (existingPlan === freebiePlanId) continue;
              const mergedProperties = Object.assign(
                {},
                existingLine.properties || {},
                freebie.properties || {}
              );
              pendingFreebiePlanUpdates.push({
                key: existingLine.key,
                quantity: existingLine.quantity || 1,
                sellingPlanId: freebiePlanId,
                properties: mergedProperties
              });
              continue;
            }
            if (!existingPlan) continue;
            pendingFreebiePlanUpdates.push({
              key: existingLine.key,
              quantity: existingLine.quantity || 1,
              clearSellingPlan: true
            });
          }
        }

        if (cartItems.length) {
          await this.flow.shopifyAPI.addToCart(cartItems);
        }
        if (pendingFreebiePlanUpdates.length) {
          if (typeof this.flow.shopifyAPI.changeCartLine !== 'function') {
            throw new Error('Cart line update is unavailable');
          }
          for (const update of pendingFreebiePlanUpdates) {
            await this.flow.shopifyAPI.changeCartLine(update);
          }
        }
        /* Checkout: skip Instant + cart icon refresh so we leave the page sooner; add_dog keeps UI in sync */
        if (!isCheckout) {
          window.Instant?.api?.updateCart?.();
          window.__wizardRefreshCartIcon?.();
        }

        const cartItemsForMetaobject = cartItems.map(item => ({
          variantId: item.variantId,
          quantity: item.quantity,
          sellingPlanId: item.sellingPlanId,
          properties: item.properties || {}
        }));

        const cartJsonPromise = fetch('/cart.js')
          .then(r => (r.ok ? r.json() : null))
          .catch(() => null);

        const metaPromise =
          state.petMetaobjectId && this.flow.shopifyAPI?.backendApiUrl
            ? this.flow.shopifyAPI
                .createOrUpdatePetMetaobject({
                  petData: this.getPetDataForMetaobject(state),
                  calculations: this.getWizardCalculationsForPersistence(state),
                  petMetaobjectId: state.petMetaobjectId,
                  cartItems: cartItemsForMetaobject,
                  selectedFlavors: state.selectedFlavorsFull?.length ? state.selectedFlavorsFull : selectedFlavorsTrial,
                  selectedFlavorsTrial
                })
                .catch(e => {
                  console.warn('Failed to persist cart to metaobject (non-blocking):', e.message);
                })
            : Promise.resolve();

        const [cartJsonAfterAdd] = await Promise.all([cartJsonPromise, metaPromise]);

        if (isCheckout) {
          try {
            await this.applyWizardCartDiscountCodes();
          } catch (error) {
            console.warn('Failed to apply discount codes (non-blocking):', error);
          }

          try {
            if (cartJsonAfterAdd && cartJsonAfterAdd.items && Array.isArray(cartJsonAfterAdd.items)) {
              const petNamesSet = new Set();
              cartJsonAfterAdd.items.forEach(item => {
                const petName = this.getPetNameFromLineItemProperties(item.properties);
                if (petName) petNamesSet.add(petName);
              });
              const formattedNote = this.formatCartNote(petData.ownerName, Array.from(petNamesSet));
              if (formattedNote) {
                await this.flow.shopifyAPI.updateCartNote(formattedNote);
              }
            }
          } catch (error) {
            console.warn('Failed to update cart note (non-blocking):', error);
          }

          if (this.flow.klaviyoManager && petData.ownerEmail) {
            try {
              const trialPackTitle =
                this.getLocaleString?.('quiz.steps.plan_overview.trial_subtitle_full') || 'Transition plan';
              const cartItemsForKlaviyo = [
                {
                  variant_title: trialPackTitle,
                  quantity: 1,
                  properties: {
                    ...this.buildPetLineItemProperties(petData.name, '')
                  }
                }
              ];
              this.flow.klaviyoManager.addCartItemsToEvent(cartItemsForKlaviyo, petData.ownerEmail);
            } catch (e) {
              console.warn('Failed to add cart items to Klaviyo event (non-blocking):', e);
            }
          }

          const trialTotalCents = this.getTrialPriceCents();
          const cartValue = trialTotalCents / 100;
          const currency = this.getWizardPresentmentCurrencyCode();
          const contentIds = cartItems
            .filter(i => i.sellingPlanId)
            .map(item => item.variantId);
          const contents = cartItems
            .filter(i => i.sellingPlanId)
            .map(item => ({
              id: item.variantId,
              quantity: item.quantity
            }));

          const analyticsPayload = {
            pet_name: petData.name,
            match_days: matchDays,
            bag_count: fullPlanBagCount,
            intro_match_days: nextShipmentOffsetDays,
            intro_bag_count: calculations.introBagCount,
            flavors: selectedFlavorsTrial,
            multiplier,
            flow: built.flow || 'wizard-4',
            trial: true,
            trial_variant_id: trialVariantId
          };

          if (this.flow.analytics) {
            try {
              if (typeof this.flow.analytics.trackCompletion === 'function') {
                this.flow.analytics.trackCompletion(analyticsPayload);
              }
              if (typeof this.flow.analytics.trackFacebookAddToCart === 'function') {
                this.flow.analytics.trackFacebookAddToCart({
                  content_ids: contentIds,
                  contents,
                  value: cartValue,
                  currency
                });
              }
              if (typeof this.flow.analytics.trackAddToCart === 'function') {
                this.flow.analytics.trackAddToCart(
                  Object.assign({}, analyticsPayload, {
                    content_ids: contentIds,
                    value: cartValue,
                    currency
                  })
                );
              }
            } catch (e) {
              console.warn('Wizard-2 analytics add-to-cart tracking failed:', e);
            }
          }

          if (this.flow.klaviyoManager && petData.ownerEmail) {
            try {
              if (this.flow.klaviyoManager.hasPendingEvent(petData.ownerEmail)) {
                this.flow.klaviyoManager.cancelPendingEvent();
                void this.flow.klaviyoManager.sendKlaviyoEvent(petData.ownerEmail).catch(err => {
                  console.warn('Failed to send Klaviyo event before checkout (non-blocking):', err);
                });
              }
            } catch (e) {
              console.warn('Failed to send Klaviyo event before checkout (non-blocking):', e);
            }
          }

          if (typeof window.bzStampVwoExperiments === 'function') {
            try {
              await window.bzStampVwoExperiments();
            } catch (e) {}
          }

          const rawCheckoutUrl =
            this.buildCheckoutUrlWithPrefill?.(petData.ownerEmail, petData.ownerName) || '/checkout';
          const checkoutUrl = window.bzCheckoutPrefill?.addCountryToUrl?.(rawCheckoutUrl) || rawCheckoutUrl;
          const locale = window.__wizardCurrentLocale || 'nl';
          const isDutch = locale === 'nl' || (locale && locale.startsWith('nl-'));

          if (isDutch) {
            if (
              typeof window.firmhouse !== 'undefined' &&
              typeof window.firmhouse.getCart === 'function' &&
              typeof window.firmhouse.generateSEPACheckoutUrl === 'function'
            ) {
              try {
                const cart = await window.firmhouse.getCart();
                const [checkoutUrlMain, checkoutUrlParams] = checkoutUrl.split('?');
                const newParams = checkoutUrlParams ? `skip_shop_pay=true&${checkoutUrlParams}` : 'skip_shop_pay=true';
                const checkoutUrlWithSkipShopPay = `${checkoutUrlMain}?${newParams}`
                const sepaUrl = window.firmhouse.generateSEPACheckoutUrl(cart.items);
                const returnToPattern = /%26return_to=[^&]*/;
                const checkoutUrlWithSepaPlans = returnToPattern.test(sepaUrl)
                  ? sepaUrl.replace(returnToPattern, `%26return_to=${encodeURIComponent(encodeURIComponent(checkoutUrlWithSkipShopPay))}`)
                  : sepaUrl;
                this.leaveForCheckout(checkoutUrlWithSepaPlans);
              } catch (e) {
                console.error('Firmhouse SEPA checkout failed:', e);
                resetCheckoutButton();
              }
            } else {
              console.error('Firmhouse SEPA not available for Dutch locale');
              resetCheckoutButton();
            }
          } else {
            this.leaveForCheckout(checkoutUrl);
          }
        } else {
          /* add_dog — metaobject already saved above */
          const preservedSessionCustomerId = state.sessionCustomerId || state.customerId;
          state.reset();
          if (preservedSessionCustomerId) {
            state.sessionCustomerId = preservedSessionCustomerId;
          }
          this.flow.router.navigate('name', {});
        }
      } catch (e) {
        console.error(isCheckout ? 'Add to cart failed:' : 'Error adding another dog:', e);
        resetCheckoutButton();
        if (!isCheckout) {
          resetAddDogUi();
        }
        if (isCheckout) {
          try {
            window.Instant?.api?.updateCart?.();
            window.__wizardRefreshCartIcon?.();
          } catch (refreshErr) {
            /* non-blocking */
          }
        }
        const is429 =
          e.status === 429 ||
          (e.message && (e.message.includes('429') || e.message.includes('Too Many Requests')));
        if (!is429) {
          const key = 'quiz.steps.bulk.add_to_cart_error';
          let msg =
            typeof this.getLocaleString === 'function' ? this.getLocaleString(key) : '';
          if (!msg || msg === key) {
            msg =
              (document.documentElement.lang || '').toLowerCase().startsWith('nl')
                ? 'Er ging iets mis bij het toevoegen aan je winkelwagen. Probeer het opnieuw.'
                : 'Something went wrong adding to your cart. Please try again.';
          }
          console.error('Wizard-2 cart/checkout error detail:', e.message || e);
          if (window.bzToast) window.bzToast.showKey('cart_checkout_error');
          else alert(msg);
        }
        if (!isCheckout) {
          try {
            this.flow.router.navigate('name', {});
          } catch (navErr) {
            console.error(navErr);
          }
        }
      }
    }

    loadPetDataFromMetaobject(metaobject, updateCurrentStep = true) {
      const fields = metaobject.fields || [];
      const petData = {};
      const calculations = {};

      fields.forEach(field => {
        const k = field.key;
        const v = field.value;
        if (k === 'pet_name') petData.name = v;
        else if (k === 'gender') petData.gender = v;
        else if (k === 'breed') petData.breed = v;
        else if (k === 'weight') {
          try {
            const o = typeof v === 'string' ? JSON.parse(v) : v;
            petData.weight = o?.value ? parseFloat(o.value) : parseFloat(v);
          } catch (e) { petData.weight = parseFloat(v); }
        }
        else if (k === 'composition') petData.composition = v;
        else if (k === 'age_group') petData.ageGroup = v;
        else if (k === 'spayed') petData.spayed = v === 'true' || v === true;
        else if (k === 'activity') petData.activity = v;
        else if (k === 'allergies') {
          const raw = typeof v === 'string' ? (v ? v.split(',') : []) : (v || []);
          const parts = (Array.isArray(raw) ? raw : [])
            .map(x => String(x).trim())
            .filter(Boolean);
          petData.allergies = this.normalizePetAllergies(parts);
        }
        else if (k === 'snacks') petData.snacks = v;
        else if (k === 'owner_name') petData.ownerName = v;
        else if (k === 'owner_email') petData.ownerEmail = v;
        else if (k === 'email_consent') petData.emailConsent = v !== 'false';
        else if (k === 'daily_kcal') calculations.dailyKcal = parseFloat(v);
        else if (k === 'daily_food_g') calculations.dailyFoodG = parseFloat(v);
        else if (k === 'days_per_bag') calculations.daysPerBag = parseFloat(v);
        else if (k === 'bag_count') calculations.bagCount = parseFloat(v);
        else if (k === 'match_days') calculations.matchDays = parseFloat(v);
      });

      if (metaobject.id) this.flow.state.petMetaobjectId = metaobject.id;

      const customerField = fields.find((f) => f.key === 'customer');
      if (customerField?.value) {
        this.flow.state.customerId = customerField.value;
        this.flow.state.sessionCustomerId = customerField.value;
      }

      if (Object.keys(petData).length) this.flow.state.petData = { ...this.flow.state.petData, ...petData };
      if (typeof this.flow.state.petData.name === 'string' && typeof window.normalizePetNameEdges === 'function') {
        this.flow.state.petData.name = window.normalizePetNameEdges(this.flow.state.petData.name);
      }
      if (Object.keys(calculations).length) this.flow.state.calculations = { ...this.flow.state.calculations, ...calculations };

      const resumeStep = metaobject.resumeStep || metaobject.fields?.find(f => f.key === 'resume_step')?.value;
      if (resumeStep && updateCurrentStep) {
        const step = resumeStep === 'plan_overview' || ['flavors', 'plan', 'bulk'].includes(resumeStep) ? 'plan_overview' : resumeStep;
        this.flow.state.setCurrentStep(step);
      }

      const selectedFlavors = metaobject.selectedFlavors || metaobject.fields?.find(f => f.key === 'selected_flavors')?.value;
      if (selectedFlavors) {
        const arr = typeof selectedFlavors === 'string' ? selectedFlavors.split(',') : selectedFlavors;
        this.flow.state.selectedFlavorsTrial = [...arr];
        this.flow.state.selectedFlavorsFull = [...arr];
      }
    }
  }

  window.StepHandlerWizard = StepHandlerWizard;

  window.addEventListener('bz:experiments', function () {
    const handler = window.wizardFlow?.stepHandler;
    if (handler && typeof handler.updateRewardsPunchCard === 'function') {
      handler.updateRewardsPunchCard();
    }
  });
})();
